export default {
  hkMarket: {
    deskSubtitle: '直銷可售目錄＋一鍵上手＋模擬付成功 · stub≠真聚合／PayPal／Meta',
    sellableCatalogTitle: '直銷可售收款目錄（§1-11）',
    sellableCatalogHint: 'Apple／Google 掛本地聚合；PayPal 備援；加密入目錄（真收待合規）。可選 BYO／Referral。',
    colTitle: '名稱',
    colTrack: '商業軌',
    colEnabled: '啟用',
    colMerchant: '商戶佔位',
    colNote: '說明'
  },
  produceOutputCatalog: {
    pageTitle: '出品掛鉤',
    pageDesc: '以機型為主：一台設備掛哪些出品；再維護出品分類與場景組合，供 Leo 自動生產選機。',
    tabCategories: '出品分類',
    tabBinds: '機型掛出品',
    tabKits: '場景組合',
    categoryKey: '分類鍵',
    name: '名稱',
    bucket: '大類',
    pickBucket: '請選擇出品大類',
    bucketFreshDrink: '現製飲',
    bucketDessert: '甜品',
    bucketVending: '無人零售',
    bucketLightMeal: '輕食',
    bucketHotKitchen: '熱廚',
    bucketBakery: '烘焙',
    status: '狀態',
    sortNo: '排序',
    modelKey: '型號編碼',
    deviceFamily: '設備族',
    pickModel: '請選擇機型',
    pickDeviceFamily: '請選擇設備族',
    bindRole: '掛接角色',
    boundOutputs: '掛接出品',
    secondaryOutputs: '其中副掛',
    secondaryHint: '勾在副掛的出品，對該機型算次要能力。',
    kitKey: '組合鍵',
    members: '成員設備',
    coverCategories: '覆蓋出品',
    optional: '可選',
    startPipeline: '開始標準流水線',
    guideStarted: '已開啟出品掛鉤引導',
    guideStartFail: '開啟引導失敗'
  },
  trainingWorkBoard: {
    title: '訓工作表',
    desc: '德國日訓總賬：按機型／內容篩選，一眼看清健康、卡住、口語燃料與訓練回報。',
    toDesk: '決策台',
    refresh: '刷新',
    searchPh: '搜尋標題／內容／型號',
    deviceFamily: '機型族',
    contentCategory: '內容類',
    status: '報告狀態',
    workState: '工作態',
    stuckOnly: '只看卡住',
    fuelStallOnly: '只看空轉綠',
    total: '全部',
    stuck: '卡住',
    healthy: '健康',
    recent: '近窗',
    fuelStall: '空轉綠',
    fuelActive: '有燃料',
    roiTitle: '訓練回報',
    roiAvg: '均分',
    roiImprove: '須改進',
    roiWaste: '浪費候選',
    roiPlateau: '平台期／低回報',
    roiNext: '下一刀',
    fuelTitle: '口語燃料',
    colTitle: '訓練項',
    colContent: '內容',
    colFamily: '機型族',
    colCategory: '內容類',
    colFreq: '頻率',
    colWorkState: '工作態',
    colFuel: '燃料',
    colFuelPending: '待審',
    colFuelT6: 'T6併入',
    colFuelPromoted: '晉升',
    colRoi: '回報檔',
    colRoiScore: '分',
    colRoiReason: '回報建議',
    colStatus: '報告',
    colAge: '齡(h)',
    colReportAt: '報告時間',
    colModels: '型號鍵',
    colActions: '操作',
    nodeOpen: '打開總表',
    nodeFilter: '篩卡住',
    nodeDesk: '決策台處置',
    nodeDone: '完成',
    nodeTodo: '未開始',
    ws: { HEALTHY: '健康', STUCK: '卡住', RECENT: '近窗剛跑' },
    fuel: { FUEL_ACTIVE: '有燃料', FUEL_STALL: '空轉', FUEL_OK: '待命', N_A: '—' },
    family: {
      tea_machine: '茶機',
      coffee_machine: '咖啡機',
      cross_cutting: '跨族',
      factory: '工廠'
    },
    category: {
      device_gate: '設備 Gate',
      routing_nl: '路由 NL',
      portal_nl: '門戶 NL',
      hm_engine: 'HM 引擎',
      commerce_nl: '商城 NL',
      store_ops: '店務',
      intelligence: '智力',
      healer: 'Healer',
      factory: '工廠',
      other: '其他'
    }
  },
  aiSpendAudit: {
    title: '燒錢審計',
    desc: '所有 AI Token／美金燒錢集中審計：德國訓練、雲修單、邊緣商家與可擴展科目。',
    reconcileOr: '對帳 OpenRouter',
    importOr: '匯入 OR 活動',
    refresh: '刷新',
    kpiMeasured: '實測 USD',
    kpiEstimate: '估算 USD',
    kpiCombined: '合計可見',
    kpiTokens: '實測 Token',
    kpiTrainStatus: '訓練成本態',
    kpiHealer: 'Healer',
    group: '費用分組',
    deviceFamily: '設備族',
    applyFilter: '篩選',
    colCategory: '科目',
    colGroup: '分組',
    colMetering: '計量',
    colUsd: '本月 USD',
    colTokens: 'Token',
    colBudget: '預算',
    colStatus: '狀態',
    colHint: '說明',
    detail: '明細',
    budgetPanel: '預算閘（寫回）',
    healerMode: 'Healer 模式',
    rounds: '月輪次',
    trainBudget: '訓練月預算 USD',
    saveHealer: '保存 Healer',
    saveTrainBudget: '保存訓練預算',
    nodeOpen: '打開燒錢審計',
    nodeCap: '確認月帽',
    nodeDone: '已就緒',
    nodeTodo: '待辦',
    loadFail: '載入燒錢審計失敗',
    reconcileOk: '對帳完成',
    importOk: '匯入完成',
    saveOk: '已保存',
    stepOverview: '總覽',
    stepCategories: '科目',
    stepDetail: '明細',
    stepBudget: '月帽',
    stepOps: '對帳',
    stepOverviewTitle: '本月 AI 燒錢總覽',
    stepOverviewLead: '先看合計與狀態，再一步步點進科目與月帽——像大公司帳單嚮導一樣，一步一事。',
    stepCategoriesTitle: '按分類查看科目',
    stepCategoriesLead: '點選一張科目卡進入明細；可先按分組篩選。',
    stepDetailTitle: '科目明細',
    stepDetailLead: '本步只看當前科目的金額、計量與說明，不再堆整頁 JSON。',
    stepBudgetTitle: '設定月帽與預算',
    stepBudgetLead: '雲修單月美金／輪次，以及訓練月預算，寫回後立即生效。',
    stepOpsTitle: '對帳與匯入',
    stepOpsLead: '需要時對帳 OpenRouter 或匯入活動；做完即可離開本頁。',
    groupAll: '全部分組',
    emptyCategories: '暫無科目，請刷新或檢查德國賬本。',
    pickCategoryFirst: '請先在上一步選一個科目',
    moreFields: '更多欄位',
    healerBlock: 'Cursor 雲修單',
    trainBlock: '德國訓練預算',
    usdCap: '月美金上限',
    reconcileHint: '把 OpenRouter 帳單與訓練賬本對齊。',
    importHint: '從 OpenRouter 活動匯入本月用量。',
    doneBanner: '審計流程已走完；可隨時回到總覽再看。',
    prev: '上一步',
    next: '下一步',
    finish: '完成',
    finishOk: '燒錢審計嚮導已完成',
    chartsTitle: '圖表分析',
    chartsLead: '按日／月／年／星期／時段看趨勢；科目對比、分組占比、預算占用一目了然。',
    granDay: '按日',
    granMonth: '按月',
    granYear: '按年',
    granWeekday: '按星期',
    granHour: '按時段',
    chartTrend: '費用趨勢對比',
    chartCategory: '科目金額對比',
    chartGroup: '分組占比',
    chartBudget: '預算 vs 已用',
    chartTrainSplit: '訓練內部分拆（T9 / OpenRouter）',
    chartModels: 'OpenRouter 模型排行',
    chartEmpty: '暫無圖表資料（賬本為空時只顯示科目卡）',
    seriesTraining: '德國訓練',
    seriesHealer: '雲修單',
    seriesEcs: '德國 ECS（估）',
    seriesCombined: '合計',
    seriesBudget: '預算',
    seriesSpent: '已用',
  },
  leoChat: {
    chat_1475da: "企業登入",
    chat_16f606: "整數；單位依設備／約定",
    chat_17dfdc: "我的偏好",
    chat_22f4eb: "用量與計費",
    chat_27e8b6: "標籤（來自記憶偏好）",
    chat_29f404: "調理機配方",
    chat_30_can_4ab820: "近 30 日 CAN 解碼幀",
    chat_30_can_8fe750: "近 30 日 CAN 計量合計",
    chat_30_e47539: "近 30 日已入帳扣款",
    chat_30_token_16fa23: "近 30 日 AI 點數",
    chat_33613d: "對話",
    chat_40d6e4: "以訪客身分繼續（產品與公開諮詢）",
    chat_43631f: "停止聆聽",
    chat_4845c6: "處理中…",
    chat_553891: "填入並對齊設備",
    chat_5cd727: "返回對話",
    chat_62e9d1: "選擇模式",
    chat_6888c5: "儲存",
    chat_6adada: "控制台",
    chat_6d1197: "隱私政策、服務條款與免責聲明",
    chat_7106a7: "機台商品",
    chat_71c576: "請輸入密碼",
    chat_755be2: "出品建檔",
    chat_7847b8: "送出",
    chat_7e76c4: "尚未建立計費帳戶；儲存後將以所選模式開始計量。",
    chat_805f8b: "使用此內容",
    chat_85406a: "跳過朗讀",
    chat_965a50: "店鋪管理員",
    chat_9b2c38: "輸入訊息",
    chat_9cbbd1: "最近一次辨識",
    chat_a84cf9: "留空＝全域偏好；指定則為該機專屬",
    chat_ab185d: "填入輸入框",
    chat_abd535: "註冊會員",
    chat_api_a76f41: "（訂閱方案請由營運或 API 建立）",
    chat_app_c884f6: "若其他 App 已複製連結或機碼，直接貼上即可。",
    chat_b347b6: "目前計費設定",
    chat_b6d41c: "複製指令",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例如 curve_soft",
    chat_d2de5e: "註冊完成，請以會員身份重新登入後繼續。",
    chat_d5e285: "我已閱讀並同意",
    chat_d5edfc: "複製全文",
    chat_da4d71: "會員登入",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "後台完整登入頁",
    chat_e6a549: "關閉",
    chat_ea544c: "請輸入帳號",
    chat_ef5cb: "重新載入",
    chat_email_leo_fda298: "Email + 密碼；登入後回到 Leo 對話並依步驟完成開通。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "儲存設定",
    chat_fe497b: "請以會員帳號登入；店鋪管理員請用「企業後台」分頁。登入後依提示完成家用或商用設定。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "需相機權限；建議 HTTPS 或 localhost。對準設備或產品上的 QR／條碼。",
    chat_leo_323396: "Leo 用量與計費",
    chat_leo_99743: "Leo 導覽",
    chat_leo_ac1503: "會員登入並進入 Leo",
    chat_leo_e3ca11: "Leo 開通步驟",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "企業登入並進入 Leo",
    chat_loaderror_108d9d: "載入錯誤",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例如 night_owl",
    chat_png_d92bec: "下載 PNG",
    chat_qr_25f92d: "掃描與產品 QR",
    chat_qr_40dfbd: "產生 QR",
    chat_qr_a9ae66: "選取相簿截圖或照片，離線辨識 QR／條碼。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "將門市配方關鍵字、網址或 SKU 轉成 QR，可下載 PNG 列印貼標。",
    chat_token_7959d6: "累計 AI 點數（全期間）",
    chat_token_can_dbc_28957f: "查看 Token 與車載 CAN／DBC 用量、錢包／帳本扣款紀錄（請以會員登入，或後台帳號已完成商用綁定）。",
    chat_user_ace2e8: "後台 User 帳號；具備菜單權限者可操作設備與數據中心。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "要為此語言啟用 Leo NL 嗎？",
      later: "稍後",
      no: "否",
      subProgress: "生成中…",
      subPrompt: "使用 AI 理解 %1$s 語音指令",
      titleProgress: "正在準備 Leo NL 語言理解…",
      titlePrompt: "要為此語言啟用 Leo NL 嗎？",
      titleReady: "Leo NL 語言包已就緒",
      yes: "是",
  },

  dineTable: {
    title: '桌碼點單',
    desc: '一桌一碼。沒裝 Leo 也能在網頁點一單，同時推下載。同一頁可嵌進 Facebook 等社群。',
    brand: '品牌商',
    retailer: '零售商',
    store: '門店',
    payMode: '付款時機',
    payFirst: '先付再出餐',
    payLater: '先點後付',
    saveMode: '保存',
    tableNo: '桌號',
    create: '建桌',
    refresh: '刷新',
    colNo: '桌號',
    colUrl: '桌貼網址',
    qr: '桌貼',
    stickerPreview: '桌貼預覽',
    downloadJpg: '下載 JPG',
    downloadAllJpg: '全店桌貼打包',
    downloadOk: '已下載桌貼 JPG',
    downloadAllOk: '已下載全店桌貼 ZIP',
    downloadFail: '桌貼下載失敗',
    scanHint: '掃碼點單',
    poweredBy: 'Leo · 桌碼點單',
    empty: '還沒有桌',
    webLink: '社群點單連結',
    webHint: '可嵌進 Facebook 或其他社群，客人用網頁點單',
    close: '清台',
    ordersTitle: '桌碼訂單／收款',
    orderCount: '單數',
    paidCount: '已收',
    unpaidCount: '未收',
    amount: '金額',
    paid: '付款',
    paidYes: '已付',
    paidNo: '未付',
    pickup: '取餐號',
    createdAt: '時間',
    ordersEmpty: '這家店還沒有桌碼單',
    ordersLoadFail: '桌碼訂單載入失敗，請刷新或重新登入',
  },

  brandStorePayment: {
    title: '品牌付款',
    desc: '選地區 → 只選一家付款 → 填商戶號 → 試付通過 → 標 LIVE。錢進店自己的商戶戶。',
    hintOneVendor: '每家店只能綁一家；換供應商須重新試付。',
    store: '門店',
    storePh: '選擇門店',
    region: '地區',
    vendor: '付款方式',
    track: '開戶方式',
    trackByo: '已有商戶戶（自填號）',
    trackReferral: '經我們介紹開戶',
    merchantRef: '商戶號',
    merchantRefPh: '公開 MID／Account；勿填 Secret',
    currency: '幣種',
    secretWarn: '禁止填寫 API Secret／私鑰；只填公開商戶號。',
    save: '保存綁定',
    trial: '標記試付通過',
    live: '標 LIVE',
    status: '狀態',
    needStore: '請先選門店',
    needMid: '請填商戶號',
    saveOk: '已綁定',
    trialOk: '已標記試付通過',
    liveOk: '已標 LIVE'
  },

  hkPspOpenAccount: {
    title: '開戶管理',
    desc: '港區 Referral 開戶案：AI 審件、送供應商、收信跟進；營運只讀與例外處置。',
    hint: '僅 Referral 案；BYO 綁號不進此佇列。',
    refresh: '重新整理',
    status: '狀態',
    vendor: '供應商',
    caseId: '案號',
    store: '門店',
    mid: '商戶號',
    sla: 'SLA',
    updated: '更新時間',
    note: '說明',
    runAi: '重跑 AI',
    forceReject: '強制駁回',
    markHandled: '標記已人工處理',
    ok: '已處理'
  },

  brandOpenPack: {
    title: '自動開店',
    desc: '一關一關過。系統能認的直接做。唯一選擇是現在買不買機器。',
    goPay: '去收款',
    level: '第 {n} 關 / {total}',
    photoTitle: '拍一張證件',
    photoHint: '營業執照或商業登記拍一張。系統自己填，你不用打字。',
    photoNext: '拍好了，下一關',
    machineTitle: '現在要買機器嗎',
    machineHint: '不買也可以先開店。以後再買。',
    buyNow: '現在買，教我做產品',
    buyLater: '以後再買',
    productTitle: '產品圖和描述',
    productHint: '隨便講幾句、丟幾張圖，或什麼都不填。AI 幫你補齊，你再核對確認。',
    productHintPh: '例如：冰美式，偏苦一點',
    productAi: 'AI 補齊',
    productSkip: '先跳過用模板',
    productConfirm: '確認這些產品',
    productName: '產品名',
    productDesc: '描述',
    productPrice: '價格',
    productNeedAi: '請先點 AI 補齊，或跳過。',
    productSkipped: '已用模板招牌，可繼續。',
    menuTitle: '菜單和收款已經好了',
    menuHint: '不買機器就到這裡。下一關去收款。',
    teachTitle: '做出第一杯',
    teachHint: '機器綁上之後，按畫面做出第一杯。',
    next: '這一關完成',
    back: '退回上一關',
    stay: '這一關還沒過，先留在這裡。',
    doneTitle: '店開好了',
    doneMenu: '可以收款、賣菜單上的東西。',
    doneMachine: '下一關去學做出品。',
    colStep: '步驟',
    colDetail: '這一區要做的'
  },

  productShelf: {
    title: '產品上架',
    desc: '手填名稱、售價；介紹和產品圖可手填或交給 AI 真生成。自動出品須打開後台真頁走完八步，不能假寫配方。',
    storePh: '門店編號',
    load: '載入',
    manual: '普通品',
    auto: '自動出品',
    name: '產品名',
    price: '售價',
    description: '產品介紹',
    imageUrl: '產品圖網址',
    kind: '種類',
    state: '狀態',
    save: '存產品資料',
    ai: '交給 AI 補',
    publish: '確認上架',
    listed: '已上架',
    ready: '可交給 AI',
    waiting: '基礎未齊',
    needStore: '請填門店編號',
    noEquipment: '店裡還沒有自動設備，配方和掃碼先不能用',
    materialPh: '這一款用的物料名',
    saveMaterial: '記下這步物料',
    confirmStep: '做好這一步',
    now: '現在做',
    coachNow: '現在請做 · 第 {n} 步',
    coachHint: '打開後台真頁做完這一步，回來刷新。禁止跳步、禁止手機假寫配方。',
    finishCurrent: '請先完成當前步驟',
    needProduct: '請先保存這一款的名稱和售價',
    openSoc: '打開後台這一步',
    refreshStep: '我做完了，刷新',
    fail: '沒做成，請再試'
  },

  produceGuide: {
    title: '自動設備',
    desc: '先選想自動做茶、咖啡或飲料。我們只推薦商店裡的一台，用一句話說明它怎麼做。有價錢就現在買，沒有就先留需求。',
    storePh: '門店編號',
    tea: '茶',
    coffee: '咖啡',
    drink: '飲料',
    look: '看推薦',
    combo: '也可以一整套：',
    demo: '看它怎麼做',
    receiver: '收貨人',
    phone: '電話',
    address: '地址',
    buy: '現在買',
    demand: '先留需求',
    empty: '商店裡還沒有對上的機器',
    done: '已記下',
    fail: '沒做成，請再試'
  },

  brandAppListing: {
    title: '品牌上架',
    desc: '傻瓜一鍵：AI 幫你出名稱／圖標／商店文案，確認後一鍵打包上架草稿（XRROSS 代管帳）。',
    hint: '客戶不用管打包與商店後台；付款須 LIVE 才可對外收款。',
    store: '門店',
    storePh: '選擇門店',
    displayName: 'App 名稱',
    storeTitle: '商店標題',
    shortDesc: '短介紹',
    fullDesc: '完整介紹',
    icon: '圖標',
    iconEmpty: '尚未生成圖標',
    status: '狀態',
    btnAi: '幫我生成',
    btnConfirm: '確認素材',
    btnPublish: '一鍵上架',
    btnPipeline: '開始標準流水線',
    coachDo: '按當前步去做',
    aiOk: '已生成（可再改）',
    confirmOk: '素材已確認',
    publishOk: '已排隊上架'
  },

  route: {
    // XRROSS_I18N_UNION_FILL_20260916 tw
    add: '新增',
    agentPermissionSteward: 'Agent 權限管家',
    aiTrusteeAdmin: 'AI 託管管理',
    batchDelete: '批量刪除',
    batchImport: '批量匯入',
    bindMachine: '綁定設備',
    bindStore: '綁定店鋪',
    codeRule: '編碼規則',
    delete: '刪除',
    detail: '詳情',
    edit: '編輯',
    export: '匯出',
    leoBrandOnboardingDesk: '品牌接入台',
    leoBrandOnboardingDeskConfirm: '確認',
    leoBrandOnboardingDeskView: '查看',
    leoBrandOnboardingGroup: '品牌接入',
    log: '日誌',
    machineList: '設備列表',
    merchantData: '商家資料',
    oneClickCopy: '一鍵複製',
    reset: '重置',
    resetPwd: '重置密碼',
    search: '查詢',
    socNotificationCenter: '通知中心',
    storeMaterialPhysicalMerge: 'SKU合併建議',
    teaE1MatchScore: '匹配分',
    teaE1OnTarget: '達標',
    teaE1Performance: '茶機 E1 效能',
    teaE1Wear: '磨損',
    homePage:'首頁',
    dataDisplay:'數據展示',
    atlas:'地圖',
    journal:'日誌',
    details:'詳情',
    systemSetting:'系統設置',
    loginAccount:'帳號管理',
    merchants:'商家管理',
    devices: "設備管理",
    material: "物料管理",
    deviceConfig: "設備配置",
    channelConfiguration: "通道配置",
    configProfileLibrary: "配置檔庫",
    coffeeMachineChannelSlots: "X600H配方中心",
    configBindDispatch: "綁定與下發",
    leoKnowledgeGroup: '智能.Leo',
    leoKnowledgeModelFields: '型號知識欄位',
    leoKnowledgeEquipmentTypeTypeKey: '設備類型 type_key',
    leoKnowledgeUpload: '知識上傳',
    leoKnowledgeIngestBatch: '入庫批次（自動建立）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT 管線',
    leoKnowledgeCapabilityMatrix: '能力矩陣',
    leoKnowledgeOnboarding: '智慧型號引導',
    leoKnowledgeTesterConsole: '測試員主控台',
    leoKnowledgePipelineHub: '管線總覽',
    leoKnowledgeFeatureSurface: '功能→API 映射',
    leoKnowledgeProtocolDoc: '協議文檔索引',
    leoKnowledgeRemoteTools: '遙控工具目錄',
    leoKnowledgeLearning: '學習閉環',
    leoKnowledgeExternalIngest: '外部知識入庫',
    leoKnowledgePortalHub: 'Leo 對話與營運',
    leoKnowledgePortalHubDesc: '由此開啟 Leo 對話（主入口）與 Biz 營運功能；Console／Portal 僅內部運維。',
    leoKnowledgePortalHubHint: '主權台為氣泡式智慧對答版面；門戶為精簡入口。若需帶 portalToken／ceoBearer，請在開啟後於網址列補上查詢參數。',
  leoKnowledgeUiSurfaceSample: '視覺樣板',
  leoKnowledgeUiSurfaceSample2: '視覺樣板 · 樣板2',
  leoKnowledgeUiSurfaceSample3: '視覺樣板 · 樣板3',
  uiSurfaceSampleMergedLead: '三套後台視覺樣板合在一頁，用上方 Tab 切換對照。',
  uiSurfaceSampleTab1: '樣板1 · Ant Pro',
  uiSurfaceSampleTab2: '樣板2 · Stripe',
  uiSurfaceSampleTab3: '樣板3 · 緊湊',
    uiSurfaceSampleLead: '樣板1（已定案試點）：Ant Design Pro 中密。全域 Token 已抽出；商家列表／設備列表已試套骨架。',
    uiSurfaceSampleLead2: '樣板2 · Stripe／SaaS：淡紫主色、更大圓角、偏鬆留白、輕陰影。',
    uiSurfaceSampleLead3: '樣板3 · 緊湊運營：青綠主色、小圓角、迷你控件、資訊密度更高。',
    uiSurfaceSampleAlert: '僅視覺樣板，表單與表格為示意資料，不呼叫後端；尚未套用到全站。請對照樣板1／2／3 選風格。',
    uiSurfaceSampleTokenTitle: 'Design Token（候選）',
    uiSurfaceSampleDensity: '密度：中密（8 的倍數）',
    uiSurfaceSampleDensity2: '密度：中鬆（Stripe 節奏）',
    uiSurfaceSampleDensity3: '密度：緊湊（運營桌面）',
    uiSurfaceSampleBtnTitle: '按鈕分級',
    uiSurfaceSampleBtnPrimary: '主要操作',
    uiSurfaceSampleBtnSecondary: '次要',
    uiSurfaceSampleBtnText: '文字按鈕',
    uiSurfaceSampleBtnDanger: '危險',
    uiSurfaceSampleBtnMore: '更多',
    uiSurfaceSampleBtnCreate: '新建',
    uiSurfaceSampleListSkeleton: '列表頁骨架：篩選｜表格｜底欄',
    uiSurfaceSampleFormTitle: '表單密度（中密）',
    uiSurfaceSampleFormRemark: '備註',
    uiSurfaceSamplePipelineTitle: '流水線節點＋教練卡金樣（SocProcessRail + SocStepCoach）',
    uiSurfaceSamplePipelineMeta: '頂欄標準流水線＝節點軌＋藍框教練大鈕；工單／頁內共用；禁止另起樣式',
    uiSurfaceSampleCoachTitle: '請完成：第 2 步（示範）',
    uiSurfaceSampleCoachHint: '藍框＝現在要做的一步；點大按鈕即可，不必在整頁大海撈針。',
    uiSurfaceSampleCoachPrimary: '去做這一步',
    uiSurfaceSampleCoachSecondary: '開始／檢查引導',
    uiSurfaceSamplePipelineStep1: '步驟一',
    uiSurfaceSamplePipelineStep2: '步驟二',
    uiSurfaceSamplePipelineStep3: '步驟三',
    uiSurfaceSamplePipelineStep4: '步驟四',
    uiSurfaceSampleColActions: '操作',
    uiSurfaceSampleActEdit: '編輯',
    uiSurfaceSampleActExport: '匯出',
    uiSurfaceSampleTableFootHint: '底欄：左側說明｜右側分頁',
    uiSurfaceSampleKpi_orders: '今日訂單（示意）',
    uiSurfaceSampleKpi_online: '在線設備',
    uiSurfaceSampleKpi_alerts: '待處理告警',
    uiSurfaceSampleKpiSub: '樣板數字',
    uiSurfaceSampleFilterTitle: '篩選區',
    uiSurfaceSampleKeyword: '關鍵字',
    uiSurfaceSampleKeywordPh: '名稱或編號',
    uiSurfaceSampleStatus: '狀態',
    uiSurfaceSampleStAll: '全部',
    uiSurfaceSampleStOn: '啟用',
    uiSurfaceSampleStOff: '停用',
    uiSurfaceSampleReset: '重置',
    uiSurfaceSampleSelectPh: '請選擇',
    uiSurfaceSampleTableTitle: '列表示意',
    uiSurfaceSampleColName: '名稱',
    uiSurfaceSampleColRegion: '區域',
    uiSurfaceSampleColStatus: '狀態',
    uiSurfaceSampleColUpdated: '更新時間',
    uiSurfaceSampleCompareTitle: '對照：全白區塊 vs 分層灰底',
    uiSurfaceSampleCompareOld: '舊感：大面積純白',
    uiSurfaceSampleCompareOldDesc: '內容區與背景同色時，邊界較不分明，長時間閱讀容易累。',
    uiSurfaceSampleCompareNew: '建議：灰底上的白卡',
    uiSurfaceSampleCompareNewDesc: '主內容仍在白底上維持對比；頁面級用淺灰承托，視線有落點。',
    leoPortalHubSovereign: '主權台（全屏）',
    leoPortalHubPortal: '門戶',
    leoPortalHubDeviceIntegrationSection: '裝置端整合',
    leoPortalHubDeviceIntegrationLink: '對外說明與工具（新分頁）',
    leoPortalHubRuntimeModuleLink: '裝置雲運行期 AAR（新分頁）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（工程測試）',
    leoPortalHubSdkEngineerLabOpen: '全功能測試台（第一軌＋第二軌，新分頁）',
    leoPortalHubSdkPublicTrack1: '第一軌對外說明',
    leoPortalHubSdkPublicTrack2: '第二軌對外說明',
    leoPortalHubChatSection: '對話入口',
    leoPortalHubPreferences: '我的偏好',
    leoPortalHubLogin: '登入',
    leoPortalHubSectionOps: '營運控制台',
    leoPortalHubSectionOpsDesc: '後台即時對話流、CEO／門戶主權視窗，適合大螢幕驗收與值守。',
    leoPortalHubSectionPortal: '行動門戶',
    leoPortalHubSectionPortalDesc: '精簡入口，方便手機或對外展示。',
    leoPortalHubSectionChat: '智慧對話',
    leoPortalHubSectionChatDesc: 'Leo 智慧對話；下方可調整偏好或登入。',
    leoPortalHubSectionDeviceDesc: '對外說明、運行期模組與整合文檔（皆於新分頁開啟）。',
    leoPortalHubSectionSdkDesc: '工程師用於兩軌串接、回歸與除錯的統一測試台。',
    leoPortalHubCardSovereignDesc: '氣泡式智慧對答、Markdown 與 SOP 步驟卡片。',
    leoPortalHubCardPortalDesc: '精簡 Leo 門戶；必要時於網址加上 portalToken／ceoBearer。',
    leoPortalHubCardLeoDesc: '預設 Leo 對話；一般營運、知識問答與遙控（全球會員同一入口）。',
    leoPortalHubCardPrefDesc: '人設、地區與個人化選項。',
    leoPortalHubCardLoginDesc: '以後台帳號登入後再使用寫入／敏感能力。',
    leoPortalHubCardDeviceIntegrationDesc: '公開說明、Track1 工具與整合檢核表。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud 運行期／AAR 與 Track2 對照入口。',
    leoPortalHubCardSdkLabDesc: '整合測試環境，同時演練第一軌與第二軌行為。',
    leoPortalHubSdkFeaturedTag: '工程',
    leoPortalHubOpenNewTab: '點擊以新分頁開啟',
    leoPortalHubSdkCrossRefHint: '第一軌／第二軌對外說明請使用上方「裝置端整合」兩張卡片。',
    leoFloatDockTitle: 'Leo 對話',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '關閉',
    leoFloatDockResizeHint: '拖曳右下角調整視窗大小',
    leoFloatDockSwitchLabel: 'Leo 對話',
    leoFloatDockSwitchHint: '開啟後打開 Leo SOC助手「對話」頁（與說明書／智能引導同抽屜）；獨立 Leo／Console／門戶頁仍用全頁聊天。',
    socAssistantTabManual: '問說明書',
    socAssistantTabGuide: '智能引導',
    socSmartGuideLead: '說你是誰、要達到什麼；系統開一張流水線並一直跟到結果，除非你刪除。做完自動接下一段。',
    socSmartGuideStart: '開始進程',
    socSmartGuideMyProcesses: '我的進程',
    socSmartGuideCatalog: '或從進程目錄選',
    socSmartGuideNetStats: '單位 {units} · 進程 {processes} · 交叉 {edges}',
    socSmartGuideIntentPlaceholder: '例如：我是新品牌老闆，要從建品牌到出品',
    socSmartGuideEntry: '入口',
    socSmartGuideExit: '出口',
    socSmartGuideDemand: '需求',
    socSmartGuideResult: '結果',
    socSmartGuideHandoff: '這條做完了，接著開下一條',
    socSmartGuideRolePreview: '角色預覽',
    socSmartGuideRoleCurrent: '當前帳號',
    socSmartGuideProxyStore: '代跑店員線：門店編號',
    socSmartGuidePaused: '已暫停',
    socSmartGuideInProgress: '進行中',
    socSmartGuideNotices: '提醒',
    socSmartGuideNoticeNotDone: '沒做',
    socSmartGuideNoticeWrong: '做錯',
    socSmartGuideNoticeDue: '到期',
    socSmartGuideAck: '已知悉',
    socSmartGuideContinue: '繼續',
    socSmartGuideDelete: '刪除流水線',
    socSmartGuideDeleteConfirm: '刪除後系統不再跟進這條線，確定？',
    socSmartGuideDeleted: '已刪除流水線',
    socSmartGuideDeleteFail: '刪除失敗',
    socSmartGuideOpenPage: '打開',
    socProcessNetTogoTitle: '進程待辦',
    socProcessNetTogoRemain: '還差 {n} 步',
    socProcessNetTogoAllDone: '這條線都過了',
    socProcessNetTogoHint: '打勾只認系統狀態。點卡住的步驟跳真頁，或開口跟 Leo 說、填同一張單。',
    socProcessNetTogoVoice: '跟 Leo 說',
    socProcessNetTogoClose: '關閉',
    socProcessNetTogoLoadFail: '待辦清單載入失敗',
    socProcessNetTogoNow: '目前',
    socSmartGuideSlotsHint: '先把缺的欄問完（聊天＝填同一張單）',
    socSmartGuideSlotSubmit: '寫入',
    socAssistantTabChat: 'Leo 對話',
    xrrossIntroNavButton: '認識 XRROSS',
    xrrossIntroHub: '認識 XRROSS',
    xrrossIntroLeo: 'Leo',
    xrrossIntroSoc: 'SOC',
    xrrossIntroTrinity: '三位一體',
    xrrossIntroXhm: 'XHM',
    leoSmartIntro: '認識 Leo Smart',
    layoutThemeUseDark: '切換為深色主題',
    layoutThemeUseLight: '切換為淺色主題',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：主權台、門戶與 Leo 對話入口已移至側欄「Leo 知識庫」內之',
    leoProfileWorkbenchLeoMovedSuffix: '。',
    equipmentCategory: '設備類別',
    equipmentCategoryEdit: '設備類別－編輯',
    equipmentCategoryDel: '設備類別－刪除',
    equipmentTypePermAdd: '設備類型－查詢／新增（列表）',
    equipmentTypePermEdit: '設備類型－編輯',
    deviceSimulatorConsole: '模擬機－控制台',
    leoDeviceOpsRolePolicy: '命令權限總表',
    leoDeviceOpsSemanticTraining: '語義訓練工作台',
    leoTurnRoutingTrainingHub: 'T0 入口路由訓練台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 盤點台',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS 工作台',
    leoDeviceOpsReviewInbox: 'B 線審核待辦',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B 線日常工作台',
    simulatorGroup: '模擬機',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestro模擬機',
    storefrontSimulator: '點單機Kiosk',
    productCenter: "出品管理",
    productCenterFolderOther: '其他產品',
    dataCenter: "數據中心",
    maintenance: "運維管理",
    filesCenter:'文件管理',
    menuSetting:'菜單設置',
    organization:'用戶組織',
    loginAccount:'帳號列表',
    authorization:'角色管理',
    merchants:'商家列表',
    deviceList:'設備列表',
    deviceAutoServiceGroup: '售後維修保養',
    supportTicketGroup: '售後支持',
    supportTicketCreate: '提交工單',
    supportTicketMine: '我的工單',
    supportTicketWorkbench: '售後工作台',
    supportPlaybook: '標準問答庫',
    deviceServiceWorkbench: '售后工單工作台',
    deviceServiceMyAssignments: '我的維修任務',
    deviceServiceAssignees: '維修負責人',
    deviceServiceMaintenance: '保養計劃',
    deviceServiceFaultPolicy: '故障開單策略',
    deviceServiceEnterprisePolicy: '企業自動售后策略',
    deviceServiceMobile: '維修任務（手機）',
    deviceServiceBills: '維修帳單',
    deviceServiceAnalytics: '故障分析',
    storeMaterialStock: '庫存總覽',
    storeMaterialOrders: '採購訂單',
    storeMaterialConsumable: '耗材 BOM',
    storeMaterialMq: 'MQ 配置',
    storeMaterialInvoice: '發票',
    storeMaterialBarcodeAlias: '掃碼映射',
    storeMaterialCount: '倉庫盤點',
    storeMaterialBomWizard: 'BOM嚮導',
    storeMaterialAnalytics: '物料使用報告',
    channelCategory:'通道類型',
    productCategory:'出品類型',
    optionCategory:'規格類型',
    optionList:'規格列表',
    storeAccount:'店舖帳號',
    stores:'店舖管理',
    modelName:'設備名稱/型號',
    category:'物料類型',
    configDistribute:'通道下發',
    devicesChannels:'設備通道',
    productsList5:'出品列表5',
    produceFivePos:'產品5門店客制',
    posCenter:'POS中心',
    menuDistribute:'菜單下發',
    storeMenu:'店鋪菜單',
    merchantsData:'商家統計數據',
    devicsData:'設備統計數據',
    productionData:'設備出品數據',
    maintanenceData:'設備售後數據',
    devicesWorkingData:'設備使用數據',
    afterSalesReminder:'售後提示',
    maintenanceTips:'保養提示',
    fileUpgrade:'文件升級',
    dataDowloan:'數據下載',
    materialList:'物料列表',
    accessoriesCategory:'小吃類型',
    accessoriesList:'小吃列表',
    businessCenter: '業務中心',
    afterSalesServiceGroup: '售後服務',
    storeMaterialGroup: '庫存管理',
    appsBanner:'App橫幅展示',
    advertisement:'廣告清單',
    advertBind:'廣告綁定',
    advertDistribute:'廣告下發',
    membersCenter:'會員列表',
    orderCenter:'訂單列表',
    packBag:'打包袋子',
    appsCenter:'app管理',
    productsList2:'出品列表2',
    XTSeriesData:'配料機數據',
    calibrationData:'校準數據',
    fullPipeData:'滿管數據',
    productionData:'出品數據',
    materialDate:'物料數據',
    qualityData:'單杯數據',
    alertsLog:'故障日誌',
    cleaningLog:'清洗記錄',
    coffeeData:'咖啡機數據',
    coffeeMachineProductionData:'X600H 出品數據',
    coffeeMachineSingleCupData:'X600H 單杯數據',
    coffeeSumData:'品質數據',
    taxCenter:'稅務中心',
    taxManagement:'稅務管理',
    taxAllocation:'稅務配置',
    dataOfTeaExtractorMachine:'萃茶機數據',
    teaMachineMaterial: '物料損耗',
    teaEarlyBrewWork: '多機互聯工作',
    dispenserPrecision: '精準度',
    dispenserMaterialLoss: '物料損耗',
    dispenserMultiMachine: '多機互聯',
    ecosystemMallGroup: '生態商城',
    ecosystemMallTopology: '商店拓撲',
    ecosystemMallFeaturedBuyEyebrow: '主力推薦 · 家用直購',
    ecosystemMallFeaturedBuyTitle: 'Xrross X600H · $499',
    ecosystemMallFeaturedBuyDesc: '家用智能咖啡機：一鍵進結帳，填地址即可付款。',
    ecosystemMallFeaturedBuyCta: '立即購買 X600H',
    ecosystemMallFeaturedBuyBrowse: '先看目錄',
    ecosystemMallCapGridTitle: '商城能做什麼',
    ecosystemMallCapGridDesc: '這裡是全部能力（不藏）。滑鼠移到每一格，會彈出該功能的簡單說明與聯動一句；藍框建議＝現在最該做的一步。',
    ecosystemMallCapHoverHint: '移上查看說明',
    ecosystemMallTipBuyX600h: '進入家用結帳，用 Stripe／PayPal 買 X600H（海外預設 Stripe）。',
    ecosystemMallTipOrientPipeline: '帶你逛商城：能力格 → 家用／商用 → 選店 → 點能力。',
    ecosystemMallTipGapFillPipeline: '選店後補齊本店缺口：拓撲 → 建議 → 模擬或留資 → 可下單。',
    ecosystemMallTipColorScheme: '只改畫布配色，不影響功能。',
    ecosystemMallTipBrowseCatalog: '先逛目錄與拓撲，不急著下單。',
    ecosystemMallTipHomePipeline: '家用結帳標準流水線：選商品 → 填地址 → 付款 → 完成。',
    ecosystemMallTipBackTopology: '回商城主畫面（拓撲／能力格）。',
    ecosystemMallTipReload: '重新載入本頁資料。',
    ecosystemMallTipPayStripe: '用 Stripe 安全付款（海外預設）。',
    ecosystemMallTipPayPaypal: '用 PayPal 付款（可選）。',
    ecosystemMallTipTrialPipeline: '先試後買流水線：開試用 → 看結果 → 直購或留意向。',
    ecosystemMallTipEntryContinue: '依簡報建議做下一步。',
    ecosystemMallTipEntrySwitch: '在家用焦點與商用焦點之間切換（功能不減）。',
    ecosystemMallTipEntryAdvanced: '展開或收起進階圖表／專家細節。',
    ecosystemMallTipTrackHome: '家用焦點：偏直購／家用設備。',
    ecosystemMallTipTrackCommercial: '商用焦點：偏店務／產線／缺口。',
    ecosystemMallTipAppDlPipeline: '帶你下載本區正式 App（與 OTA 同一帳本）。',
    ecosystemMallTipAppDlReload: '重新整理可下載清單。',
    ecosystemMallCapBadgeSuggest: '建議',
    ecosystemMallCapBadgeCurrent: '目前',
    ecosystemMallCapBadgeNeedStore: '需選店',
    ecosystemMallCapC1Title: '商店拓撲',
    ecosystemMallCapC1Blurb: '用拓撲圖看本店已有／還缺什麼',
    ecosystemMallCapC1Link: '聯動：點設備看跟其他機怎麼一起工作',
    ecosystemMallCapC2Title: '搜尋推薦',
    ecosystemMallCapC2Blurb: '用關鍵詞找下一台',
    ecosystemMallCapC2Link: '聯動：依你店況／已有設備推薦缺口',
    ecosystemMallCapC3Title: '產線組合',
    ecosystemMallCapC3Blurb: '開這類店要哪幾台',
    ecosystemMallCapC3Link: '聯動：一整條店務產線一起配齊',
    ecosystemMallCapC4Title: '試用模擬',
    ecosystemMallCapC4Blurb: '先雲端試再決定買',
    ecosystemMallCapC4Link: '聯動：試完可回拓撲補缺口或直購',
    ecosystemMallCapC5Title: '組合演示',
    ecosystemMallCapC5Blurb: '看整條店務怎麼聯動',
    ecosystemMallCapC5Link: '聯動：多機一起跑的店務故事',
    ecosystemMallCapC6Title: '家用直購／訂單',
    ecosystemMallCapC6Blurb: '買硬體、付款、查單',
    ecosystemMallCapC6Link: '聯動：買回家後進 Leo／拓撲同一生態',
    ecosystemMallCapC7Title: '商業計畫',
    ecosystemMallCapC7Blurb: '買／升級商業方案',
    ecosystemMallCapC7Link: '聯動：方案能力掛回店與設備',
    ecosystemMallCapC8Title: '購買意向',
    ecosystemMallCapC8Blurb: '留下我要這台／要裝',
    ecosystemMallCapC8Link: '聯動：意向進履約，再回拓撲補節點',
    ecosystemMallCapC9Title: '售前問答',
    ecosystemMallCapC9Blurb: '問聯動／怎麼買／怎麼試',
    ecosystemMallCapC9Link: '聯動：問清楚再進模擬或意向',
    ecosystemMallCapC10Title: '應用下載',
    ecosystemMallCapC10Blurb: '下載本區正式 App',
    ecosystemMallCapC10Link: '聯動：手機／機端同一帳本生態',
    ecosystemMallCapC11Title: '虛擬店／家',
    ecosystemMallCapC11Blurb: '擺佈局、看建議放置',
    ecosystemMallCapC11Link: '聯動：虛擬擺好對回真實店缺口',
    ecosystemMallCapC12Title: '產品展示',
    ecosystemMallCapC12Blurb: '用格子一張張看商品與介紹',
    ecosystemMallCapC12Link: '聯動：點商品可去結帳／試用／回拓撲圖',
    ecosystemMallProductDisplayDesc: '格子展示全部商品（與拓撲圖、產線組合並列）。點一張卡看說明，再決定買或試。',
    ecosystemMallProductDisplayToolbar: '商品格子',
    ecosystemMallProductDisplayCount: '共 {n} 件',
    ecosystemMallProductDisplaySearchPh: '搜名稱／編碼',
    ecosystemMallProductDisplayDefaultPitch: '雲端就緒 · 可聯動',
    ecosystemMallProductDisplayAlreadyHere: '你已在產品展示',
    ecosystemMallProductDisplaySeeTopology: '在拓撲圖看聯動',
    ecosystemMallProductDisplayScopeLabel: '設備範圍',
    ecosystemMallProductDisplayScopeAll: '全部設備',
    ecosystemMallProductDisplayScopeStore: '本店設備',
    ecosystemMallProductDisplayNeedStore: '本店範圍需先選店',
    ecosystemMallProductDisplayNoStore: '未選店',
    ecosystemMallProductDisplayStoreAlert: '本店設備：請先在上方選一家店，才會列出本店已有／建議補的商品。',
    ecosystemMallProductDisplayCatalogAlert: '全部設備：展示商城目錄全量；選店後會標記本店已有。',
    ecosystemMallProductDisplayEmpty: '目前沒有可展示的商品。可改「全部設備」、換店，或確認目錄已上架 ACTIVE。',
    ecosystemMallProductDisplaySideEmpty: '點左側商品卡片，展開與拓撲商店相同的產品詳情與媒資。',
    ecosystemMallProductDisplaySideEmptyHint: '含封面／影片、概覽、規格與功能章節；可直購、試用或到拓撲看聯動。',
    ecosystemMallDetailCapacity: '產能提升',
    ecosystemMallDetailLabor: '人工降幅',
    ecosystemMallDetailMedia: '產品細節與動態藝廊',
    ecosystemMallDetailMediaPending: '待補圖',
    ecosystemMallDetailMediaPreview: '產品預覽',
    ecosystemMallDetailVideo: '產品影片',
    ecosystemMallDetailCover: '商城封面',
    ecosystemMallDetailAvatar: '拓撲頭像',
    ecosystemMallDetailModelImg: '型號圖',
    ecosystemMallDetailScene: '情境',
    ecosystemMallDetailTabOverview: '概覽',
    ecosystemMallDetailTabSpecs: '規格',
    ecosystemMallDetailTabFeatures: '功能',
    ecosystemMallDetailKeySpecs: '重點規格',
    ecosystemMallDetailSeeAll: '查看全部',
    ecosystemMallDetailSpecsLoading: '規格載入中…',
    ecosystemMallDetailSpecsEmpty: '尚無已採用規格。',
    ecosystemMallDetailSpecsFail: '規格載入失敗',
    ecosystemMallDetailSpecSearchPh: '搜尋規格項目…',
    ecosystemMallDetailGuide: '引導體驗',
    ecosystemMallDetailAllChapters: '全部章節',
    ecosystemMallDetailPrev: '上一章',
    ecosystemMallDetailNext: '下一章',
    ecosystemMallDetailProof: '能力證明掛點',
    ecosystemMallDetailOpen: '打開',
    ecosystemMallDetailNoChapters: '此型號尚無功能章節。',
    ecosystemMallDetailBackChapters: '返回章節列表',
    ecosystemMallDetailChapter: '章節',
    ecosystemMallDetailChapterHint: '點擊查看步驟詳情',
    ecosystemMallDetailModel: '型號',
    ecosystemMallDetailFamily: '族別',
    ecosystemMallDetailRole: '店務角色',
    ecosystemMallDetailOverlayOwned: '本店已有 · 已連雲端',
    ecosystemMallDetailOverlayMissing: '雲端已就緒，店裡還缺這台',
    ecosystemMallDetailOverlayAvailable: '目錄可選 · 雲端已就緒',
    ecosystemMallOrientRailTitle: '帶你認識生態商城',
    ecosystemMallGapFillPipeline: '帶我補齊這家店',
    ecosystemMallGapFillRailTitle: '本店缺口補齊',
    ecosystemMallGuideChromeTitle: '流程引導',
    ecosystemMallGuideExpand: '展開引導',
    ecosystemMallGuideCollapse: '收合引導',
    ecosystemMallGuideCollapsedHint: '已收合，工作區優先',
    ecosystemMallGuideSkipOrient: '稍後再導覽',
    ecosystemMallGuideSkipOrientDone: '已略過導覽，可直接看拓撲',

    ecosystemMallHomeCheckoutPipeline: '家用直購流水線',
    ecosystemMallTrialThenBuyTitle: '先試用再買',
    ecosystemMallTrialThenBuyDesc: '試過再開直購或留購買意向；模擬與真機主檔隔離，功能不減。',
    ecosystemMallTrialThenBuyPipeline: '帶我試完再買',
    ecosystemMallTrialThenBuyRailTitle: '試用→購買',
    ecosystemMallTrialThenBuyListTitle: '我的試用模擬機',
    ecosystemMallTrialThenBuyAllStatus: '全部狀態',
    ecosystemMallTrialThenBuyCleanup: '清理過期',
    ecosystemMallTrialThenBuyEmpty: '尚無試用模擬機',
    ecosystemMallTrialThenBuyStatus: '狀態',
    ecosystemMallTrialThenBuyExpires: '過期',
    ecosystemMallTrialCoachPick: '請先選要試的商品',
    ecosystemMallTrialCoachOpen: '開通／查看試用模擬',
    ecosystemMallTrialCoachResult: '看結果後可直購或留意向',
    ecosystemMallTrialHintPick: '可從拓撲點設備再開模擬；本頁看已開通清單。',
    ecosystemMallTrialHintOpen: '刷新可看本帳號試用 SN；與真機隔離。',
    ecosystemMallTrialHintResult: '直購與意向兩條入口都在，不會藏。',
    ecosystemMallSideBuyNow: '直接購買這台',
    ecosystemMallSideSimOpen: '先體驗模擬製作',
    ecosystemMallSideSimClose: '收起模擬',
    ecosystemMallSideIntentNeedStore: '請先選店再留「我要這台」',
    ecosystemMallSideIntentPotential: '我要這台（留下意向）',
    ecosystemMallSideIntentOwned: '這台本店已有',
    ecosystemMallAppDownloads: '應用下載',
    ecosystemMallAppDownloadsDesc: 'Leo 產品頁。蘋果走 App Store；安卓海外走 Google Play，中國大陸走本區節點安裝（與 OTA 同一份）。',
    ecosystemMallAppDlReload: '重新載入',
    ecosystemMallAppDlChannels: '下載通道',
    ecosystemMallAppDlAndroid: '安卓直裝',
    ecosystemMallAppDlInstallNow: '立即下載安裝',
    ecosystemMallAppDlNoApk: '本區暫無直裝包',
    ecosystemMallAppDlAndroidReady: '偵測到安卓。點按鈕即可下載本區已發布的 Leo 手機包。',
    ecosystemMallAppDlAndroidWait: '本區還沒有對客戶開放的安裝包，請稍候或走商店上架。',
    ecosystemMallAppDlVersion: '版本',
    ecosystemMallAppDlUnknownSrc: '若系統提示未知來源，請允許安裝此應用。',
    ecosystemMallAppDlPlayReview: 'Google Play 尚未開放。',
    ecosystemMallAppDlIosReview: 'App Store 即將上架。',
    ecosystemMallAppDlReviewing: '審核中',
    ecosystemMallAppDlComing: '即將上架',
    ecosystemMallAppDlDesktopHint: '蘋果走 App Store。安卓海外走 Google Play，中國大陸走本區節點安裝。也可複製連結發給同事。',
    ecosystemMallAppDlCopyLink: '複製本頁連結',
    ecosystemMallAppDlOpenSoc: '打開 SOC 後台',
    ecosystemMallAppDlCopySoc: '複製 SOC 連結',
    ecosystemMallAppDlSocHint: 'SOC 是網頁後台，用瀏覽器打開即可；你現在就在這裡。',
    ecosystemMallAppDlCopied: '已複製',
    ecosystemMallAppDlSmartAndroid: '這是安卓手機：可直接下載安裝 Leo。',
    ecosystemMallAppDlSmartAndroidPlay: '這是安卓手機（海外）：請打開 Google Play 安裝 Leo。',
    ecosystemMallAppDlSmartAndroidNode: '這是安卓手機（中國大陸）：請用本區節點安裝，與 OTA 同一份。',
    ecosystemMallAppDlSmartAndroidNoApk: '這是安卓手機，但本區還沒有直裝包。海外請走 Google Play。',
    ecosystemMallAppDlSmartIos: '這是蘋果手機：請從 App Store 安裝 Leo.Smart。',
    ecosystemMallAppDlSmartDesktop: '這是電腦：請用安卓手機打開本頁安裝，或複製連結。',
    ecosystemMallAppDlRoleLeo: '手機大腦',
    ecosystemMallAppDlRoleSoc: '你在這裡',
    ecosystemMallAppDlRoleXhm: '店裡機器 · 下輪',
    ecosystemMallAppDlTopo: '商城拓撲 · 三位一體',
    ecosystemMallAppDlEdgeLeoSoc: '手機 → 後台',
    ecosystemMallAppDlEdgeSocXhm: '後台 → 機器',
    ecosystemMallAppDlCapLeo: 'Leo 管人怎麼跟機器說話；安卓可先直裝。',
    ecosystemMallAppDlCapSoc: 'SOC 是中樞：帳號、店、遠端都從這裡走。',
    ecosystemMallAppDlCapXhm: '機端 App 下輪再放；現在先把手機 Leo 裝上。',
    ecosystemMallAppDlStartPipeline: '開始標準流水線',
    ecosystemMallAppDlPipelineStarted: '已開始標準流水線',
    ecosystemMallAppDlDeveloper: 'XRROSS',
    ecosystemMallAppDlCategory: '生活 · 人機 · 店鋪',
    ecosystemMallAppDlPlayBtn: 'Google Play',
    ecosystemMallAppDlIosBtn: 'App Store',
    ecosystemMallAppDlQrTitle: '掃碼下載',
    ecosystemMallAppDlQrHint: '掃碼打開下載頁。蘋果進 App Store。安卓：海外進 Google Play，中國大陸走本區節點安裝。',
    ecosystemMallAppDlQrSave: '下載二維碼',
    ecosystemMallAppDlQrOpen: '打開下載頁',
    ecosystemMallAppDlShots: '預覽',
    ecosystemMallAppDlShotVoice: '開口出杯',
    ecosystemMallAppDlShotTopo: 'Leo → SOC → 機器',
    ecosystemMallAppDlShotLife: '生活裡的人機',
    ecosystemMallAppDlShotWork: '店裡幹活',
    ecosystemMallAppDlAbout: '簡介',
    ecosystemMallAppDlAboutBody: 'Leo 是人機生活方式的手機入口：你開口，店裡的機器做事。手機連 SOC 後台，後台連茶機／咖機／出杯線。不是聊天機器人清單，是同一條拓撲上的生活、工作與生意。',
    ecosystemMallAppDlFeatTalk: '開口就能泡茶、問狀態、跟機器說話',
    ecosystemMallAppDlFeatTopo: '三位一體：手機 Leo → SOC 中樞 → 店裡機器',
    ecosystemMallAppDlFeatLife: '生活點單、店員幹活、老闆看店，人機都在場',
    ecosystemMallAppDlFeatOta: '安裝包與本區 OTA 同一帳本，發版即商店直裝跟著變',
    ecosystemMallAppDlWhatsNew: '新內容',
    ecosystemMallAppDlWhatsNewBody: '本區已發布 {ver}，與檢查更新同一包。',
    ecosystemMallAppDlWhatsNewEmpty: '本區還沒有對客戶開放的安裝包。',
    ecosystemMallAppDlInfo: '資訊',
    ecosystemMallAppDlInfoDev: '開發者',
    ecosystemMallAppDlInfoPkg: '套件名',
    ecosystemMallAppDlInfoAge: '年齡分級',
    ecosystemMallAppDlAgeVal: '4+',
    ecosystemMallSocOps: '營運商店',
    ecosystemMallPortraits: '客戶畫像',
    ecosystemMallPortraitsDesc: '按企業／帳號判斷設備商或運營商，並結合規模、運營與生命週期做精準推廣。',
    ecosystemMallPortraitsStatsTitle: '畫像統計',
    ecosystemMallPortraitsStatEntTotal: '企業畫像數',
    ecosystemMallPortraitsStatUserTotal: '用戶畫像數',
    ecosystemMallPortraitsChartType: '企業 · 主體類型分布',
    ecosystemMallPortraitsChartBrand: '企業 · 品牌樹語境',
    ecosystemMallPortraitsChartHabit: '企業 · 習慣域 Top 命中',
    ecosystemMallPortraitsChartLifecycle: '企業 · 生命週期分群',
    ecosystemMallPortraitsKpiOverrideRate: '身份覆寫率 I-1',
    ecosystemMallPortraitsColHabit: '習慣 Top',
    ecosystemMallPortraitsColCommercial: '商業兩類',
    ecosystemMallPortraitsColScale: '規模(機/店/活)',
    ecosystemMallPortraitsColLifecycle: '生命週期',
    ecosystemMallPortraitsCommercialFilter: '商業畫像',
    ecosystemMallPortraitsLifecycleFilter: '生命週期',
    ecosystemMallPortraitsCommercialVendor: '設備商',
    ecosystemMallPortraitsCommercialChain: '實體連鎖運營商',
    ecosystemMallPortraitsLifecycleChampion: '冠軍',
    ecosystemMallPortraitsLifecycleGrowing: '成長',
    ecosystemMallPortraitsLifecycleStable: '穩定',
    ecosystemMallPortraitsLifecycleAtRisk: '流失風險',
    ecosystemMallPortraitsLifecycleDormant: '沉睡',
    ecosystemMallPortraitsScaleSummary: '機{eq}／店{kids}／活{days}天',
    ecosystemMallPortraitsExplainTitle: '為何是這類／這群',
    ecosystemMallPortraitsHabitProduce: '出品配方',
    ecosystemMallPortraitsHabitMaterial: '物料BOM',
    ecosystemMallPortraitsHabitDevice: '設備機隊',
    ecosystemMallPortraitsHabitAfterSales: '售後維保',
    ecosystemMallPortraitsHabitData: '數據分析',
    ecosystemMallPortraitsHabitStore: '店務訂單',
    ecosystemMallPortraitsHabitHq: '總部組織',
    ecosystemMallPortraitsHabitMonetization: '加購計費',
    ecosystemMallPortraitsHabitOther: '其他',
    ecosystemMallPortraitsTabEnterprise: '企業畫像',
    ecosystemMallPortraitsTabUser: '用戶畫像',
    ecosystemMallPortraitsTypeFilter: '主體類型',
    ecosystemMallPortraitsStatusFilter: 'SOC租戶狀態',
    ecosystemMallPortraitsBrandCtxFilter: '品牌樹語境',
    ecosystemMallPortraitsColBrandCtx: '品牌樹',
    ecosystemMallPortraitsStatusOemSelf: '設備商自身',
    ecosystemMallPortraitsStatusDistSelf: '分銷商自身',
    ecosystemMallPortraitsStatusSocBrand: '獨立SOC品牌',
    ecosystemMallPortraitsStatusDeviceCust: '設備商下客戶',
    ecosystemMallPortraitsStatusUnknown: '未知',
    ecosystemMallPortraitsBrandCtxRoot: '根／獨立',
    ecosystemMallPortraitsBrandCtxPhysical: '實體品牌樹下',
    ecosystemMallPortraitsBrandCtxOem: '設備商樹下',
    ecosystemMallPortraitsTypeOem: '設備生產商',
    ecosystemMallPortraitsLeoXidInstalled: 'Leo App · 已裝 X-ID',
    ecosystemMallPortraitsLeoXidActive30d: 'Leo App · 30天活躍 X-ID',
    ecosystemMallPortraitsColLeoApp: 'Leo App',
    ecosystemMallPortraitsLeoStatusActive: '30天活躍',
    ecosystemMallPortraitsLeoStatusInstalled: '已安裝',
    ecosystemMallPortraitsLeoStatusNotInstalled: '未安裝',
    ecosystemMallPortraitsLeoEntSummary: '已裝 {installed} · 活躍 {active}',
    ecosystemMallPortraitsLeoAppFilter: 'Leo App 狀態',
    ecosystemMallPortraitsLeoPushBannerTitle: '現客一輪：推廣 Leo 手機智能助手',
    ecosystemMallPortraitsLeoPushBannerDesc: '還有客戶未裝 Leo App。請到應用下載頁分享給同事，同一 Xrross 帳號免費安裝。',
    ecosystemMallPortraitsLeoPushCta: '去應用下載',
    ecosystemMallAppDlSmartTitle: 'Leo 手機智能助手',
    ecosystemMallAppDlShareColleague: '分享給同事',
    ecosystemMallAppDlShareOk: '分享卡已就緒',
    ecosystemMallAppDlShareFail: '分享失敗，請稍後再試',
    ecosystemMallPortraitsTypeDistributor: '業務分銷商',
    ecosystemMallPortraitsTypePhysical: '實體連鎖運營者',
    ecosystemMallPortraitsReload: '重新載入',
    ecosystemMallPortraitsRecompute: '重算畫像',
    ecosystemMallPortraitsRecomputeOk: '重算完成',
    ecosystemMallPortraitsRecomputeFail: '重算失敗',
    ecosystemMallPortraitsLoadFail: '載入失敗',
    ecosystemMallPortraitsColName: '企業名',
    ecosystemMallPortraitsColAccount: '帳號',
    ecosystemMallPortraitsColEnterpriseId: '企業ID',
    ecosystemMallPortraitsColType: '畫像類型',
    ecosystemMallPortraitsColStatus: 'SOC租戶狀態',
    ecosystemMallPortraitsColConfidence: '置信度',
    ecosystemMallPortraitsColComputed: '計算時間',
    ecosystemMallPortraitsColActions: '操作',
    ecosystemMallPortraitsSignals: '訊號',
    ecosystemMallPortraitsOverride: '覆寫',
    ecosystemMallPortraitsOverrideOk: '已覆寫鎖定',
    ecosystemMallPortraitsOverrideOkDetail: '已覆寫鎖定為「{type}」（請看「類型」欄；OEM／分銷在「商業」欄都顯示設備商屬正常）',
    ecosystemMallPortraitsOverrideFail: '覆寫失敗',
    ecosystemMallPortraitsLocked: '已鎖定',
    ecosystemMallPortraitsUnlock: '解鎖',
    ecosystemMallPortraitsUnlockConfirm: '解鎖後將依組織基線重算類型，確定？',
    ecosystemMallPortraitsUnlockOk: '已解鎖並重算',
    ecosystemMallPortraitsUnlockFail: '解鎖失敗',
    ecosystemMallPortraitsColDeviceMode: '機隊用法',
    ecosystemMallPortraitsDeviceModeFilter: '機隊用法',
    ecosystemMallPortraitsDeviceNoFleet: '無機隊',
    ecosystemMallPortraitsDeviceIdle: '機隊閒置',
    ecosystemMallPortraitsDeviceOffline: '離線偏重',
    ecosystemMallPortraitsDeviceLowOut: '在線低產',
    ecosystemMallPortraitsDeviceHigh: '高產出',
    ecosystemMallPortraitsDeviceOps: '運維偏密',
    ecosystemMallPortraitsDeviceFault: '故障關注',
    ecosystemMallPortraitsDeviceBalanced: '運轉平衡',
    ecosystemMallPortraitsAdvice: '建議',
    ecosystemMallPortraitsAdviceTitle: '機隊建議（可執行）',
    ecosystemMallPortraitsAdviceNext: '下一步：',
    ecosystemMallPortraitsKpiAdviceP1: '優先建議數',
    ecosystemMallPortraitsDeviceUsageSummary: '在線 {online}/{eq} · 出杯 {cups} · 運維 {ops} · 閒置機 {idle}',
    ecosystemMallImmersivePromo: '沉浸推廣',
    ecosystemMallAdOrchestrate: '廣告編排',
    ecosystemMallChannelCommand: '渠道總控',
    ecosystemMallBEndCrm: 'B端CRM',
    ecosystemMallPromoContent: '推廣內容',
    ecosystemMallCompanyPay: '公司收款',
    ecosystemMallCompanyPayDesc: '海外收款 Stripe 為主、PayPal 並存；國內微信另線。App／官網賣貨進公司戶。Stub 不是真收款。',
    ecosystemMallCompanyPayReload: '重新載入',
    ecosystemMallCompanyPayChannel: '來源',
    ecosystemMallCompanyPayOrderNo: '訂單號',
    ecosystemMallCompanyPaySku: '商品',
    ecosystemMallCompanyPayName: '名稱',
    ecosystemMallCompanyPayAmount: '金額',
    ecosystemMallCompanyPayStatus: '狀態',
    ecosystemMallCompanyPayEmail: 'Email',
    ecosystemMallCompanyPayTracking: '物流單號',
    ecosystemMallCompanyPayAction: '操作',
    ecosystemMallCompanyPayShip: '發貨',
    ecosystemMallCompanyPayLedger: 'PayPal 帳本',
    ecosystemMallCompanyPayIntent: '帳本號',
    ecosystemMallCompanyPaySurface: '面',
    ecosystemMallCompanyPayRef: '本地單',
    ecosystemMallCompanyPayTime: '時間',
    ecosystemMallCompanyPayCarrier: '承運商',
    ecosystemMallCompanyPayCancel: '取消',
    ecosystemMallCompanyPayShipOk: '確認發貨',
    ecosystemMallHomeCheckoutTitle: '家用直購結帳',
    ecosystemMallHomeCheckoutDesc: '選商品、填收貨地址，再用 PayPal 安全付款；完成後會寄確認信到你的 Email。',
    ecosystemMallHomeCheckoutBackTopology: '回拓撲',
    ecosystemMallHomeCheckoutReload: '重新載入',
    ecosystemMallHomeCheckoutNextAddress: '下一步：填收貨地址',
    ecosystemMallHomeCheckoutBackSku: '回選商品',
    ecosystemMallHomeCheckoutPlaceOrder: '確認下單',
    ecosystemMallHomeCheckoutPayStripe: 'Stripe 付款',
    ecosystemMallHomeCheckoutPayPaypal: 'PayPal 付款',
    ecosystemMallHomeCheckoutCapture: '確認已付款（測試）',
    ecosystemMallHomeCheckoutCaptureLive: '我已完成 PayPal 付款',
    ecosystemMallHomeCheckoutBuyPanel: '立即購買',
    ecosystemMallHomeCheckoutEmptyCatalog: '目前暫無可購買商品，請稍後再試',
    ecosystemMallHomeCheckoutSku: '商品',
    ecosystemMallHomeCheckoutQty: '數量',
    ecosystemMallHomeCheckoutName: '收貨人',
    ecosystemMallHomeCheckoutPhone: '電話',
    ecosystemMallHomeCheckoutEmail: 'Email',
    ecosystemMallHomeCheckoutAddress: '地址',
    ecosystemMallHomeCheckoutCity: '城市',
    ecosystemMallHomeCheckoutPostal: '郵編',
    ecosystemMallHomeCheckoutCountry: '國家',
    ecosystemMallHomeCheckoutPayChannel: '付款方式',
    ecosystemMallHomeCheckoutOrderLine: '訂單 {no} · {status} · {amount}',
    ecosystemMallHomeCheckoutStubNote: '測試模式（僅超管）：點「確認已付款」可走完驗收，不是真收款。',
    ecosystemMallHomeCheckoutStripeDefaultHint: '海外預設 Stripe（亦可改 PayPal）',
    ecosystemMallHomeCheckoutStripeTabHint: '請在 Stripe 視窗完成付款；付完後可查訂單／收郵件通知。',
    ecosystemMallHomeCheckoutStripeOpened: '已開啟 Stripe，請在該視窗完成付款',
    ecosystemMallHomeCheckoutPaypalTabHint: '請在 PayPal 視窗完成付款，再回來點「我已完成 PayPal 付款」。',
    ecosystemMallHomeCheckoutBuyAgain: '再買一台',
    ecosystemMallHomeCheckoutHqOrders: '訂單帳本（總部履約）',
    ecosystemMallHomeCheckoutNoOrders: '尚無訂單',
    ecosystemMallHomeCheckoutWechat: '微信支付',
    ecosystemMallHomeCheckoutStepSku: '選商品',
    ecosystemMallHomeCheckoutStepAddress: '填地址',
    ecosystemMallHomeCheckoutStepPay: '付款',
    ecosystemMallHomeCheckoutStepDone: '完成',
    ecosystemMallHomeCheckoutCoachSku: '請選要購買的商品',
    ecosystemMallHomeCheckoutCoachAddress: '請填收貨資訊',
    ecosystemMallHomeCheckoutCoachPay: '請完成付款',
    ecosystemMallHomeCheckoutCoachDone: '已付款',
    ecosystemMallHomeCheckoutHintSku: '點選商品卡片後繼續。',
    ecosystemMallHomeCheckoutHintAddress: 'Email 用於訂單確認與 PayPal。',
    ecosystemMallHomeCheckoutHintPay: '用 PayPal 付款，完成後回來確認即可。',
    ecosystemMallHomeCheckoutNeedSku: '請先選商品',
    ecosystemMallHomeCheckoutCatalogFail: '商品載入失敗，請稍後再試',
    ecosystemMallHomeCheckoutSkuNoPrice: '此商品暫無標價，可留下意向再討論，或改選其他商品。',
    ecosystemMallHomeCheckoutHqFail: '訂單帳本載入失敗（非超管可略過）',
    ecosystemMallHomeCheckoutNeedName: '請填收貨人',
    ecosystemMallHomeCheckoutNeedPhone: '請填電話',
    ecosystemMallHomeCheckoutNeedEmail: '請填有效 Email',
    ecosystemMallHomeCheckoutNeedAddress: '請填地址',
    ecosystemMallHomeCheckoutNeedCity: '請填城市',
    ecosystemMallHomeCheckoutNeedCountry: '請填國家',
    ecosystemMallHomeCheckoutNeedLogin: '請先登入再結帳',
    ecosystemMallHomeCheckoutOrderCreated: '訂單已建立，請繼續付款',
    ecosystemMallHomeCheckoutOrderFail: '下單未成功，請檢查資料後再試',
    ecosystemMallHomeCheckoutNeedOrder: '請先下單',
    ecosystemMallHomeCheckoutPaypalStub: '測試 PayPal 已就緒（超管可確認付款）',
    ecosystemMallHomeCheckoutPaypalOpened: '已開啟 PayPal，請在該視窗完成付款',
    ecosystemMallHomeCheckoutPayFail: '暫時無法開始付款，請稍後再試',
    ecosystemMallHomeCheckoutPaid: '已收到付款，謝謝！',
    ecosystemMallHomeCheckoutPaidThanks: '訂單 {no} 已付款。確認信已寄至 {email}，出貨後會再通知。',
    ecosystemMallHomeCheckoutStatusPaid: '已付款',
    ecosystemMallHomeCheckoutStatusPending: '待付款',
    ecosystemMallHomeCheckoutStatusShipped: '已出貨',
    ecosystemMallHomeCheckoutCaptureFail: '尚無法確認付款。若已在 PayPal 付過，請稍候再試一次。',
    ecosystemMallHomeCheckoutWechatFail: '無法開微信支付',
    ecosystemMallHomeCheckoutNeedTracking: '請填物流單號',
    ecosystemMallHomeCheckoutShipFail: '發貨失敗',
    ecosystemMallCompanyPayLive: 'PayPal 憑證已配置（sandbox／live）',
    ecosystemMallCompanyPayLiveMode: 'PayPal Live — 真收款',
    ecosystemMallCompanyPaySandboxMode: 'PayPal Sandbox — 測試單',
    ecosystemMallCompanyPayStub: '目前為 stub，不是真收款',
    ecosystemMallCompanyPayLoadFail: '載入失敗（須超管）',
    ecosystemMallCompanyPayNeedTracking: '請填物流單號',
    ecosystemMallCompanyPayShipped: '已標記發貨',
    ecosystemMallCompanyPayShipFail: '發貨失敗',
    ecosystemMallCompanyPayEmptyOrders: '尚無賣貨訂單',
    ecosystemMallCompanyPayEmptyLedger: '尚無收款帳本',
    ecosystemMallCompanyPayStubCol: '是否模擬',
    ecosystemMallCompanyPayStubYes: '是（模擬）',
    ecosystemMallCompanyPayKindHome: '家用 App',
    ecosystemMallCompanyPayKindWebsite: '官網',
    ecosystemMallCompanyPayStatusPending: '待付款',
    ecosystemMallCompanyPayStatusPaid: '已付款',
    ecosystemMallCompanyPayStatusShipped: '已發貨',
    ecosystemMallCompanyPayStatusDelivered: '已送達',
    ecosystemMallCompanyPayStatusBound: '已綁機',
    ecosystemMallCompanyPayStatusCancelled: '已取消',
    ecosystemMallCompanyPayIntentCreated: '已建單',
    ecosystemMallCompanyPayIntentApproved: '已授權',
    ecosystemMallCompanyPayIntentCaptured: '已入帳',
    ecosystemMallCompanyPayIntentCapturedStub: '模擬入帳',
    ecosystemMallCompanyPayIntentFailed: '失敗',
    ecosystemMallCompanyPaySurfaceHome: '家用直購',
    ecosystemMallCompanyPaySurfaceWebsite: '官網結帳',
    ecosystemMallCompanyPaySurfaceAddon: 'SOC 加購',
    ecosystemMallCompanyPaySurfacePlan: '商業計畫',
    ecosystemMallCompanyPaySurfaceContract: '品牌合同',
    ecosystemMallPriceBook: '價目表',
    ecosystemMallBillingPromo: '計費促銷',
    ecosystemMallBillingPromoDesc: '定義品牌商簽約促銷活動，並向指定品牌發放優惠券；標價仍以價目表為準，優惠券僅在結帳時減免。',
    ecosystemMallBillingPromoHqOnly: '計費促銷僅平台總部可用；品牌商請用「服務簽約」查看合同與付款。',
    ecosystemMallBillingPromoReload: '重新載入',
    ecosystemMallBillingPromoNewCampaign: '新建活動',
    ecosystemMallBillingPromoNlCompose: '口語創建',
    ecosystemMallBillingPromoNlComposeTitle: '用自然語言描述優惠',
    ecosystemMallBillingPromoNlComposeHint: '例如：品牌 1119 加購 Track B 減 1000 元，領券後 30 天有效。解析後請在表單確認再保存。',
    ecosystemMallBillingPromoNlComposePh: '口述優惠玩法、對象、核銷範圍與有效期…',
    ecosystemMallBillingPromoNlComposeParse: '解析預覽',
    ecosystemMallBillingPromoNlComposeApply: '填入表單',
    ecosystemMallBillingPromoNlComposeSummary: '解析摘要',
    ecosystemMallBillingPromoNlComposeConfidence: '置信度',
    ecosystemMallBillingPromoNlComposeWarnings: '待確認',
    ecosystemMallBillingPromoEditCampaign: '編輯活動',
    ecosystemMallBillingPromoTabCampaigns: '促銷活動',
    ecosystemMallBillingPromoTabCoupons: '已發優惠券',
    ecosystemMallBillingPromoColName: '活動名稱',
    ecosystemMallBillingPromoColKind: '活動類型',
    ecosystemMallBillingPromoColOffer: '優惠方式',
    ecosystemMallBillingPromoColAudience: '適用對象',
    ecosystemMallBillingPromoColStatus: '狀態',
    ecosystemMallBillingPromoColCouponCode: '優惠券編號',
    ecosystemMallBillingPromoColCampaign: '所屬活動',
    ecosystemMallBillingPromoColIssued: '發放時間',
    ecosystemMallBillingPromoActivate: '啟用',
    ecosystemMallBillingPromoPause: '暫停',
    ecosystemMallBillingPromoIssue: '發券',
    ecosystemMallBillingPromoRevoke: '作廢',
    ecosystemMallBillingPromoManualIssue: '手動發券',
    ecosystemMallBillingPromoBrandId: '品牌商',
    ecosystemMallBillingPromoBrandIdPh: '請輸入品牌商編號',
    ecosystemMallBillingPromoBrandIds: '指定品牌商',
    ecosystemMallBillingPromoBrandIdsHint: '多個編號請用逗號分隔',
    ecosystemMallBillingPromoFilterCampaign: '篩選活動',
    ecosystemMallBillingPromoFilterStatus: '狀態篩選',
    ecosystemMallBillingPromoSearch: '搜尋',
    ecosystemMallBillingPromoOfferPct: '折扣比例（%）',
    ecosystemMallBillingPromoCampaignValidity: '活動有效期',
    ecosystemMallBillingPromoCouponValidity: '優惠券有效期',
    ecosystemMallBillingPromoRelativeDays: '發券後有效天數',
    ecosystemMallBillingPromoNamePh: '例如：新客首年八折',
    ecosystemMallBillingPromoNameRequired: '請填寫活動名稱',
    ecosystemMallBillingPromoEmpty: '暫無資料',
    ecosystemMallBillingPromoSaved: '活動已保存',
    ecosystemMallBillingPromoIssued: '優惠券已發放',
    ecosystemMallBillingPromoRevoked: '優惠券已作廢',
    ecosystemMallBillingPromoStatusUpdated: '活動狀態已更新',
    ecosystemMallBillingPromoEnum_status_ALL: '全部',
    ecosystemMallBillingPromoEnum_status_DRAFT: '草稿',
    ecosystemMallBillingPromoEnum_status_ACTIVE: '進行中',
    ecosystemMallBillingPromoEnum_status_PAUSED: '已暫停',
    ecosystemMallBillingPromoEnum_status_ARCHIVED: '已歸檔',
    ecosystemMallBillingPromoEnum_status_EXPIRED: '已過期',
    ecosystemMallBillingPromoEnum_couponStatus_ALL: '全部',
    ecosystemMallBillingPromoEnum_couponStatus_ISSUED: '已發放',
    ecosystemMallBillingPromoEnum_couponStatus_REDEEMED: '已核銷',
    ecosystemMallBillingPromoEnum_couponStatus_EXPIRED: '已過期',
    ecosystemMallBillingPromoEnum_couponStatus_REVOKED: '已作廢',
    ecosystemMallBillingPromoEnum_kind_STANDARD_PACK: '標準套餐',
    ecosystemMallBillingPromoEnum_kind_SEASONAL: '限期大促',
    ecosystemMallBillingPromoEnum_kind_TARGETED: '定向大客戶',
    ecosystemMallBillingPromoEnum_kind_AI_ORCHESTRATED: '智能推廣',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_PCT: '百分比折扣',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_FIXED: '固定金額減免',
    ecosystemMallBillingPromoEnum_offer_BUNDLE_PRICE_CAP: '打包封頂價',
    ecosystemMallBillingPromoEnum_offer_FREE_TRIAL_EXTEND: '延長試用',
    ecosystemMallBillingPromoEnum_offer_CROSS_GRANT: '交叉贈券',
    ecosystemMallBillingPromoEnum_offer_AI_POINTS_BONUS: '贈送 AI 點數',
    ecosystemMallBillingPromoEnum_audience_ALL_ELIGIBLE_BRANDS: '全部合格品牌商',
    ecosystemMallBillingPromoEnum_audience_BRAND_ALLOWLIST: '指定品牌白名單',
    ecosystemMallBillingPromoEnum_audience_BRAND_DENYLIST: '黑名單排除',
    ecosystemMallBillingPromoEnum_audience_PORTRAIT_QUERY: '依客戶畫像',
    ecosystemMallBillingPromoEnum_audience_AI_AGENT: '智能圈選',
    ecosystemMallBillingPromoEnum_audience_HYBRID: '規則與智能混合',
    ecosystemMallBillingPromoEnum_campaignValidity_PERMANENT: '永久有效',
    ecosystemMallBillingPromoEnum_campaignValidity_FIXED_WINDOW: '固定時段',
    ecosystemMallBillingPromoEnum_couponValidity_PERMANENT_UNTIL_REDEEMED: '永久（至核銷）',
    ecosystemMallBillingPromoEnum_couponValidity_RELATIVE_FROM_ISSUE: '發券後 N 天',
    ecosystemMallBillingPromoEnum_couponValidity_INHERIT_CAMPAIGN: '跟隨活動期',
    ecosystemMallBillingPromoSectionOffer: '優惠配置',
    ecosystemMallBillingPromoSectionAudience: '精準客群',
    ecosystemMallBillingPromoSectionCrossSell: '連帶推銷',
    ecosystemMallBillingPromoRedeemTarget: '核銷範圍',
    ecosystemMallBillingPromoGrantScope: '發券綁定',
    ecosystemMallBillingPromoTriggerEvent: '自動觸發',
    ecosystemMallBillingPromoAutoIssue: '達成條件後自動發券',
    ecosystemMallBillingPromoTracksMissing: '缺檔產品線（交叉促銷）',
    ecosystemMallBillingPromoUserIds: '指定帳號',
    ecosystemMallBillingPromoUserIdsHint: '多個使用者編號以逗號分隔，千人千面精準發券',
    ecosystemMallBillingPromoColGrantScope: '綁定範圍',
    ecosystemMallBillingPromoColUser: '指定帳號',
    ecosystemMallBillingPromoColRedeemTarget: '核銷於',
    ecosystemMallBillingPromoUserIdPh: '請輸入使用者編號（可選）',
    ecosystemMallBillingPromoOfferFixed: '減免金額',
    ecosystemMallBillingPromoTrialDays: '延長試用（天）',
    ecosystemMallBillingPromoBonusPoints: '贈送 AI 點數',
    ecosystemMallBillingPromoBundleCap: '打包封頂價',
    ecosystemMallBillingPromoBundleSkus: '打包 SKU',
    ecosystemMallBillingPromoCrossGrantSku: '交叉贈送 SKU',
    ecosystemMallBillingPromoCrossGrantHint: '例：已開 Track B 可發設備／Leo 加購券，支援硬體＋軟體連帶',
    ecosystemMallBillingPromoEnum_audience_USER_ALLOWLIST: '指定帳號白名單',
    ecosystemMallBillingPromoEnum_redeemTarget_ANY_BILLING_CHECKOUT: '合併結帳台',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_A_CONTRACT: 'Track A 設備數據合同',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_B_ADDON: 'Track B SOC／Leo 加購',
    ecosystemMallBillingPromoEnum_redeemTarget_HARDWARE_ORDER: '硬體採購單',
    ecosystemMallBillingPromoEnum_grantScope_BRAND: '品牌商共享',
    ecosystemMallBillingPromoEnum_grantScope_ENTERPRISE_NODE: '組織節點',
    ecosystemMallBillingPromoEnum_grantScope_STORE: '單店',
    ecosystemMallBillingPromoEnum_grantScope_USER: '指定帳號獨享',
    ecosystemMallBillingPromoEnum_grantScope_PORTRAIT_COHORT: '畫像分群',
    ecosystemMallBillingPromoEnum_trigger_MANUAL_HQ: 'HQ 手動',
    ecosystemMallBillingPromoEnum_trigger_TRACK_A_ACTIVE: 'Track A 簽約生效',
    ecosystemMallBillingPromoEnum_trigger_TRACK_B_ACTIVE: 'Track B 加購生效',
    ecosystemMallBillingPromoEnum_trigger_HARDWARE_PAID: '硬體付款完成',
    ecosystemMallBillingPromoEnum_trigger_AI_ISSUE: '智能推廣發券',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_A: '尚未開通 Track A',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_B: '尚未開通 Track B',
    mySubscriptionPlan: '我的方案',
    mySubscriptionPlanDesc: '已簽檔位摘要與 A/B 線說明；簽約與付款走簽約台，價格與促銷見生態商城。',
    mySubscriptionPlanGoContract: '開啟簽約台',
    mySubscriptionPlanGoMall: '去商城看價格',
    mySubscriptionPlanGoPriceBook: 'HQ 價目表',
    mySubscriptionPlanTiersTitle: '四檔月費（USD）',
    mySubscriptionPlanTierCol: '檔',
    mySubscriptionPlanSceneCol: '適用場景',
    mySubscriptionPlanPriceCol: '月費',
    mySubscriptionPlanTrackCol: 'Track',
    mySubscriptionPlanTier1Scene: '純 SOC，無自動生產設備',
    mySubscriptionPlanTier2Scene: '全店打包（SOC + 全部自動生產設備，台數不限）',
    mySubscriptionPlanTier3Scene: '純設備數據，不含 SOC 店務',
    mySubscriptionPlanTier3Price: '按台月費（茶/咖/飲料 $10，PT5 $5）',
    mySubscriptionPlanTier4Scene: 'SOC + 設備（非 $199 全店打包）',
    mySubscriptionPlanHint: '② 與 ④ 同店互斥；實際簽約以簽約台為準；標價與促銷以生態商城為準。',
    subscriptionBillingFolder: '訂閱與帳單',
    deviceEndpointDataFolder: '機端數據',
    mallPricingCollectFolder: '定價與收款',
    ecosystemMallPriceBookDesc: '加購與家用硬體標價真源。僅東京 HQ 可改未稅價／稅區；本區若為邊緣則只讀鏡像。PayPal 用 USD，微信用 CNY。',
    ecosystemMallPriceBookEdgeBanner: '改價由東京總部全球統一。本區只讀鏡像；東京不可用時賣場以最後一次扇出為準，禁止在本區新增或改價。',
    ecosystemMallPriceBookTokyoBanner: '本區是全球寫入中心。保存未稅標價／稅區後會扇出到 111 與已跟讀產區。',
    ecosystemMallPriceBookReload: '重新載入',
    ecosystemMallPriceBookRefreshFx: '刷新匯率',
    ecosystemMallPriceBookFxNote: '匯率 {asOf} · {src}（1 USD）',
    ecosystemMallPriceBookFxTaxPanel: '匯率與稅區 · {fx} · 稅區 {taxCount} 條',
    ecosystemMallPriceBookFxSection: 'USD 匯率',
    ecosystemMallPriceBookStale: '匯率超過 48 小時未刷新，請點刷新或等每日自動拉取',
    ecosystemMallPriceBookCoverageGap: '尚有 {count} 項功能或設備未在價目表定價（OFF/缺價），簽約與加購將被攔截，請補價並啟用',
    ecosystemMallPriceBookCcy: '幣種',
    ecosystemMallPriceBookRatePerUsd: '對 1 USD',
    ecosystemMallPriceBookSkus: 'SKU 標價',
    ecosystemMallPriceBookKind: '類型',
    ecosystemMallPriceBookSku: 'SKU',
    ecosystemMallPriceBookName: '名稱',
    ecosystemMallPriceBookList: '標價',
    ecosystemMallPriceBookListExTax: '標價（未稅）',
    ecosystemMallPriceBookExTaxBanner: '全球一套未稅標價；各地稅點在「稅區」維護，簽約報價時再加稅。',
    ecosystemMallPriceBookTaxRegions: '節點稅區（本地加稅）',
    ecosystemMallPriceBookTaxRegionsHint: '價目表不含稅。CN=軟件服務6%，CN_HW=硬件貨物13%；報價選稅區後自動加稅。',
    ecosystemMallPriceBookTaxRegionCode: '稅區碼',
    ecosystemMallPriceBookTaxRegionName: '稅區名稱',
    ecosystemMallPriceBookTaxName: '稅種',
    ecosystemMallPriceBookTaxRate: '稅率',
    ecosystemMallPriceBookTaxNotes: '備註',
    ecosystemMallPriceBookTaxEditTitle: '編輯稅區',
    ecosystemMallPriceBookLoadFail: '載入失敗（須超管）',
    ecosystemMallPriceBookRefreshOk: '匯率已更新',
    ecosystemMallPriceBookRefreshFail: '匯率刷新失敗',
    ecosystemMallPriceBookAdd: '新增',
    ecosystemMallPriceBookEdit: '編輯',
    ecosystemMallPriceBookSave: '保存',
    ecosystemMallPriceBookSaveOk: '已保存',
    ecosystemMallPriceBookSaveFail: '保存失敗',
    ecosystemMallPriceBookKindAddon: '加購',
    ecosystemMallPriceBookKindHome: '家用硬體',
    ecosystemMallPriceBookKindCommercial: '商用硬體',
    ecosystemMallPriceBookListCcy: '標價幣',
    ecosystemMallPriceBookListedHkd: '目錄 HKD',
    ecosystemMallPriceBookColumnPricing: '計費',
    ecosystemMallPriceBookPricingSection: '計價方式',
    ecosystemMallPriceBookPaymentSection: '付款模板',
    ecosystemMallPriceBookProductClass: '產品類',
    ecosystemMallPriceBookProductSoc: 'SOC 軟件',
    ecosystemMallPriceBookProductDeviceData: '設備數據／後台',
    ecosystemMallPriceBookProductHardware: '硬件本體',
    ecosystemMallPriceBookProductAiPoints: 'AI 點數',
    ecosystemMallPriceBookBillingCycle: '計費週期',
    ecosystemMallPriceBookUnitPrice: '單價',
    ecosystemMallPriceBookMinContractMonths: '最少簽約月數',
    ecosystemMallPriceBookDayCountHint: '按天現結',
    ecosystemMallPriceBookDayCountHintBody: '簽約時填使用天數；價目表只定「每天單價」。',
    ecosystemMallPriceBookTiers: '階梯價',
    ecosystemMallPriceBookDeviceCountTiers: '台數階梯折扣',
    ecosystemMallPriceBookDeviceCountTiersHint: '單台底價依本行標價；各檔折扣相對底價。未設單價視為 0。',
    ecosystemMallPriceBookDeviceCountTierBand: '檔位',
    ecosystemMallPriceBookDeviceCountTierMin: '最少台',
    ecosystemMallPriceBookDeviceCountTierMax: '最多台',
    ecosystemMallPriceBookDeviceCountTierDiscount: '折扣係數',
    ecosystemMallPriceBookDeviceCountTierNegotiated: '總部協商',
    ecosystemMallPriceBookDeviceCountTierReset: '恢復標準五檔',
    ecosystemMallPriceBookStoreCountTiers: '店數階梯折扣',
    ecosystemMallPriceBookStoreCountTiersHint: '單店底價按本行標價；各檔折扣相對底價。0 店＝0 元。',
    ecosystemMallPriceBookStoreCountTierBand: '檔位',
    ecosystemMallPriceBookStoreCountTierMin: '最少店',
    ecosystemMallPriceBookStoreCountTierMax: '最多店',
    ecosystemMallPriceBookStoreCountTierDiscount: '折扣係數',
    ecosystemMallPriceBookStoreCountTierNegotiated: '總部協商',
    ecosystemMallPriceBookStoreCountTierReset: '恢復標準五檔',
    ecosystemMallPriceBookAddTier: '加階梯',
    ecosystemMallPriceBookRemoveTier: '刪除',
    ecosystemMallPriceBookTrialDays: '試用天數',
    ecosystemMallPriceBookCancelAnytime: '隨時可取消',
    ecosystemMallPriceBookDefaultPayment: '默認付款',
    ecosystemMallPriceBookPayNet: '放賬',
    ecosystemMallPriceBookPayPrepaid: '預付全款',
    ecosystemMallPriceBookPayDeposit: '定金+尾款',
    ecosystemMallPriceBookPayInstallment: '分期',
    ecosystemMallPriceBookDepositPct: '訂金比例%',
    ecosystemMallPriceBookStatus: '狀態',
    ecosystemMallPriceBookStatusActive: '啟用',
    ecosystemMallPriceBookStatusOff: '停用',
    ecosystemMallPriceBookNameZh: '簡中名',
    ecosystemMallPriceBookNameTw: '繁中名',
    ecosystemMallPriceBookNameEn: '英文名',
    ecosystemMallPriceBookNameJa: '日文名',
    ecosystemMallPriceBookCancel: '取消',
    ecosystemMallPriceBookFilterPreset: '快捷篩選',
    ecosystemMallPriceBookPresentationTab: '客戶分塊 L0–L6',
    ecosystemMallPriceBookPresentationTabAll: '全部',
    ecosystemMallPriceBookBlock_FREE_INCLUDED: 'L0 · 買機已含',
    ecosystemMallPriceBookBlock_BUNDLE_TIER: 'L1 · 月費套餐',
    ecosystemMallPriceBookBlock_TRACK_A: 'L2 · 設備數據',
    ecosystemMallPriceBookBlock_TRACK_B: 'L3 · 店鋪運營',
    ecosystemMallPriceBookBlock_BUNDLE_DISCOUNT: 'L4 · 組合說明',
    ecosystemMallPriceBookBlock_HARDWARE: 'L5 · 硬體',
    ecosystemMallPriceBookBlock_AI_POINTS: 'L6 · 消耗點數',
    ecosystemMallPriceBookBlockDesc_FREE_INCLUDED: '買機／開店已含：Leo 基礎、基礎店務可見，不另收月費。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_TIER: '四檔月費套餐：客戶先選買法，再對應下方 SKU 標價。',
    ecosystemMallPriceBookBlockDesc_TRACK_A: 'Track A · 按台設備數據／連雲月費（茶機、咖啡機等）。',
    ecosystemMallPriceBookBlockDesc_TRACK_B: 'Track B · 按店／模組的 SOC 店務加購（店務進階、總部、金流等）。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_DISCOUNT: '套餐互斥與升級規則：② 全店打包 vs ④ SOC+按台 同店只能二選一。',
    ecosystemMallPriceBookBlockDesc_HARDWARE: '一次性硬體採購標價（非月費）。',
    ecosystemMallPriceBookBlockDesc_AI_POINTS: 'AI 點數等按量消耗包。',
    ecosystemMallPriceBookBundleColTier: '檔',
    ecosystemMallPriceBookBundleColPlan: '套餐',
    ecosystemMallPriceBookBundleColScenario: '客戶場景',
    ecosystemMallPriceBookBundleColIncludes: '含什麼',
    ecosystemMallPriceBookBundleT1Title: '① 純 SOC $49/店/月',
    ecosystemMallPriceBookBundleT1Desc: '要用店務／SOC，店內沒有自動生產設備',
    ecosystemMallPriceBookBundleT1Includes: '標準 SOC 運營模組；不含 A 線設備數據',
    ecosystemMallPriceBookBundleT2Title: '② 全店打包 $199/店/月',
    ecosystemMallPriceBookBundleT2Desc: '店內有自動生產設備（現制飲品等），台數不限',
    ecosystemMallPriceBookBundleT2Includes: 'SOC + 該店所有自動生產設備數據費（同一店內台數不限）',
    ecosystemMallPriceBookBundleT3Title: '③ 純設備按台',
    ecosystemMallPriceBookBundleT3Desc: '只要機器連雲，不要 SOC 店務包',
    ecosystemMallPriceBookBundleT3Includes: '僅 A 線設備數據月費；不含 SOC',
    ecosystemMallPriceBookBundleT3PriceHint: '按台標準月費（見右側 SKU）',
    ecosystemMallPriceBookBundleT4Title: '④ SOC $99 + 按台',
    ecosystemMallPriceBookBundleT4Desc: '既要 SOC 又要設備，但不走 $199 全店打包',
    ecosystemMallPriceBookBundleT4Includes: 'SOC 基礎 $99/店/月 + 每台設備數據費另計',
    ecosystemMallPriceBookBundleRuleT2T4Title: '② 與 ④ 同店互斥',
    ecosystemMallPriceBookBundleRuleT2T4Body: '同一店、同一賬期只能選一種：要麼 $199 全包，要麼 $99 底費 + 按台加計；不可疊加。',
    ecosystemMallPriceBookBundleRuleUpgradeTitle: '升級路徑',
    ecosystemMallPriceBookBundleRuleUpgradeBody: '① 純 SOC 後來接自動生產設備 → 須升級到 ④ 或 ②；③ 純設備加購 SOC → 轉 ④ 或（若符合）②。',
    ecosystemMallPriceBookBundleRulePromoTitle: '① 推廣價',
    ecosystemMallPriceBookBundleRulePromoBody: '$49 為推廣期標價；Campaign 結束可恢復標準價（HQ 價目表另列）。',
    ecosystemMallPriceBookBundleRuleDeviceScopeTitle: '② $199 含哪些設備',
    ecosystemMallPriceBookBundleRuleDeviceScopeBody: '計入全包：茶機、咖啡機、飲料機、攪拌、Maestro 等自動現制設備；不含 kiosk／廣告屏／收銀／排號／車機等；雲瞳等 B 線加購另議。',
    ecosystemMallPriceBookQuoteSectionTab: '報價區塊',
    ecosystemMallPriceBookQuoteTabAll: '全部',
    ecosystemMallPriceBookQuoteTabA: '塊 A · 設備數據',
    ecosystemMallPriceBookQuoteTabB: '塊 B · 店務運營',
    ecosystemMallPriceBookQuoteTabC: '塊 C · 組合套餐',
    ecosystemMallPriceBookQuoteTabOther: '硬體／點數',
    ecosystemMallPriceBookQuoteSectionCol: '報價區塊',
    ecosystemMallPriceBookQuoteSection_TRACK_A_DEVICE_DATA: 'A · 設備數據',
    ecosystemMallPriceBookQuoteSection_TRACK_B_STORE_OPS: 'B · 店務',
    ecosystemMallPriceBookQuoteSection_TRACK_B_HQ: 'B · 總部',
    ecosystemMallPriceBookQuoteSection_TRACK_B_ANALYTICS: 'B · 分析',
    ecosystemMallPriceBookQuoteSection_TRACK_B_INTEGRATION: 'B · 整合',
    ecosystemMallPriceBookQuoteSection_TRACK_B_DEVICE_ADDON: 'B · 設備加購',
    ecosystemMallPriceBookQuoteSection_BUNDLE_FULL_STACK: 'C · 全店打包',
    ecosystemMallPriceBookQuoteSection_HARDWARE: '硬體',
    ecosystemMallPriceBookQuoteSection_AI_POINTS: 'AI 點數',
    ecosystemMallPriceBookQuoteSection_FREE_INCLUDED: '買機已含',
    ecosystemMallPriceBookFilterSearch: '搜尋',
    ecosystemMallPriceBookFilterSearchPh: 'SKU／名稱／關鍵字',
    ecosystemMallPriceBookFilterSegment: '客群',
    ecosystemMallPriceBookFilterSegmentAll: '全部客群',
    ecosystemMallPriceBookSegmentHome: '家用',
    ecosystemMallPriceBookSegmentCommercial: '商用',
    ecosystemMallPriceBookSegmentAll: '通用',
    ecosystemMallPriceBookFilterCategory: '產品族',
    ecosystemMallPriceBookFilterCategoryAll: '全部產品族',
    ecosystemMallPriceBookCatHomeHardware: '家用硬體',
    ecosystemMallPriceBookCatHomeAddon: '家用附加包',
    ecosystemMallPriceBookCatCommercialHardware: '商用硬體',
    ecosystemMallPriceBookCatCommercialStoreOps: '店務模組',
    ecosystemMallPriceBookCatCommercialHq: '總部多店',
    ecosystemMallPriceBookCatCommercialIntegration: '金流整合',
    ecosystemMallPriceBookCatCommercialAiData: 'AI／數據',
    ecosystemMallPriceBookCatCommercialOther: '商用其他',
    ecosystemMallPriceBookCatAiPoints: 'AI 點數包',
    ecosystemMallPriceBookCatUniversal: '通用加購',
    ecosystemMallPriceBookCatOther: '其他',
    ecosystemMallPriceBookFilterStatusAll: '全部狀態',
    ecosystemMallPriceBookFilterKindAll: '全部類型',
    ecosystemMallPriceBookFilterCurrencyAll: '全部幣別',
    ecosystemMallPriceBookFilterPricing: '計費方式',
    ecosystemMallPriceBookFilterPricingAll: '全部計費',
    ecosystemMallPriceBookFilterPriceBand: '價格帶',
    ecosystemMallPriceBookFilterPriceBandAll: '全部價格',
    ecosystemMallPriceBookPriceBandFree: '免費（0元）',
    ecosystemMallPriceBookPriceBandLow: '入門（<500 CNY）',
    ecosystemMallPriceBookPriceBandMid: '標準（500–3000）',
    ecosystemMallPriceBookPriceBandHigh: '高階（>3000）',
    ecosystemMallPriceBookFilterClear: '清除篩選',
    ecosystemMallPriceBookFilterSelectAll: '全選',
    ecosystemMallPriceBookFilterClearAll: '清空',
    ecosystemMallPriceBookFilterMultiAll: '全部（可多選）',
    ecosystemMallPriceBookFilterResult: '顯示 {shown}／{total} 項',
    ecosystemMallPriceBookPresetAll: '全部',
    ecosystemMallPriceBookPresetHomeHardware: '家用硬體',
    ecosystemMallPriceBookPresetHomeAddon: '家用附加包',
    ecosystemMallPriceBookPresetCommercialHardware: '商用硬體',
    ecosystemMallPriceBookPresetCommercialSoftware: '商用軟體模組',
    ecosystemMallPriceBookPresetAiPoints: 'AI 點數包',
    ecosystemMallPriceBookPresetActiveOnly: '僅啟用',
    ecosystemMallPriceBookColumnSegment: '客群',
    ecosystemMallPriceBookColumnCategory: '產品族',
    ecosystemMallPriceBookPricingTrialThenPaid: '試用後付費',
    ecosystemMallPriceBookPricingAiPointsPack: 'AI 點數包',
    ecosystemMallPriceBookPricingPerDeviceYear: '按設備／年',
    ecosystemMallPriceBookPricingPerDeviceMonth: '按台／月',
    ecosystemMallPriceBookPricingPerDeviceDay: '按台／天（現結）',
    ecosystemMallPriceBookPricingPerDevicePeriod: '按台／期',
    ecosystemMallPriceBookPricingPerStoreMonth: '按店／月',
    ecosystemMallPriceBookPricingPerStoreDay: '按店／天（現結）',
    ecosystemMallPriceBookPricingTieredAnnualPool: '年費台數階梯',
    ecosystemMallPriceBookPricingSocStoreSubscription: 'SOC 按店訂閱',
    ecosystemMallPriceBookDeviceScope: '計費範圍',
    ecosystemMallPriceBookDeviceFamily: '設備族',
    ecosystemMallPriceBookModelKey: '型號代碼',
    ecosystemMallPriceBookModelKeyPh: '如 PT5、X600H（與設備族二選一或填型號優先）',
    ecosystemMallPriceBookModelKeyShort: '型號 {key}',
    ecosystemMallPriceBookDeviceScopeHint: '設備數據費須指定設備族或型號，簽約時才會按對應台數計價。',
    ecosystemMallPriceBookDeviceScopeRequired: '請填設備族或型號代碼',
    ecosystemMallPriceBookDeviceFamilyTeaMachine: '泡茶機',
    ecosystemMallPriceBookDeviceFamilyCoffeeMachine: '咖啡機',
    ecosystemMallPriceBookDeviceFamilyDispenser: '飲料機',
    ecosystemMallPriceBookDeviceFamilyKiosk: '點餐機',
    ecosystemMallPriceBookDeviceFamilySignage: '廣告屏',
    ecosystemMallPriceBookPricingPerStoreYear: '按店／年',
    ecosystemMallPriceBookPricingPerHouseholdYear: '按家庭／年',
    ecosystemMallPriceBookPricingOneTimeSku: '一次性',
    ecosystemMallPriceBookPricingModuleAddon: '模組加購',
    ecosystemMallPriceBookPricingCustomQuote: '專案報價',
    ecosystemMallCommerceMatrix: '商業全景',
    ecosystemMallCommerceMatrixDesc: 'SKU 域包、菜單歸類、標價與健康檢查；未歸類頁對租戶不可見。',
    ecosystemMallCommerceMatrixEdgeBanner: '掛包／新增域包由東京總部全球統一。本區只讀鏡像；東京不可用時以最後一次扇出為準，禁止在本區新增。',
    ecosystemMallCommerceMatrixTokyoBanner: '本區是全球寫入中心。綁菜單／標受眾／新增域包後會扇出到 111 與已跟讀產區。',
    ecosystemMallCommerceMatrixReload: '重新載入',
    ecosystemMallCommerceMatrixOpenPriceBook: '價目表',
    ecosystemMallCommerceMatrixBlockerHint: '存在未歸類或缺價項，請先治理後再對外。',
    ecosystemMallCommerceMatrixPassHint: '商業化矩陣健康檢查通過。',
    ecosystemMallCommerceMatrixHealthSummary: '未歸類頁 {unassigned} · 阻斷 {blockers} · 架構不一致 {archMismatch}',
    ecosystemMallCommerceMatrixArchMismatchHint: '有 {n} 個域包 SKU 與價目表 product_class／quote_section 不一致，請在價目表修正架構欄。',
    ecosystemMallCommerceMatrixArchMismatchShort: '架構不一致',
    ecosystemMallCommerceMatrixArchCols: '架構欄',
    ecosystemMallCommerceMatrixArchWriteNote: '架構欄（product_class／quote_section）僅能在「價目表」修改；本頁只改金額／綁菜單／新增域包。',
    ecosystemMallCommerceMatrixSkuSection: 'SKU 域包',
    ecosystemMallCommerceMatrixTreeSection: '菜單權限樹 · 商業全景（與側欄對齊）',
    ecosystemMallCommerceMatrixOrphanSkuSection: '未綁定菜單的 SKU',
    ecosystemMallCommerceMatrixMenuSection: '菜單歸類（僅頁面）',
    ecosystemMallCommerceMatrixTier: '層級',
    ecosystemMallCommerceMatrixMenuCount: '菜單數',
    ecosystemMallCommerceMatrixMenuNames: '含菜單',
    ecosystemMallCommerceMatrixTrialDays: '試用天',
    ecosystemMallCommerceMatrixHealth: '健康',
    ecosystemMallCommerceMatrixAudience: '受众',
    ecosystemMallCommerceMatrixMenuName: '名稱',
    ecosystemMallCommerceMatrixActions: '操作',
    ecosystemMallCommerceMatrixFilterAll: '全部',
    ecosystemMallCommerceMatrixFilterBlocker: '阻斷',
    ecosystemMallCommerceMatrixFilterUnassigned: '未歸類',
    ecosystemMallCommerceMatrixFilterInternal: '內部',
    ecosystemMallCommerceMatrixLoadFail: '載入失敗（須超管）',
    ecosystemMallCommerceMatrixFilterKeyword: '關鍵字',
    ecosystemMallCommerceMatrixFilterKeywordPh: 'SKU／名稱／域包',
    ecosystemMallCommerceMatrixFilterReset: '重置',
    ecosystemMallCommerceMatrixFilterResultCount: '顯示 {shown}／{total}',
    ecosystemMallCommerceMatrixFilterHealth: '健康',
    ecosystemMallCommerceMatrixFilterTier: '層級',
    ecosystemMallCommerceMatrixFilterSegment: '分段',
    ecosystemMallCommerceMatrixFilterPriceStatus: '標價',
    ecosystemMallCommerceMatrixFilterPriceHas: '有標價',
    ecosystemMallCommerceMatrixFilterPriceMissing: '缺標價',
    ecosystemMallCommerceMatrixFilterCurrency: '幣別',
    ecosystemMallCommerceMatrixFilterDomain: '域包',
    ecosystemMallCommerceMatrixFilterPillar: '根柱',
    ecosystemMallCommerceMatrixFilterAudience: '受众',
    ecosystemMallCommerceMatrixFilterSkuBinding: 'SKU 綁定',
    ecosystemMallCommerceMatrixFilterSkuHas: '已綁 SKU',
    ecosystemMallCommerceMatrixFilterSkuNo: '未綁 SKU',
    ecosystemMallCommerceMatrixFilterHealthOk: '正常',
    ecosystemMallCommerceMatrixFilterHealthWarn: '警告',
    ecosystemMallCommerceMatrixFilterHealthBlocker: '阻斷',
    ecosystemMallCommerceMatrixFilterAudienceBrandOps: '品牌營運',
    ecosystemMallCommerceMatrixFilterUnassigned: '未歸類',
    ecosystemMallCommerceMatrixPillarSystem: '系統設置',
    ecosystemMallCommerceMatrixPillarDevice: '設備·XHM',
    ecosystemMallCommerceMatrixPillarSoc: '營運·SOC',
    ecosystemMallCommerceMatrixPillarLeo: 'Leo',
    ecosystemMallCommerceMatrixPillarMall: '生態商城',
    ecosystemMallCommerceMatrixPillarOther: '其他',
    ecosystemMallCommerceMatrixDomain: '域包',
    ecosystemMallCommerceMatrixSegment: '分段',
    ecosystemMallCommerceMatrixBindTarget: '掛到',
    ecosystemMallCommerceMatrixBindApply: '掛入選中',
    ecosystemMallCommerceMatrixBindNeedSelect: '請先勾選菜單，再選要掛的包',
    ecosystemMallCommerceMatrixBindOk: '已掛入',
    ecosystemMallCommerceMatrixBindPolicy: '生效策略',
    ecosystemMallCommerceMatrixBindPolicyNewOnly: '僅新訂閱（推薦）',
    ecosystemMallCommerceMatrixBindPolicyGrandfather: '舊客保留打包',
    ecosystemMallCommerceMatrixBindPolicyImmediate: '立即全量（高風險）',
    ecosystemMallCommerceMatrixCreateDomain: '新增域包',
    ecosystemMallStartUnifyPipeline: '開始標準流水線',
    ecosystemMallGovernanceGapJump: '整治缺口',
    ecosystemMallCommerceMatrixCreateDomainHint: '新增安全；改選單進出預設僅新訂閱生效，已購客戶權限不變。',
    ecosystemMallCommerceMatrixCreateDomainEnName: '域英文名',
    ecosystemMallCommerceMatrixCreateDomainQuoteSection: '報價分塊',
    ecosystemMallCommerceMatrixCreateDomainProductClass: '產品類',
    ecosystemMallCommerceMatrixCreateDomainNeed: '請完成必填項（選單／域名／柱）',
    ecosystemMallCommerceMatrixCreateDomainOk: '域包已建立',
    ecosystemMallCommerceMatrixCreateDomainOkSku: '域包已建立，SKU={sku}',
    ecosystemMallCommerceMatrixCreateDomainFail: '建立域包失敗',
    ecosystemMallCommerceMatrixWizardStepMenus: '選選單',
    ecosystemMallCommerceMatrixWizardStepConfirmMenus: '確認選單',
    ecosystemMallCommerceMatrixWizardStepName: '命名',
    ecosystemMallCommerceMatrixWizardStepBilling: '週期',
    ecosystemMallCommerceMatrixWizardStepPay: '付款',
    ecosystemMallCommerceMatrixWizardStepPrice: '價格',
    ecosystemMallCommerceMatrixWizardStepDone: '確認',
    ecosystemMallCommerceMatrixWizardPickMenusHint: '像授權樹一樣勾選要打進本域包的選單頁（須同一柱）。',
    ecosystemMallCommerceMatrixWizardSelectedCount: '已選 {n} 個選單頁',
    ecosystemMallCommerceMatrixWizardPillar: '柱：{pillar}',
    ecosystemMallCommerceMatrixWizardNameZh: '顯示名（可選）',
    ecosystemMallCommerceMatrixWizardAutoSkuHint: 'SKU 由系統依域名自動產生，儲存時保證唯一。',
    ecosystemMallCommerceMatrixWizardBillingHint: '選擇支援的計費週期（可多選；主週期優先年＞月＞日）。',
    ecosystemMallCommerceMatrixWizardCycleDay: '天',
    ecosystemMallCommerceMatrixWizardCycleMonth: '月',
    ecosystemMallCommerceMatrixWizardCycleYear: '年',
    ecosystemMallCommerceMatrixWizardPayHint: '選擇支援的付款方式（可多選）。',
    ecosystemMallCommerceMatrixWizardPayPrepaid: '預付',
    ecosystemMallCommerceMatrixWizardPrev: '上一步',
    ecosystemMallCommerceMatrixWizardNext: '下一步',
    ecosystemMallCommerceMatrixWizardFinish: '確認建立',
    ecosystemMallCommerceMatrixWizardNeedMenus: '請先勾選至少一個選單頁',
    ecosystemMallCommerceMatrixWizardMultiPillar: '所選選單跨多個柱，請只選同一柱',
    ecosystemMallCommerceMatrixWizardNeedBilling: '請至少選一個計費週期',
    ecosystemMallCommerceMatrixWizardNeedPay: '請至少選一種付款方式',
    ecosystemMallCommerceMatrixWizardNeedPrice: '請填寫大於 0 的價格',
    ecosystemMallCommerceMatrixBindFail: '掛入失敗',
    ecosystemMallCommerceMatrixMakeFree: '改為免費',
    ecosystemMallCommerceMatrixMakeFreeConfirm: '會把此收費包內的頁面改到免費基礎包，租戶不用買也能看。確定？',
    ecosystemMallCommerceMatrixMakeFreeOk: '已改為免費',
    ecosystemMallCommerceMatrixFreeTier: '免費',
    ecosystemMallCommerceMatrixPaidTier: '收費',
    ecosystemMallCommerceMatrixBindHint: '受眾／域包列可直接改（含標內部）；勾選可批量。',
    ecosystemMallCommerceMatrixAudienceApply: '改受眾',
    ecosystemMallCommerceMatrixAudienceNeedSelect: '請先勾選頁面並選擇受眾',
    ecosystemMallCommerceMatrixAudienceOk: '受眾已更新',
    ecosystemMallCommerceMatrixAudienceFail: '受眾更新失敗',
    ecosystemMallCommerceMatrixAudienceJsonBoundWarn: '{n} 個頁面由 JSON 種子歸類，無法改為未歸類',
    ecosystemMallCommerceMatrixBatchSelected: '已選 {n} 個頁面',
    ecosystemMallCommerceMatrixClearSelection: '清除勾選',
    ecosystemMallCommerceMatrixInlineDomainPh: '選擇域包',
    ecosystemMallCommerceMatrixBindPillarMixed: '請只勾選同一柱的頁面後再批量綁域包',
    ecosystemMallCommerceMatrixBindPillarOther: '此頁未掛到五根柱，請先調整菜單樹',
    ecosystemMallCommerceMatrixBindPillarMismatch: '{n} 個頁面與域包柱不匹配，已跳過',
    ecosystemMallCommerceMatrixMenuId: '菜單 ID',
    ecosystemMallCommerceMatrixTierFreeBasic: '免費基礎包',
    ecosystemMallCommerceMatrixTierAddon: '加購包',
    ecosystemMallCommerceMatrixTierNone: '無',
    ecosystemMallCommerceMatrixAudienceInfraFolder: '基礎資料夾',
    ecosystemMallCommerceMatrixHealthOk: '正常',
    ecosystemMallCommerceMatrixHealthWarn: '警告',
    ecosystemMallCommerceMatrixHealthBlocker: '阻斷',
    ecosystemMallCommerceMatrixDomain_socMonDomainBasicOps: 'SOC 營運基礎',
    ecosystemMallCommerceMatrixDomain_socMonDomainStoreOpsPlus: '門店營運加購',
    ecosystemMallCommerceMatrixDomain_socMonDomainHqMulti: '總部多店加購',
    ecosystemMallCommerceMatrixDomain_socMonDomainPayIntegrate: '支付整合加購',
    ecosystemMallCommerceMatrixDomain_socMonDomainAnalytics: '分析 AI 加購',
    ecosystemMallCommerceMatrixDomain_socMonDomainSmartGuidePlus: '智能引導加購',
    ecosystemMallCommerceMatrixDomain_leoMonDomainBasic: 'Leo 基礎',
    ecosystemMallCommerceMatrixDomain_leoMonDomainHomeAddon: 'Leo 首頁加購',
    ecosystemMallCommerceMatrixDomain_leoMonDomainComAddon: 'Leo 組件加購',
    ecosystemMallCommerceMatrixDomain_leoMonDomainAiPoints: 'Leo AI 點數',
    ecosystemMallCommerceMatrixDomain_ecMonDomainMallBrowse: '商城瀏覽基礎',
    ecosystemMallCommerceMatrixDomain_ecMonDomainBusinessPlan: '商業計畫加購',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainBasicCenter: '設備中心基礎',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainAfterSales: '售後服務基礎',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainInCar: '車載基礎',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainHardwarePartner: '硬件夥伴基礎',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainFamilySlot: '設備族槽位',
    ecosystemMallCommerceMatrixDomain_brandServiceModeA: '簽約模式 A（設備數據）',
    ecosystemMallCommerceMatrixDomain_brandServiceModeB: '簽約模式 B（SOC/Leo 加購）',
    ecosystemMallCommerceMatrixDomain_subscriptionBillingFolder: '訂閱賬單',
    ecosystemMallCommerceMatrixDomain_deviceEndpointDataFolder: '設備端數據',
    ecosystemMallSocOpsDesc: '標準體驗包（標準收費）或定制體驗包（額外收費）。定制需先確認人力／設備／模組／權限再出模擬包。',
    ecosystemMallSocOpsToDevices: '設備星圖',
    ecosystemMallSocOpsFullSim: '看完整一天',
    ecosystemMallSocOpsPlayDay: '一鍵播一天',
    ecosystemMallSocOpsDayPlaying: '演示中…',
    ecosystemMallSocOpsDayLabel: '一天怎麼轉',
    ecosystemMallSocOpsRailCup: '杯',
    ecosystemMallSocOpsRailCupHint: '下單→出杯→取貨',
    ecosystemMallSocOpsRailStock: '料',
    ecosystemMallSocOpsRailStockHint: '做一杯扣一點，缺了建議補',
    ecosystemMallSocOpsRailPeople: '人',
    ecosystemMallSocOpsRailPeopleHint: '引導與總部協同',
    ecosystemMallSocOpsRailCash: '錢',
    ecosystemMallSocOpsRailCashHint: '支付、分析與情報',
    ecosystemMallSocOpsRailMore: '其他模組',
    ecosystemMallSocOpsMode: '呈現方式',
    ecosystemMallSocOpsModeTopo: '拓撲圖',
    ecosystemMallSocOpsModeList: '模組列表',
    ecosystemMallSocOpsReload: '重新載入',
    ecosystemMallSocOpsGuideToggle: '體驗包',
    ecosystemMallSocOpsGuideHide: '收起體驗包',
    ecosystemMallSocOpsPickCard: '點卡片查看這個營運域能替店做什麼。',
    ecosystemMallSocOpsPickNode: '點左側節點，看這個營運域能替店做什麼。',
    ecosystemMallSocOpsPickHint: '也可點上方「杯 / 料 / 人 / 錢」高亮對應流程。',
    ecosystemMallSocOpsYear: '年',
    ecosystemMallSocOpsInBasic: '含在基礎包',
    ecosystemMallSocOpsStartTrial: '開始試用',
    ecosystemMallSocOpsTrySim: '本域體驗',
    ecosystemMallSocOpsCombo: '組合演示',
    ecosystemMallSocOpsAddPack: '加入營運套餐',
    ecosystemMallSocOpsRemovePack: '移出套餐',
    ecosystemMallSocOpsConfirmPay: '確認開通／付費',
    ecosystemMallSocOpsPaying: '開通中…',
    ecosystemMallSocOpsMakePlan: '生成方案',
    ecosystemMallSocOpsPayOk: '已確認開通',
    ecosystemMallSocOpsPayFail: '開通失敗',
    ecosystemMallSocOpsPayNeedTrial: '請先試用後再確認開通',
    ecosystemMallSocOpsAutoHuman: '自動 vs 找人',
    ecosystemMallSocOpsAuto: '自動：',
    ecosystemMallSocOpsHuman: '找人：',
    ecosystemMallSocOpsCaps: '開了能做什麼',
    ecosystemMallSocOpsRelations: '上下游關係',
    ecosystemMallSocOpsUpstream: '依賴',
    ecosystemMallSocOpsDownstream: '驅動',
    ecosystemMallSocOpsRelNone: '無（由雲端直連）',
    ecosystemMallSocOpsDemoTitle: '本域自動流程',
    ecosystemMallSocOpsDemoClose: '收起',
    ecosystemMallSocOpsPackTitle: '營運套餐 · {n} 個域',
    ecosystemMallSocOpsPackEst: '預估年費 ¥{amount}',
    ecosystemMallSocOpsPackClear: '清空',
    ecosystemMallSocOpsPackTrial: '一鍵試用套餐',
    ecosystemMallSocOpsPackTrialOk: '已開啟 {n} 個域試用',
    ecosystemMallExpGuideTitle: '先選體驗包類型',
    ecosystemMallExpGuideSub: '標準包可直接體驗；定制包需先確認人力／設備／模組／權限，再出整店模擬包。',
    ecosystemMallExpKindStandard: '標準體驗包',
    ecosystemMallExpKindStandardHint: '固定套餐，選好就能體驗或付款開通',
    ecosystemMallExpKindCustom: '定制體驗包',
    ecosystemMallExpKindCustomHint: '先確認整店配置，再一鍵出模擬包',
    ecosystemMallExpFeeStandard: '標準收費',
    ecosystemMallExpFeeExtra: '額外收費',
    ecosystemMallExpFeeExtraHint: '定制配置與出包服務另計',
    ecosystemMallExpStepPickStandard: '① 選一個標準包',
    ecosystemMallExpStandardLineA: '按標準包試用開域並進入模擬店（設備若未自動放入，可在虛擬店補放）。',
    ecosystemMallExpStandardLineB: '按標準包付款正式開通軟件域。',
    ecosystemMallExpStaffTitle: '人力',
    ecosystemMallExpStaffHint: '確認模擬店要幾個店長、幾個店員（先記配置，不謊稱帳號已開）。',
    ecosystemMallExpDevicesTitle: '設備',
    ecosystemMallExpDevicesHint: '勾選要放入模擬店的設備。',
    ecosystemMallExpModulesTitle: '模組',
    ecosystemMallExpModulesHint: '勾選要開通試用的運營域。',
    ecosystemMallExpPermsTitle: '權限',
    ecosystemMallExpPermsHint: '選店長／店員權限預設。',
    ecosystemMallExpConfirmTitle: '確認出包',
    ecosystemMallExpConfirmHint: '核對無誤後出定制模擬包並進入體驗。',
    ecosystemMallExpManagerCount: '店長人數',
    ecosystemMallExpStaffCount: '店員人數',
    ecosystemMallExpPermsHonest: '此處只保存權限預設配置；若後端尚未開帳號，清單會標「已記錄」而非「已完成」。',
    ecosystemMallExpConfirmHonest: '出包後會顯示真實 checklist：軟件試用／模擬店／設備放置／人力與權限是否僅記錄。',
    ecosystemMallExpSumStaff: '人力：店長 {m}、店員 {s}',
    ecosystemMallExpSumDevices: '設備 {n} 台',
    ecosystemMallExpSumModules: '模組 {n} 個',
    ecosystemMallExpSumPerms: '權限預設 {n} 項',
    ecosystemMallExpPrev: '上一步',
    ecosystemMallExpNext: '下一步',
    ecosystemMallExpIssuePack: '確認並出模擬包',
    ecosystemMallExpIssuing: '出包中…',
    ecosystemMallExpIssueOk: '定制模擬包已發出，正在進入體驗',
    ecosystemMallExpIssueFail: '出包未完成（見下方清單，未謊稱成功）',
    ecosystemMallExpDraftInvalid: '請先完成人力／設備／模組／權限勾選',
    ecosystemMallExpChecklistTitle: '出包結果（誠實狀態）',
    ecosystemMallExpCheckModules: '軟件模組試用',
    ecosystemMallExpCheckStore: '模擬店工作區',
    ecosystemMallExpCheckDevices: '設備放入模擬店',
    ecosystemMallExpCheckStaff: '店長／店員配置',
    ecosystemMallExpCheckStaffHonest: '配置已記錄；帳號開通需後端能力，前端不虛報已開好',
    ecosystemMallExpCheckPerms: '權限預設配置',
    ecosystemMallExpCheckPermsHonest: '權限預設已記錄；未等同角色已授權完成',
    ecosystemMallExpStatusDone: '已完成',
    ecosystemMallExpStatusRecorded: '已記錄（待後端）',
    ecosystemMallExpStatusFailed: '失敗',
    ecosystemMallExpStatusPending: '待操作',
    ecosystemMallExpStatusSkipped: '未處理',
    ecosystemMallExpModOrder: '訂單',
    ecosystemMallExpModProduce: '出杯',
    ecosystemMallExpModPickup: '取貨',
    ecosystemMallExpModStock: '庫存',
    ecosystemMallExpModPay: '支付',
    ecosystemMallExpModHq: '總部',
    ecosystemMallExpModGuide: '引導',
    ecosystemMallExpModAnalytics: '分析',
    ecosystemMallExpModIntel: '情報',
    ecosystemMallExpDevKiosk: '點餐屏',
    ecosystemMallExpDevTea: '出品／茶機',
    ecosystemMallExpDevQueue: '叫號屏',
    ecosystemMallExpDevPos: '收銀機',
    ecosystemMallExpDevSignage: '廣告屏',
    ecosystemMallExpPermManager: '店長：全店運營',
    ecosystemMallExpPermStaff: '店員：日常店務',
    ecosystemMallExpPermStaffPickup: '店員：僅取貨',
    ecosystemMallSocOpsBridgeHwTitle: '建議搭配的硬件',
    ecosystemMallSocOpsBridgeHonest: '未載入設備快照時只顯示目錄建議，絕不謊稱店內已有／已配齊。',
    ecosystemMallSocOpsBridgeGoHw: '去設備星圖',
    ecosystemMallSocOpsBridgeFromHw: '已從設備星圖帶入推薦上下文（軟體態以本頁拓撲為準）',
    ecosystemMallSocOpsBridgeFromHwPay: '硬件側建議走成交線：請確認標準包後付款開通',
    ecosystemMallSocOpsDualTitle: '體驗完以後，只有兩條線',
    ecosystemMallSocOpsDualSub: '先選標準權限包。體驗線：配好包 → 建模擬店 → 後台模擬跑；成交線：付款直接正式開通。',
    ecosystemMallSocOpsLineATag: '線 A · 體驗',
    ecosystemMallSocOpsLineATitle: '標準權限包 → 模擬店',
    ecosystemMallSocOpsLineADesc: '我們按所選標準包開通試用權益，並在後台建好模擬商店，你直接進去跑。',
    ecosystemMallSocOpsLineAStep1: '配置標準權限包（試用開域）',
    ecosystemMallSocOpsLineAStep2: '自動建立模擬商店工作區',
    ecosystemMallSocOpsLineAStep3: '進入虛擬店模擬跑店',
    ecosystemMallSocOpsLineACta: '配包並進入模擬店',
    ecosystemMallSocOpsLineACtaShort: '體驗線：進模擬店',
    ecosystemMallSocOpsLineARunning: '正在配包建店…',
    ecosystemMallSocOpsLineAOk: '已配置 {n} 個域試用，正在進入模擬店',
    ecosystemMallSocOpsLineBTag: '線 B · 成交',
    ecosystemMallSocOpsLineBTitle: '付款直接開通',
    ecosystemMallSocOpsLineBDesc: '確認後按當前標準包／已勾選域正式開通真實權益，不走模擬店。',
    ecosystemMallSocOpsLineBStep1: '確認標準包或勾選域',
    ecosystemMallSocOpsLineBStep2: '付款確認開通',
    ecosystemMallSocOpsLineBStep3: '真實門店運營域生效',
    ecosystemMallSocOpsLineBCta: '付款正式開通',
    ecosystemMallSocOpsLineBCtaShort: '成交線：付款開通',
    ecosystemMallSocOpsLineBOk: '已正式開通 {n} 個營運域',
    ecosystemMallSocOpsLineBEmpty: '目前沒有待開通的加購域',
    ecosystemMallSocOpsPackDayTitle: '日營運標準包',
    ecosystemMallSocOpsPackDayDesc: '單·出·取·庫·付',
    ecosystemMallSocOpsPackHqTitle: '總部增強包',
    ecosystemMallSocOpsPackHqDesc: '日營運 + 總·導·析',
    ecosystemMallSocOpsPackFullTitle: '全量情報包',
    ecosystemMallSocOpsPackFullDesc: '總部增強 + 情報',
    ecosystemMallSocOpsSimStoreName: '營運模擬店 · {pack}',
    ecosystemMallSocOpsSimStoreFallback: '模擬店介面暫未完全就緒，仍將進入虛擬店頁面繼續體驗',
    ecosystemMallSocOpsActive: '已開通',
    ecosystemMallSocOpsTrial: '試用中',
    ecosystemMallSocOpsPotential: '還缺',
    ecosystemMallBadgeAll: '全部',
    ecosystemMallBadgeOwned: '已有',
    ecosystemMallBadgeIntent: '已意向',
    ecosystemMallBadgeAvailable: '可選',
    ecosystemMallSocOpsLoadFail: '載入失敗',
    ecosystemMallSocOpsTrialOk: '試用已開啟',
    ecosystemMallSocOpsTrialFail: '試用失敗',
    ecosystemMallSocOpsListCount: '共 {n} 個模組',
    ecosystemMallSocOpsBrand: 'XRROSS 營運商店',
    ecosystemMallSocOpsChip: 'Leo · SOC · XHM 三位一體',
    ecosystemMallSocOpsSub: '中心＝SOC 門店運行時；亮線＝業務怎麼自動轉。點域看能力，組套餐試用。',
    ecosystemMallSocOpsScheme: '切換背景配色',
    ecosystemMallSocOpsSchemeLight: '淺灰',
    ecosystemMallSocOpsSchemeMidnight: '深空',
    ecosystemMallSocOpsSchemeSlate: '石板',
    ecosystemMallSocOpsSchemeBrand: '品牌',
    ecosystemMallSocOpsEngine: '營運地圖',
    ecosystemMallSocOpsLegendTitle: '怎麼看這張圖',
    ecosystemMallSocOpsLegendHub: '中心＝SOC 門店運行時（Leo 引導 / XHM 回寫）',
    ecosystemMallSocOpsLegendActive: '亮＝已開通／買機含基礎',
    ecosystemMallSocOpsLegendPotential: '暗＝還缺（虛線＋黃粒子）',
    ecosystemMallSocOpsLegendTrial: '綠＝試用中',
    ecosystemMallSocOpsLegendHint: '粗線＝日循環業務邊；點選後高亮上下游',
    ecosystemMallSocOpsLegendExpand: '點大模組可散出細功能；再點收回',
    ecosystemMallSocOpsLegendHover: '滑過小球看全稱與具體功能',
    ecosystemMallSocOpsHoverBelong: '所屬',
    ecosystemMallSocOpsZoomHint: '滾輪縮放 · 空白處拖曳平移',
    ecosystemMallSocOpsZoomReset: '重置',
    ecosystemMallSocOpsFs: '全屏',
    ecosystemMallSocOpsExitFs: '退出全屏',
    ecosystemMallSocOpsFsLeft: '左側拓撲全屏',
    ecosystemMallSocOpsFsRight: '右側詳情全屏',
    ecosystemMallSocOpsSplitHint: '拖曳調整左右寬度',
    ecosystemMallSocOpsSku: '加購 SKU',
    ecosystemMallSocOpsReloading: '開通中…',
    ecosystemMallSocOpsEmpty: '還沒算出營運節點',
    ecosystemMallSocOpsHubLabel: 'SOC 門店運行時',
    ecosystemMallSocOpsHubSub: '運行時',
    ecosystemMallSocOpsHubHint: '杯料人錢在此閉環',
    ecosystemMallSocOpsMetaBasicSolve: '把門店基礎運行能力一次裝齊，後續業務域才能接上。',
    ecosystemMallSocOpsMetaBasicAuto: '帳號、門店檔案、基礎菜單與設備握手。',
    ecosystemMallSocOpsMetaBasicHuman: '首次開店配置與品牌規則確認。',
    ecosystemMallSocOpsMetaBasicC1: '門店與員工基礎檔案',
    ecosystemMallSocOpsMetaBasicC2: '菜單／SKU 底座',
    ecosystemMallSocOpsMetaBasicC3: '與設備星圖握手',
    ecosystemMallSocOpsMetaBasicD1: '雲端建立門店運行時',
    ecosystemMallSocOpsMetaBasicD2: '同步基礎菜單與權限',
    ecosystemMallSocOpsMetaBasicD3: '業務域開始可掛載',
    ecosystemMallSocOpsMetaOrderSolve: '把線上下單收成同一條訂單流，減少漏單與口頭傳菜。',
    ecosystemMallSocOpsMetaOrderAuto: '接單、校驗、路由到出杯隊列。',
    ecosystemMallSocOpsMetaOrderHuman: '異常單、改單與客訴裁決。',
    ecosystemMallSocOpsMetaOrderC1: '多渠道訂單匯聚',
    ecosystemMallSocOpsMetaOrderC2: '自動校驗與分派',
    ecosystemMallSocOpsMetaOrderC3: '異常單提示',
    ecosystemMallSocOpsMetaOrderD1: '客人下單進入雲端',
    ecosystemMallSocOpsMetaOrderD2: '規則校驗後入隊',
    ecosystemMallSocOpsMetaOrderD3: '推給出杯域開工',
    ecosystemMallSocOpsMetaProduceSolve: '按配方驅動出杯，讓「做出一杯」變成可追蹤步驟。',
    ecosystemMallSocOpsMetaProduceAuto: '按 BOM／配方推進產線步驟並回寫進度。',
    ecosystemMallSocOpsMetaProduceHuman: '設備故障、配方例外時介入。',
    ecosystemMallSocOpsMetaProduceC1: '配方驅動產線',
    ecosystemMallSocOpsMetaProduceC2: '進度回寫取貨',
    ecosystemMallSocOpsMetaProduceC3: '同步扣減原料建議',
    ecosystemMallSocOpsMetaProduceD1: '訂單觸發出杯任務',
    ecosystemMallSocOpsMetaProduceD2: '設備／產線執行步驟',
    ecosystemMallSocOpsMetaProduceD3: '完成信號送給取貨與庫存',
    ecosystemMallSocOpsMetaPickupSolve: '用訂單碼把「做好了」變成無爭議取貨。',
    ecosystemMallSocOpsMetaPickupAuto: '排號、叫號、掃碼核銷。',
    ecosystemMallSocOpsMetaPickupHuman: '取貨糾紛與特殊放行。',
    ecosystemMallSocOpsMetaPickupC1: '排號／叫號',
    ecosystemMallSocOpsMetaPickupC2: '掃碼核銷',
    ecosystemMallSocOpsMetaPickupC3: '取貨狀態回寫支付與分析',
    ecosystemMallSocOpsMetaPickupD1: '出杯完成進入取貨隊列',
    ecosystemMallSocOpsMetaPickupD2: '客人掃訂單碼核銷',
    ecosystemMallSocOpsMetaPickupD3: '閉環到支付與復盤',
    ecosystemMallSocOpsMetaStockSolve: '做一杯扣一點；缺料時給補貨建議而不是靠感覺。',
    ecosystemMallSocOpsMetaStockAuto: '按杯扣料、閾值預警、補貨建議單。',
    ecosystemMallSocOpsMetaStockHuman: '確認收發與大額採購放閘。',
    ecosystemMallSocOpsMetaStockC1: 'BOM 扣減',
    ecosystemMallSocOpsMetaStockC2: '缺料預警',
    ecosystemMallSocOpsMetaStockC3: '掃碼收發建議',
    ecosystemMallSocOpsMetaStockD1: '出杯觸發原料扣減',
    ecosystemMallSocOpsMetaStockD2: '閾值破線生成建議',
    ecosystemMallSocOpsMetaStockD3: '需要時升級到總部',
    ecosystemMallSocOpsMetaHqSolve: '多店與例外集中到總部視角，常態不打擾店長。',
    ecosystemMallSocOpsMetaHqAuto: '彙總破閾值事件與跨店對照。',
    ecosystemMallSocOpsMetaHqHuman: '策略、定價、重大例外決策。',
    ecosystemMallSocOpsMetaHqC1: '多店儀表',
    ecosystemMallSocOpsMetaHqC2: '破閾值升級',
    ecosystemMallSocOpsMetaHqC3: '策略下發到引導域',
    ecosystemMallSocOpsMetaHqD1: '各域上報關鍵指標',
    ecosystemMallSocOpsMetaHqD2: '破閾值才找人',
    ecosystemMallSocOpsMetaHqD3: '決策回寫到門店引導',
    ecosystemMallSocOpsMetaPaySolve: '把應付可記清楚，出款前仍由人手放閘。',
    ecosystemMallSocOpsMetaPayAuto: '記帳、對帳線索、支付狀態同步。',
    ecosystemMallSocOpsMetaPayHuman: '出款前確認與退款裁決。',
    ecosystemMallSocOpsMetaPayC1: '收款／應付記帳',
    ecosystemMallSocOpsMetaPayC2: '對帳線索',
    ecosystemMallSocOpsMetaPayC3: '出款前人工閘',
    ecosystemMallSocOpsMetaPayD1: '取貨完成觸發帳務事件',
    ecosystemMallSocOpsMetaPayD2: '自動歸集待對帳項',
    ecosystemMallSocOpsMetaPayD3: '出款前請求確認',
    ecosystemMallSocOpsMetaAnalyticsSolve: '把一天的杯料人錢收成可復盤的數字，而不是週末再對表。',
    ecosystemMallSocOpsMetaAnalyticsAuto: '彙總銷售、損耗與峰值。',
    ecosystemMallSocOpsMetaAnalyticsHuman: '解讀異常並決定改菜單／排班。',
    ecosystemMallSocOpsMetaAnalyticsC1: '日／周經營摘要',
    ecosystemMallSocOpsMetaAnalyticsC2: '峰值與損耗提示',
    ecosystemMallSocOpsMetaAnalyticsC3: '輸出給情報與總部',
    ecosystemMallSocOpsMetaAnalyticsD1: '支付與產線事件入倉',
    ecosystemMallSocOpsMetaAnalyticsD2: '生成經營摘要',
    ecosystemMallSocOpsMetaAnalyticsD3: '異常推給情報／總部',
    ecosystemMallSocOpsMetaGuideSolve: '用對話與指引把店員動作對齊系統，而不是靠微信群喊話。',
    ecosystemMallSocOpsMetaGuideAuto: '下一步動作提示、缺人時外呼建議。',
    ecosystemMallSocOpsMetaGuideHuman: '班表確認與現場例外。',
    ecosystemMallSocOpsMetaGuideC1: '崗位下一步指引',
    ecosystemMallSocOpsMetaGuideC2: '排班／補缺建議',
    ecosystemMallSocOpsMetaGuideC3: '把總部策略落到店員動作',
    ecosystemMallSocOpsMetaGuideD1: '總部策略下發',
    ecosystemMallSocOpsMetaGuideD2: '店員收到下一步',
    ecosystemMallSocOpsMetaGuideD3: '動作回流到訂單流',
    ecosystemMallSocOpsMetaIntelSolve: '把經營信號變成可行動情報，而不是一堆報表。',
    ecosystemMallSocOpsMetaIntelAuto: '識別趨勢與風險並生成簡報。',
    ecosystemMallSocOpsMetaIntelHuman: '決定要不要改組合／加購硬體或軟體域。',
    ecosystemMallSocOpsMetaIntelC1: '趨勢與風險簡報',
    ecosystemMallSocOpsMetaIntelC2: '與設備／軟體加購聯動建議',
    ecosystemMallSocOpsMetaIntelC3: '回流總部決策',
    ecosystemMallSocOpsMetaIntelD1: '分析域輸出信號',
    ecosystemMallSocOpsMetaIntelD2: '生成可行動情報',
    ecosystemMallSocOpsMetaIntelD3: '推給總部做取捨',
    ecosystemMallCatalog: '商品與章節',
    ecosystemMallWebsitePages: '官網產品頁',
    ecosystemMallSynergyEdges: '協同邊開閘',
    ecosystemMallIntents: '意向／諮詢單',
    ecosystemMallVendors: '供應商與人員',
    ecosystemMallMediaBilling: '媒資AI／計費',
    ecosystemMallProductSpecs: '產品規格／缺料',
    ecosystemMallLines: '產線組合',
    ecosystemMallSearch: '搜尋推薦',
    ecosystemMallEquipmentDemands: '設備需求單',
    storeAssortmentOptimization: '店鋪選品優化',
    storeAssortmentGroup: '店鋪選品',
    storeAssortmentDesk: '選品優化工作台',
    storeAssortmentView: '查看',
    storeAssortmentGate: '開閘',
    teaSingleCupParams: '單杯參數',
    dataOfBlendExtractorMachine:'冰沙機數據',
    dataOfMilkExtractorMachine:'奶沫機數據',
    beverageOutputData:'出品數據',
    singleCupData:'單杯數據',
    faultLog:'故障日誌',
    deliveryPlatform:'外賣平台',
    uber:'Uber',
    otherProducts:'其他產品',
    listOfTeaExtractsProducts:'萃茶機產品',
    machineDebug:'設備調試',
    deviceRdGroup:'設備研發',
    presetCommand:'預設命令',
    commandConfiguration:'命令配置',
    memberHqGroup: '會員 HQ',
    memberHqDashboard: 'HQ 總覽',
    memberHqFinance: '財務匯總',
    financeAccountingReports: '會計報表',
    financeAccountingGroup: '財務會計',
    storeCostOptimizeGroup: '成本效率',
    storeCostOptimizeDesk: '成本優化工作台',
    storeCostOptimizeView: '查看',
    storeCostOptimizeGate: '放閘',
    storeOpsCeoDeskGroup: '運營總決策台',
    storeOpsCeoDecisionDesk: 'CEO 運營決策台',
    storeOpsCeoDecisionDeskView: '查看',
    storeOpsCeoDecisionDeskDecide: '決策',
    storeOpsCeoGovernanceGapTitle: '全球整治缺口',
    storeOpsCeoGovernanceGapDesc: '總清單在這裡。價目／型號頁只跳過來。確認方案不等於改價、不等於批型號、不等於寫深圳。',
    storeOpsCeoGovernanceGapConfirm: '確認方案',
    storeOpsCeoGovernanceGapStart: '開始標準流水線',
    storeOpsCeoGovernanceGapEmpty: '目前沒有待確認缺口',
    storeOpsCeoGovernanceGapKind: '種類',
    storeOpsCeoGovernanceGapPlan: '方案',
    storeOpsCeoGovernanceGapHonesty: '跨區價差要對賬入庫後才會出現。本線不自動扇出。',
    storeOpsCeoGovernanceGapConfirmed: '已確認',
    storeOpsCeoGovernanceStepOpen: '打開清單',
    storeOpsCeoGovernanceStepPick: '點缺口',
    storeOpsCeoGovernanceStepConfirm: '確認方案',
    storeOpsCeoGovernanceStepGates: '核對寫閘',
    storeOpsCeoGovernanceStepDone: '完成',
    storeOpsCeoGovernanceCoachTitle: '現在請確認方案',
    storeOpsCeoGovernanceCoachHint: '看清步驟再點確認。確認不等於寫深圳。',
    aiEngineeringControlGroup: 'AI 工程總控',
    aiEngineeringControlDesk: '工程總控台',
    aiEngineeringControlDeskView: '查看',
    storePnLGroup: '店務 P&L',
    storePnLDesk: 'P&L／現金工作台',
    storePnLDeskView: '查看',
    storePnLDeskGate: '日結／分錄',
    opsAnalyticsDesk: '經營儀表',
    hkTaxFilingDesk: '店鋪帳稅',
    hkTaxFilingDeskView: '查看',
    hkTaxFilingDeskGate: '產包／人閘',
    hkTaxZeroDesc: '開店不用記賬：賣貨自動入帳，其他單據拍張照，一鍵準備報稅檔。不是自動向稅局完稅。',
    hkTaxZeroHonesty: 'XRROSS 幫你整理帳和報稅檔；簽名上傳仍要你自己在稅局網站做。',
    hkTaxZeroSales: '賣出',
    hkTaxZeroExpense: '支出',
    hkTaxZeroSurplus: '本年盈餘',
    hkTaxZeroPrepare: '準備報稅檔',
    hkTaxZeroSign: '我核過了',
    hkTaxZeroUpload: '去稅局上傳',
    hkTaxZeroDownload: '下載報稅檔',
    hkTaxZeroAdvanced: '進階（會計欄）',
    hkTaxZeroYa: '課稅年度',
    hkTaxZeroCompany: '公司名',
    hkTaxZeroTaxFile: '稅務檔案編號',
    hkTaxZeroTwoTier: '兩級制',
    hkTaxZeroHasEmp: '有僱員',
    hkTaxZeroSaveProfile: '存主檔',
    hkTaxZeroRebuild: '重算底稿',
    hkTaxZeroAddAdj: '加調整',
    hkTaxZeroPartner: '推送 Partner',
    hkTaxZeroAck: '稅局回執號',
    hkTaxZeroSaveAck: '回填回執',
    hkTaxZeroEmpAdd: '加入僱員',
    hkTaxZeroEmpPack: '產僱主報稅包',
    storeReceiptInbox: '店鋪單據',
    storeReceiptInboxView: '查看',
    storeReceiptInboxGate: '上傳入帳',
    storeReceiptInboxDesc: '拍照上傳租金／水電／外購單據，自動入帳並進香港報稅底稿。不是自動向稅局完稅。',
    storeReceiptPickStore: '選店',
    storeReceiptReload: '重新整理',
    storeReceiptHonesty: '營業額已從已付訂單來；這裡只補店外單據。入帳後仍須在報稅台人閘簽署。',
    storeReceiptTakePhoto: '拍照／選圖上傳',
    storeReceiptMerchantHint: '商戶名（可空）',
    storeReceiptList: '已上傳單據',
    storeReceiptEmpty: '尚未上傳',
    storeReceiptDate: '日期',
    storeReceiptMerchant: '商戶',
    storeReceiptAmount: '金額',
    storeReceiptKind: '科目',
    storeReceiptStatus: '狀態',
    storeReceiptActions: '操作',
    storeReceiptConfirm: '確認入帳',
    storeReceiptReject: '作廢',
    storeReceiptPreview: '看圖',
    storeReceiptBadType: '只接受 JPG／PNG／WebP',
    storeReceiptBadSize: '單張不超過 8MB',
    storeReceiptUploadFail: '圖檔上傳失敗',
    storeReceiptIngestOk: '已收單',
    storeReceiptIngestFail: '入列失敗',
    storeReceiptBooked: '已入帳',
    storeReceiptBookFail: '入帳失敗',
    storeReceiptRejected: '已作廢',
    storeReceiptRejectFail: '作廢失敗',
    storeReceiptOpenAssist: '打開助手',
    storeReceiptIDidCheck: '我做完了，檢查',
    storeReceiptStatusDone: '完成',
    storeReceiptStatusCurrent: '進行中',
    storeReceiptStatusTodo: '未開始',
    xhmHardwarePartnerGroup: '工廠／硬體夥伴',
    xhmHardwarePartnerDesk: '伙伴／月結工作台',
    xhmHardwarePartnerDeskView: '查看',
    xhmHardwarePartnerDeskGate: '月結／掛單',
    xhmFamilySlotGroup: 'XHM 三軌槽位',
    xhmFamilySlotDesk: '槽位工作台',
    xhmFamilySlotDeskView: '查看',
    xhmFamilySlotDeskGate: '保存槽位',
    hkMarketChannelGroup: '香港上市通道',
    hkMarketChannelDesk: 'HK 收款／WhatsApp 工作台',
    hkMarketChannelDeskView: '查看',
    hkMarketChannelDeskGate: '模擬／配置',
    hkMarketSignup: '港店簽約上手',
    hkMarketSignupGate: '簽約提交',
    cnMarketChannelGroup: '大陸上市通道',
    cnMarketChannelDesk: '陸店收款／社交工作台',
    cnMarketChannelDeskView: '查看',
    cnMarketChannelDeskGate: '模擬／配置',
    cnMarketSignup: '陸店簽約上手',
    cnMarketSignupGate: '簽約提交',
    brandStorePaymentGroup: '品牌搭建',
    brandOpenPack: '自動開店',
    productShelf: '產品上架',
    produceGuide: '自動設備',
    brandStorePaymentBind: '品牌付款',
    brandAppListing: '品牌上架',
    storeAutonomousMarketingGroup: '店鋪自主營銷',
    storeAutonomousMarketingDesk: '自主營銷工作台',
    storeAutonomousMarketingView: '查看',
    storeAutonomousMarketingGate: '放閘',
    workforceGroup: '排班出勤',
    workforceWeekSchedule: '週排班',
    workforceClock: '打卡出勤',
    workforceSummary: '出勤匯總',
    workforceSmartRoster: '智能排班',
    workforceMySchedule: '我的班表',
    workforcePayroll: '薪資月結',
    memberHqOps: '營運入口',
    distributorReportGroup: '渠道報表',
    distributorDashboard: '渠道總覽',
    distributorMembers: '我的會員',
    distributorProfit: '分潤明細',
    merchantTokenBillingPlatform: 'AI 點數',
    merchantDataBillingPlatform: '車載數據帳單',
    linuxAutoOps: '車載運營',
    linuxAutoEquipment: '車載設備',
    linuxAutoRemoteOps: '遠程運維',
    linuxAutoProfileConfig: 'Profile 配置',
    linuxAutoDataBilling: 'CAN 數據帳單',
    linuxAutoModelRegistry: '型號註冊',
    linuxAutoPartnerDelivery: '夥伴交付',
    linuxAutoFleetMonitor: '車隊監控',
    linuxAutoDbcEntitlement: 'DBC 授權',
    linuxAutoCabinFeatures: '座艙功能',
    linuxAutoCanAutoMatch: 'CAN 自動匹配',
    operationAndMaintenanceServices:'運維服務',
    productionList:'出品清單',
    smallMaterial:'小料列表',
    takeoutProducts:'外送產品',
    pointRule:'積分規則',
    couponManagement:" 優惠券管理",
    couponList:" 優惠券列表",
    additionalProducts:'額外產品',
    type:'產品類型',
    taxAllocation:'稅務配置',
    produce:'產品列表',
    produceList4:'出品列表4',
    smoothieMakerProduct:'冰沙機出品',
    machineMenu:'設備菜單',
    systemLog:"系統日誌",
    region:'區域'
    },
    acoount: {
    name: '名稱',
    enterpriseName: '企業名稱',
    account: '帳號',
    password: '密碼',
    confirmPassword: '確認密碼',
    roleTitle:'角色職稱',
    roleName:'角色名稱',
    searchKeyword:'帳號/手機/郵箱/角色',
    phone:'手機號碼',
    email:'郵箱',
    idNumber:'證件號',
    workAddress:'工作地址',
    status:'狀態',
    onDuty:'在崗',
    leaveDuty:'離崗',
    takeVacationrm:'休假',
    disable:'停用',
    profilePicture:'頭像',
    confirmPasswordCannotBeEmpty:'確認密碼不能為空',
    inconsistentPasswordInput:'密碼輸入不一致',
    emailFormatError:'郵箱格式錯誤',
    phoneNumberFormatError:'手機號碼格式錯誤',
    notes:'備註',
    empower:'授權',
    contactInformation:'聯絡方式',
    leoEntityId:'X-ID',
    leoEntityIdFilter:'篩選 X-ID',
    leoPrimaryAnchor:'Leo 主錨',
    leoPrimaryAnchorFilter:'篩選主錨',
    leoPrimaryAnchored:'已完成',
    leoPrimaryNotAnchored:'未完成',
    leoIdentityLinks:'登入對應',
    leoIdentityLinkCountSuffix:' 項',
    leoIdentityLinksTitle:'X-ID 登入對應關係',
    leoIdentityLinkLabel:'登入方式／帳號',
    leoIdentityLinkKind:'類型',
    leoIdentityLinkPrimary:'主錨',
    leoIdentityLinkRef:'憑證',
    leoIdentityLinksEmpty:'此 X-ID 尚無掛接登入方式',
    userOrganizationType:'用戶組織類型',
    userOrganizationName:'用戶組織名稱',
    describe:'描述',
    available:'可用',
    deactivate:'停用',
   
    },
    merchant: {
    // XRROSS_I18N_UNION_FILL_20260916 tw
    region: '區域',
    account: '登陸帳號',
    password: '密碼',
    store: '店家',
    status:'狀態',
    available:'正常',
    deactivate:'停用',
    merchantName:'商家名稱',
    searchKeyword:'商家名稱/負責人/電話/地址',
    sapPageDesc:'金樣頁：標題｜篩選｜表格｜底欄；主按鈕一個、列操作收進更多、中等密度。',
    sapListTitle:'商家列表',
    cooperationType:'商戶類型',
    selectCooperationTypeFirst:'請先選擇商戶類型',
    noUserOrganizationForType:'該類型下暫無用戶組織，請先在「用戶組織」中配置',
    enterpriseSegment:'經營場景',
    segmentDistributor:'渠道批發',
    segmentShop:'門店商用',
    segmentHome:'家用 Leo',
    businessLicense:'營業執照',
    frontIDCard:'身分證正面',
    backIDCard:'身分證反面',
    head:'負責人',
    Telephone:'聯絡電話',
    userOrganization:'使用者組織',
    businessAddress:'註冊地址',
    trade:'營業',
    closeBusiness:'歇業',
    superior:'上級',
    supervisorSubordinateRelation:'上下級關係',
    clickView:'點看',
    business:'商家',
    country:'國家',
    address:'地址',
    shopNames:'店名',
    storeType:'門店類型',
    selfService:'自助',
    askFor:'自取',
    SelfPickupTakeoutShop:'自取+外送店',
    selfServicePickUpTakeout:'自助+自取+外賣',
    businessHours:'營業時間',
    closingTime:'打烊時間',
    operatingCycle:'營業週期',
    Monday:'週一',
    Tuesday:'週二',
    Wednesday:'週三',
    Thursday:'週四',
    Friday:'週五',
    Saturday:'週六',
    Sunday:'週日',
    picture:'圖片',
    vatNumber:'VAT增值稅號',
    kvtCompanyRegistrationNumber:'KVK公司註冊號碼',
    invoiceUnifiedNumbering:'發票統編',
    invoiceAccountNumber:'發票帳號',  
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    
   
    },
    device:{
      sapPageDesc:'金樣頁：標題｜KPI｜篩選｜表格｜底欄；主按鈕一個、列操作收進更多、中等密度。',
      sapKpiTitle:'設備概況',
      sapListTitle:'設備列表',
      mapShowLocation:'地圖顯示位置',
      deviceType:'設備類型',
      totalDevice:'設備總數',
      passConfigName:"名稱",
      offLineDevice:'離線設備',
      materialShortageDevice:'缺料設備',
      alertingDevice:'警報設備',
      lockDevice:'鎖機設備',
      maintenanceDevice:'需要保養設備',
      businessInformation:'設備業務資料',
      deviceId:'設備ID',
      deviceModel:'型號',
      modelCodeKey:'型號代碼',
      modelCodePlaceholder:'例：PT5 或 XRROSS_PT5，需全站唯一',
      modelCodeRequired:'請填寫型號代碼（對應 Leo model_key）',
      dealer:"零售商",
      deviceImie:'設備編碼',
      appVersion:'App版本',
      appKeyword:'軟體名稱',
      appVersionOp:'版本比較',
      appVersionOpEq:'等於',
      appVersionOpContains:'包含',
      appVersionOpLt:'低於',
      appVersionOpGt:'高於',
      appVersionOpLte:'不高於',
      appVersionOpGte:'不低於',
      appVersionFilter:'機上版本',
      appVersionReportStatus:'版本上報',
      appReportHas:'有上報',
      appReportNone:'從未上報',
      appReportStale:'上報過期(7天)',
      appPublishRel:'對比發版',
      appPublishBehind:'落後發版',
      appPublishEqual:'等於發版',
      appPublishAhead:'高於發版',
      equipmentSerialNumber:'設備序列號',
      posNumber:'刷卡機編碼',
      store:'商家',
      location:'設備位置',
      none:'暫無',
      log:"日誌",
      fault:"故障",
      normal:"正常",
      offline:"離線",
      linkOffline:"模組離線",
      onLine:"在線",
      isFault:"是否有故障",
      type:"類型",
      fullyAutomatic:"全自動",
      semiAutomatic:"半自動",
      availableMerchants:"可使用商家",
      faultStatistics:"故障統計",
      basicMaintenance:"基礎保養",
      deepMaintenance:"深度保養",
      onLineDevice:'在線設備',
      equipmentOnlineStatus:"設備狀態:",
      moduleLinkStatus:"模組連線:",
      hostProduceStatus:"主機可製作:",
      hostReadyCanProduce:"可製作",
      hostReadyNeedWake:"需喚醒",
      hostReadyUnknown:"未知",
      linkOnlineHostSleep:"在線·主機休眠",
      macFastRebindEnabled:"MAC快速重綁",
      macFastRebindPending:"重綁未就緒",
      brandName: "品牌:",
      telephone: "電話:",
      equipmentModelName: "設備名稱/型號:",
      dateOfManufacture: "生產日期:",
      usageDate: "使用日期:",
      menu:"選單",
      productName :"產品名稱",
      channelConfiguration :"通道配置",
      channelNumber :"通道號",
      material :"物料",
      shelfLife :"有效期",
      alarmListForTheDay: "警報列表(當天)",
      content :"內容",
      time :"時間",
      key: "按鍵",
      frequency :"次數",
      remoteOperation :"遠端操作",
      cloudIris:'雲瞳 · 真屏遙控',
      cloudIrisShort:'雲瞳',
      cloudIrisNeedImie:'缺少機碼，無法打開雲瞳',
      cloudIrisVersionLow:'App 版本低於雲瞳最低要求（需 {minVersion}，目前 {appVersion}）',
      cloudIrisNoVersion:'尚無 App 版本上報，無法確認是否支持雲瞳',
      cloudIrisNotReadyFamily:'此機型雲瞳尚未就緒',
      cloudIrisNotLicensed:'此設備未購買雲瞳，請在簽約加購中勾選該機',
      cloudIrisNeedUpgradeShort:'雲瞳需升級',
      cloudIrisOldVersionShort:'舊版',
      cloudIrisEnd:'結束雲瞳',
      cloudIrisWaiting:'等待設備推流…',
      cloudIrisLive:'已連上，可點觸機屏',
      cloudIrisFailed:'雲瞳未就緒',
      cloudIrisUpgradeConfirmTitle:'確認雲瞳升級',
      cloudIrisUpgradeConfirm:'將對機碼 {imie} 推送 OTA 強更（目標 ≥ {minVersion}，目前 {appVersion}）。\n{detail}\n僅影響此一台，不會改動其他客戶灰度名單。',
      cloudIrisUpgradeConfirmOk:'同意並推送',
      cloudIrisUpgradePushSent:'已推送 OTA 檢查令（{imie}）',
      cloudIrisUpgradePushOffline:'已加入灰度白名單，設備離線或未 ACK（{imie}）',
      cloudIrisUpgradePushFailed:'雲瞳 OTA 推送失敗',
      identityAndLink:'身份與連線',
      storeAddress:'門市地址',
      deviceGeo:'設備定位',
      deviceGeoLoading:'定位載入中…',
      deviceGeoNone:'暫無定位',
      success :"成功",
      menuStatus: "選單狀態",
      updated: "已更新",
      notUpdated: "未更新",
      lock: "鎖定",
      unlock: "解鎖",
      startup: "啟動",
      shutdown: "關機",
      restart: "重啟",
      param:"參數",
      factoryParam:"工廠參數",
      moduleParam:"模塊參數",
      paramBaselineOpen:'設置參數',
      paramBaselineTitle:'設置參數（Leo 型號基準）',
      paramBaselineHint:'參數鍵請與設備配置 JSON path 一致（例：config.stirTime）；儲存後供 Leo 與機器實際配置比對。',
      paramBaselineAddRow:'新增參數列',
      paramBaselineSave:'儲存',
      paramBaselineRefresh:'重新載入',
      paramKey:'參數鍵',
      paramKeyPh:'例：config.stirTime',
      paramDisplayName:'顯示名稱',
      standardValue:'標準值',
      lowerLimit:'下限',
      upperLimit:'上限',
      unit:'單位',
      paramRemark:'備註',
      paramBaselineNoProfile:'此型號尚無可讀取之 L1 配置檔（或尚無 PUBLISHED 版）。請先於「配置檔管理」建立／發佈綁定該型號之 Profile。',
      paramBaselineProfileSource:'參數預設來源：{name} · published 版號 {version}',
      paramBaselineApplyPublished:'自最新 published 套用',
      paramBaselineApplyConfirm:'將依最新 published 之 JSON 合併至表格（同鍵將覆寫標準值與上下限，並新增未存在之鍵）。確定？',
      paramBaselineApplyDone:'已套用 published 建議值（請確認後儲存）',
      paramBaselineTypeUnionTitle:'同設備類型 · 各型號 published 路徑聯集（參考）',
      paramBaselineTypeUnionMissing:'無 Profile 之型號 ID'
      },
      produce: {
    // XRROSS_I18N_UNION_FILL_20260916 tw
    Text19: '僅可填數字',
    countsInConsumption: '計入消耗',
    matterTypeKind: '類型性質',
    matterTypeKindParameter: '參數',
    matterTypeKindPhysical: '實體物料',
    matterTypeParameterHint: '「參數」類型不參與物料消耗統計，適用於程序、濃度檔、水溫等製作維度。',
      name: '名稱',
      price: '價格',
      uberPrice: 'Uber單價',
      matterType: '物料類型',
    materialRoleBean: '咖啡豆',
    materialRoleMilk: '液態奶',
    materialRolePowder: '粉料',
    materialRoleWater: '水',
    materialRoleTeaLeaf: '茶葉',
    materialRoleTeaBroth: '茶湯',
    materialRoleSyrup: '糖漿',
    materialRoleLiquor: '酒',
    materialRoleConsumable: '耗材',
      physicalMaterial: '物理物料',
      physicalMaterialHint: 'V1：先選店倉物理 SKU；未選可勾「按名稱新建物理並自動映射」。',
      physicalMaterialRequired: '請選擇物理物料，或勾選按名稱新建物理物料',
      createPhysicalIfMissing: '按名稱新建物理物料並自動映射',
      normType: '規格類型',
      matter: '物料',
      min: '最小值',
      max:'最大值',
      shelfLife:'保鮮期',
      unit:'單位',
      hour:'小時',
      step1:'產品資料',
      step2:'產品物料',
      step3:'產品配方',
      step4:'配方組合',
      step5:'產品小料',
      produceName:'出品名稱',
      produceCode:'出品編碼',
      produceType:'出品類型',
      showSnacks:'顯示小吃',
      yes:'是',
      no:'否',
      describe:'描述',
      order:'順序',
      value:'值',
      unit:'單位',
      norm:'規格',
      select:'選擇',
      step:'步驟',
      matterSequence:'物料順序',
      action:'操作',
      freeSnacks:'免費配料',
      feeBasedMaterials:'收費配料',
      nextStep:'下一步',
      back:'上一步',
      save:'儲存',
      saveUpdate:'儲存更新',
      productList:'出品選單',
      selectProduct:'選擇出品',
      menuSort:'排序',
      produceImport:'出品導入',
      bind:'綁定',
      bindMachien:'綁定設備',
      smallMatterType:'小料類型',
      listing:'上架',
    productDetail:'產品詳情',
    produceEquipment:'製作流水線',
    canMake:'可生產',
    cannotMake:'本店未掛此型號',
    noRecipe:'還沒有配方／製作參數',
    noCombo:'還沒有規格組合',
    noProduceEquipment:'還沒有點單／掃碼製作流水線',
    consumableNoMachine:'耗材（不佔機）',
    orderOnLeo:'本店無點單機／收銀機 → 用手機 Leo 點單',
      isSales:'可下單',
      productListName:"輸入出品菜單名稱",
      Text1:'輸入出品名稱',
      Text2:'商家',
      Text3:'物料',
      Text4:'配料',
      Text5:'飲品',
      Text6:'小吃',
      Text7:'新增配方',
      Text8:'更新',
      Text9:'該產品編碼已存在',
      Text10:'請完善產品信息',
      Text11:'茶品',
      Text12:'第一段',
      Text13:'第二段',
      Text14:'第三段',
      Text15:'出',
      Text16:'不出',
      Text17:'範圍:',
      Text18:'茶葉量:',
      Text20:'冰塊量:',
      Text21:'攪拌時間不能大於同段萃茶/萃取時間（上限 {max}）',
      Text22:'萃茶/萃取時間不能小於目前攪拌時間（{min}）',
      Text23:'配方「{name}」攪拌時間超過萃茶/萃取時間（上限 {max}），請調整後再保存',
      codeRule:'編輯規則',
      prefix:'字首',
      suffix:'後綴',
      review:'預覽',
      codeRuleDescribe:'這個格式就是收銀系統列印編碼的格式',
     
      },
      business: {
      name: '名稱',
      type: '類型',
      homepage: '首頁',
      advertisingList: '廣告清單',
      pictureOrVideo: '圖片/影片',
      addProductAdvertisements:'新增產品廣告',
      AddImagesOrvideos:'新增圖片/視頻',
      userName: '使用者名稱',
      email: '郵箱',
      sex: '性別',
      birthday: '生日',
      phone: '手機號',
      walletBalance: '錢包餘額',
      integral: '積分',
      orderNo: '訂單編號',
      pickupCode: '取餐碼',
      orderSource: '來源',
      orderSourceAll: '全部來源',
      orderSourceTable: '桌碼',
      orderSourceNormal: '一般',
      tableNo: '桌號',
      store: '店家',
      amount: '訂單金額',
      payAmount: '實付金額',
      receiptsPrice: '實收金額',
      discount: '優惠',
      orderStatus: '訂單狀態',
      toBePaid: '待支付',
      paid: '已支付',
      processing: '處理中',
      completed: '已完成',
      orderCancellation: '訂單取消',
      orderRejection: '訂單拒絕',
      paymentMethod: '支付方式',
      wallet: '錢包',
      cash: '現金',
      pos: '刷卡機',
      thirdParty: '第三方',
      otherPay: '其他',
      produce: '出品',
      unitPrice: '單價',
      number: '數量',
      parameter: '參數',
      totalTaxAmount:'總稅額',
      taxName:'稅名',
      taxAmount:'稅額',
      taxRate:'稅率',
      orderType: '訂單類型',
      pack: '打包',
      dineIn: '堂食',
     
      },
      file: {
        name: '名稱',
        version: '版本',
        keyword: '標識',
        file:'文件',
        upload:'上傳',
        remark: '備註',
        publishStatus: '發布狀態',
        published: '對外最新',
        archived: '已歸檔',
        backupStatus: '伺服器備份',
        backedUp: '已備份',
        notBackedUp: '未備份',
        otaStatus: 'OTA狀態',
        otaLiveBacked: '對外最新·已備份',
        otaLiveNoBackup: '對外最新·未備份',
        otaArchivedBacked: '已歸檔·已備份',
        otaArchivedNoBackup: '已歸檔·未備份',
        otaLinkBroken: '鏈接失效',
        otaStatusTipTitle: '狀態說明：',
        otaStatusTipLiveBacked: '綠＝正在對外發且伺服器有備份，正常。',
        otaStatusTipLiveNoBackup: '橙＝正在對外發但未備份，請補備份或重傳。',
        otaStatusTipArchivedBacked: '灰＝已不對外，但可回滾。',
        otaStatusTipArchivedNoBackup: '紅＝已歸檔且無備份，基本不可回滾，建議重傳。',
        otaStatusTipLinkBroken: '紅「鏈接失效」＝下載地址空或雲端 404/不通，請重新上傳 APK。',
        recheckLinks: '重新檢查鏈接',
        history: '歷史',
        historyTitle: '版本歷史',
        backupNow: '補備份',
        batchBackup: '批量補備份',
        batchArchive: '批量歸檔',
        batchBackupConfirm: '確認對勾選項執行補備份？',
        batchBackupDone: '批量補備份結束',
        selectFirst: '請先勾選要操作的 APP',
        copyLink: '鏈接',
        linkCopied: '下載鏈接已複製',
        linkCopyFailed: '複製失敗，請手動複製',
        noDownloadLink: '此 APP 尚無下載鏈接',
        backupRemoteGone: '雲端 APK 已不存在（404）。請重新上傳 APK 後再備份。',
        archive: '歸檔',
        archiveConfirm: '歸檔後舊設備不再取此版（檔案保留可回滾），確認',
        rollback: '回滾',
        rollbackConfirm: '確認回滾為此版本？當前對外最新將歸檔保留。',
        otaBackupHint: '儲存後系統會把包拉到伺服器製品倉備份；舊設備仍用原下載連結。',
        otaReuploadHint: '若補備份報 404：雲端檔已刪，請在此重新上傳 APK 後再按確定。',
        otaGray: '灰度',
        otaGrayOff: '全量',
        otaGrayOn: '灰度({n}台)',
        otaGraySet: '設置灰度',
        otaGrayHint: '開=僅白名單機碼可升此版；關或名單空=全量。',
        otaGrayMachines: '灰度機碼',
        otaGrayMachinesPlaceholder: '一行一個機碼，也可用逗號分隔',
        otaForceUpgrade: '強制升級',
        otaForceUpgradeHint: '開=機端不可取消更新；可與灰度並用。',
        otaPushForce: '立即推送',
        otaPushForceConfirm: '向灰度白名單機立即推送強制升級檢查？離線機會記為 offline。',
        otaPushForceResult: '推送完成：共 {total}，送達 {delivered}，離線 {offline}',

        pendingIntentGate: 'PendingIntent閘',
        pendingIntentGatePass: '已過閘',
        pendingIntentGateSkip: '已跳過',
        pendingIntentGateNa: '不適用',
        pendingIntentGateFail: '未過閘',
        pendingIntentGateUnknown: '未標記',
        pendingIntentGateTipPass: '發版時已通過 Android 12 PendingIntent 硬閘（可安全作為 OTA 源）。',
        pendingIntentGateTipSkip: '發版時人工跳過硬閘，存在風險。',
        pendingIntentGateTipNa: 'targetSdk 較低或無 UpdateDialog，硬閘不適用。',
        pendingIntentGateTipFail: '已掃描：targetSdk≥31 且 UpdateDialog 缺少 PendingIntent 修法，從此版 App 內 OTA 會崩。',
        pendingIntentGateTipUnknown: '歷史版本無閘標記；新發版或回填掃描才會寫入。'
        },
        coupon: {
        Text1: '名稱',
        Text2: '優惠金額',
        Text3: '消耗積分',
        Text4:'狀態',
        Text5:'詳情',
        Text6:'可用',
        Text7:'不可用',
        Text8:'有效天數'
       
        },
        pass: {
        name: '名稱',
        pass: '通道',
        passNumber: '頻道號碼',
        preDischargeTime: '預出料時間',
        addPass:'新增頻道',
        bindPass:'通道綁定',
        passConfigName:'通道設定名稱'
       
        },
        operation:{
        business_data:"業務數據看板",
        orderAmount:"訂單金額",
        orderQuantity:"訂單數量",
        actualAmountReceived:"實收金額",
        top_10_beverage_rankings:"飲品榜Top10",
        sales_revenue:"銷售額",
        order_quantity:"訂單數量",
        payment_method:"付款方式",
        real_time_orders_on_the_hour:"整點即時訂單",
        },
        dataCenter:{
          Text1:"內容",
          Text2:"資料",
          Text3:"銷售量/杯",
          Text4:"銷售額/元",
          Text5:"消耗物料/g",
          Text6:"月",
          Text7:"日",
          Text8:"時",
          Text9:"圖表",
          Text10:"單杯消耗物料",
          Text11:"排名",
          Text12:"出品消耗物料",
          Text13:"設備消耗物料",
          Text14:"百分比",
          Text15:"排名",
          Text16:"銷售量",
          Text17:"銷售額",
          Text18:"時間/S",
          Text19:"出品銷售量",
          Text20:"出品銷售額",
          Text21:"設備銷售量",
          Text22:"設備銷售額",
          Text23:"總杯數",
          Text24:"總配方量/克",
          Text25:"實際總配方量/克",
          Text26:"壞杯量/杯",
          Text27:"壞杯率/%",
          Text28:"誤差率/%",
          Text29:"出品名稱",
          Text30:"製作方式",
          Text31:"掃碼-全管",
          Text32:"產品-全管",
    fullPipeModeValue:'滿管',
    fullPipeMode:'模式',
    calibComplete:'已完成',
    calibIncomplete:'未完成',
    calibValue:'數值',
    calibModeChannel:'通道校準',
    calibModeScale:'小稱校準',
    calibMode:'校準模式',
    pipeActualText:'單管實際量(g)',
    Text32Single:'產品-單管',
    Text31Single:'掃碼-單管',
          Text33:"手動",
          Text34:"訂單號碼",
          Text35:"門市",
          Text36:"單價",
          Text37:"配方總量",
          Text38:"實際出杯量",
          Text39:"出杯時間",
          Text40:"誤差(%)",
          Text41:"壞杯",
          Text42:"正常",
          Text43:"製作完成",
          Text44:"製作失敗",
          Text45:"完成時間",
          Text46:"模式",
          Text47:"頻道",
          Text48:"狀態",
          Text49:"未完成",
          Text50:"完成",
          Text51:"出品名稱",
          Text52:"杯數",
          Text53:"總價",
          Text54:"訂單統計",
          Text55:"訂單列表",
          Text56:"訂單金額",
          Text57:"訂單數量",
          Text58:"實收金額",
          Text59:"產品金額",
          Text60:"茶葉量",
          Text61:"出水量",
          Text62:"銷售量/桶",
          Text63:"桶",
          Text64:"偏酸/萃取過短",
          Text65:" 均衡/萃取中等",
          Text66:"偏苦/萃取過度",
          Text67:"味苦/濃度低",
          Text68:"適中",
          Text69:"強/濃度高",
          Text70:"萃取时间",
          Text71:"水粉比",
          strongBalance:"強平衡",
          weakBalance:"弱平衡",
          mediumAcid:"中酸",
          strongAcid:"強酸",
          goldenCup:"金杯",
          weakAcid:"弱酸",
          bitter:"苦",
          strongBitter:"強苦",
          weakBitter:"弱苦",
          extractionTime:"萃取時間",
          Text72:"動態校準",
          },
          taxation:{
          Text1:"稅名",
          Text2:"稅率",
          Text3:"基數",
          Text4:"備註",
          Text5:"國家",
          Text6:"型別",
          Text7:"內用",
          Text8:"打包",
          Text9:"產品类型",
          Text10:"稅種",
          Text11:"平台外賣",
          },
          uber:{
          Text1:"uber店舖",
          Text2:"平台店舖",
          Text3:"菜單狀態",
          Text4:"店舖狀態",
          Text5:"已綁定",
          Text6:"未綁定",
          Text7:"同步"
         
          },
          login: {
          title: '系統登入',
          logIn: '登入',
          username: '帳號',
          password: '密碼',
          readAndAgree:'已閱讀並同意',
          pleaseCheckThePrivacyAgreement:'請勾選並同意《隱私政策》《服務條款》與《免責聲明》後再登入',
          termTip:'《隱私政策》《服務條款》與《免責聲明》',
          Text1:'請輸入帳號',
          Text2:'請輸入帳號',
          leoSmartComingSoon: 'Leo Smart 專業站即將上線'


          },
          navbar: {
          logOut: '退出登入',
          dashboard: '首頁',
          github: '項目地址',
          screenfull: '全螢幕',
          theme: '換背景顏色',
          size: '布局大小',
          globalSearchTitle: '站內搜尋',
          globalSearchPlaceholder: '搜尋選單／店鋪／設備／物料／工單（Ctrl+K）',
          globalSearchHotkeyHint: '開啟站內搜尋（Ctrl+K）',
          globalSearchRecent: '最近搜尋',
          globalSearchSaved: '已存視圖',
          globalSearchEmpty: '無結果',
          globalSearchSaveView: '儲存目前視圖',
          globalSearchSaveViewPrompt: '視圖名稱',
          globalSearchDefaultViewName: '視圖',
          globalSearchSavedOk: '已儲存視圖',
          globalSearchFooterHint: 'Enter 開啟首條 · Esc 關閉',
          globalSearchGroupMenus: '選單',
          globalSearchGroupStores: '店鋪',
          globalSearchGroupEquipment: '設備',
          globalSearchGroupMaterials: '物料',
          globalSearchGroupTickets: '工單',
          globalSearchMissingRoute: '沒有可打開的頁面'
          },
          tagsView: {
          refresh: '刷新',
          close: '關閉',
          closeOthers: '關閉其它',
          closeAll: '關閉所有'
          },
          common:{
          tower:'台',
          yuan:'元',
          cup:'杯',
          place:'位',
          individual:'個',
          language:'語言',
          success:'成功',
          fail:'失敗',
          createTime:'創建時間',
          all:'全部',
          common:'全部',
          sureDel:'確定刪除',
          tip:'提示',
          status:'狀態',
          bing:'綁定',
          pleaseSelectDevice:'請選擇設備',
          pleaseSelectMenu:'請選擇菜單',
          pleaseSelectModel:'請選擇型號',
          pleaseSelect:'請選擇',
          code:'編碼',
          entering_the_platform:'進入平台',
          date:"日期",
          address_fail:"地址不正確",
          back:'返回',
          pleaseEnter:'請輸入',
          uploadImageBtn:'點擊上傳圖片',
          uploadImageBtnTip:'僅支援上傳JPG 格式和PNG格式（限制10M以內）',
          uploadVideoBtn:'點擊上傳影片',
          uploadVideoBtnTip:'僅支援上傳mp4或MP4檔案（限制50M以內）',
          videoPlayTip:' 您的瀏覽器不支援影片播放',
          menuVersion:"選單版本"
          },
          table:{
          search: '查詢',
          detail:'詳情',
          actions: '操作',
          edit: '編輯',
          publish: '發布',
          delete: '刪除',
          cancel: '取 消',
          confirm: '確 定',
          add:'新增',
          copy:'複製',
          produceCodeRule:'編碼規則',
          batchDeletion:'大量刪除',
          batchImport:'批次導入',
          batchCopy:'批量複製',
          export:'數據導出',
          exportAll:'匯出全部',
          import:'導入',
          more:'更多',
          reset:'重置',
          templateDownload:'模板下載',
          dragAndDropUpload:'將檔案拖曳到這裡，或點擊以上傳',
          picture:'圖',
          resetPwd:'重設密碼'
          },
          coffeeData:{
          Text1:"浸泡流量",
          Text2:"浸泡時間",
          Text3:"萃取流量",
          Text4:"萃取壓力",
          Text5:"萃取溫度",
          Text6:"訂單類型",
          Text7:"狀態",
          Text8:"出杯時間",
          Text9:"粉量",
          Text10:"設備編碼",
          Text11:"出品名稱",
          Text12:"咖啡液",
          Text13:"壓粉力道",
          Text14:"粉餅厚度",
          Text15:"萃取流速",
          Text16:"萃取腔體位置",  
          Text17:"研磨度1",
          Text18:"研磨度2",
          }
  ,
  navbar: {
    logOut: '退出登入',
    dashboard: '首頁',
    github: '項目地址',
    screenfull: '全螢幕',
    theme: '換背景顏色',
    size: '布局大小',
    globalSearchTitle: '站內搜尋',
    globalSearchPlaceholder: '搜尋選單／店鋪／設備／物料／工單（Ctrl+K）',
    globalSearchHotkeyHint: '開啟站內搜尋（Ctrl+K）',
    globalSearchRecent: '最近搜尋',
    globalSearchSaved: '已存視圖',
    globalSearchEmpty: '無結果',
    globalSearchSaveView: '儲存目前視圖',
    globalSearchSaveViewPrompt: '視圖名稱',
    globalSearchDefaultViewName: '視圖',
    globalSearchSavedOk: '已儲存視圖',
    globalSearchFooterHint: 'Enter 開啟首條 · Esc 關閉',
    globalSearchGroupMenus: '選單',
    globalSearchGroupStores: '店鋪',
    globalSearchGroupEquipment: '設備',
    globalSearchGroupMaterials: '物料',
    globalSearchGroupTickets: '工單',
    globalSearchMissingRoute: '沒有可打開的頁面'
  },
  channelCmd: {
    desc: '一眼看 A 線直銷社媒、B 線授權／頭牌：在用、在推、無官方發佈 API、等人閘。本頁不能發帖。',
    reload: '重新載入',
    v1Note: '第一版只讀。有官方發佈 API 的渠道：人手只做一次接通／過審，之後由 AI 發。沒有官方發佈 API 就不做手工發。商務／展會仍人手。',
    fLine: '市場線',
    fKind: '類型',
    fRegion: '地區',
    fStatus: '狀態',
    fPromo: '正在推',
    fApi: '有官方 API',
    fHuman: '等人閘',
    fAi: 'AI 代運營',
    fSku: 'SKU',
    fLocale: '語種',
    fQ: '平台／備註',
    reset: '清空篩選',
    yes: '是',
    no: '否',
    lineA: 'A 線直銷',
    lineB: 'B 線授權',
    lineBoth: '兩線共用',
    aInUse: 'A 在用',
    aPromo: 'A 在推',
    bInUse: 'B 在用',
    noApi: '無 API',
    needsHuman: '等人閘',
    hold: '凍結',
    aiReady: 'AI 已可發',
    afterConnect: '接上後 AI 發',
    humanOnly: '只人手',
    total: '目前條數',
    colA: 'A 線 · 直銷社媒',
    colB: 'B 線 · 授權／頭牌',
    cPlatform: '平台',
    cStatus: '狀態',
    cPromo: '在推',
    cApi: 'API',
    cKind: '類型',
    cRegion: '地區',
    cNote: '備註',
    cAi: '誰幹活',
    cFollow: '人手跟進',
    cComms: '通訊',
    comms: '通訊歷史',
    chatEmpty: '尚無通訊記錄。發帖、OAuth、跟進都請登錄在此。',
    sideUs: '我方',
    sideThem: '渠道／對方',
    logInbound: '登錄對方回覆',
    logOutbound: '登錄我方跟進',
    subject: '主旨',
    chatPlaceholder: '通訊內容…',
    logSave: '寫入歷史',
    openLink: '打開連結',
    openFollow: '打開跟進頁',
    noFollowUrl: '無公開入口',
    step1: '打開總控',
    step2: '篩線與狀態',
    step3: '讀在用／在推',
    coachBadge: '現在請做',
    coachHint: '本頁只看矩陣，不要在這裡發帖。點列可看通訊歷史。',
    coachNext: '下一步',
    kind: { social: '社媒', commerce: '電商', license: '授權', web: '官網', email: '郵件' },
    region: { US: '美國', CN: '中國', HK: '香港', JP: '日本', GLOBAL: '全球' },
    status: {
      LIVE: '在發',
      TOKEN_PRESENT: '有憑證',
      NEEDS_TOKEN: '缺憑證',
      NEEDS_OAUTH: '要授權',
      NEEDS_REAUTH: '要重授權',
      NEEDS_HUMAN_GATE: '等人閘',
      HOLD_NO_APP_AUDIT: '應用未過審',
      HOLD_NO_COMPANY_PAGE: '缺公司頁',
      NO_API: '無官方 API',
      PROBE: '探測中'
    },
    ai: {
      ai_ready: 'AI 已可發',
      after_connect: '接上後 AI 發',
      human_only: '只人手（BD／條款）',
      no_api_skip: '無 API · 不發'
    }
  },
  bCrm: {
    desc: 'B 端客戶台：頭牌買家＋經銷商。管道階段、產品分類／SKU 篩選、聯絡人、活動、統一發推排隊。',
    reload: '重新載入',
    applyFilter: '套用篩選',
    v1Note: '可按產品分類篩不同產品線。勾選有信箱客戶後統一發推＝預設排隊；實發須運維放行。',
    fType: '帳戶類型',
    fFunnel: '漏斗',
    fStage: '階段',
    fRegion: '地區',
    fOwner: '負責人',
    fProdCat: '產品分類',
    fSku: '產品 SKU',
    fPromo: '正在推',
    fPriority: '優先級',
    fHasEmail: '有信箱',
    fContactStatus: '聯絡完備度',
    fQ: '名稱／備註',
    reset: '清空篩選',
    yes: '是',
    no: '否',
    campaign: '統一發推',
    head: '頭牌',
    dealer: '經銷',
    promoting: '在推',
    withEmail: '有信箱',
    total: '目前',
    queue: '排隊戰役',
    accounts: '客戶列表',
    detail: '客戶詳情',
    contacts: '聯絡人',
    activities: '活動',
    notes: '備註',
    openLi: 'LinkedIn',
    cContact: '主聯絡人',
    cEmailAddr: '信箱',
    cLinkedin: 'LinkedIn',
    cContactStatus: '聯絡狀態',
    cRole: '角色',
    contactStatus: {
      EMAIL_OK: '有BD信箱',
      LINKEDIN_ONLY: '僅LinkedIn',
      MISSING: '缺聯絡'
    },
    subject: '主題',
    body: '正文',
    cancel: '取消',
    sendQueue: '加入發推行列',
    campaignHint: '已選 {n} 戶（僅有信箱可勾選）',
    queuedOk: '已排隊 {n}，跳過 {s}',
    coachBadge: '現在請做',
    coachHint: '先篩產品分類，再勾選發推。',
    coachNext: '下一步',
    coach1: '打開 B端CRM，看頭牌／經銷匯總',
    coach2: '按產品分類或 SKU 篩選',
    coach3: '勾選客戶並統一發推排隊',
    railOpen: '打開',
    railFilter: '產品篩選',
    railCampaign: '統一發推',
    cName: '名稱',
    cType: '類型',
    cFunnel: '漏斗',
    cStage: '階段',
    cPri: '優先',
    cCats: '產品分類',
    cSkus: 'SKU',
    cPromo: '在推',
    cOwner: '負責人',
    cNext: '下一步',
    cEmail: '信箱',
    cAction: '操作',
    interactions: '互動記錄',
    chatEmpty: '尚無往來記錄',
    sideUs: '我方',
    sideThem: '客戶',
    logReply: '登錄客戶回信',
    logOutbound: '登錄我方發出',
    chatPlaceholder: '貼上郵件正文或摘要…',
    logSave: '寫入記錄',
    logOk: '已寫入互動記錄',
    type: { head_buyer: '頭牌買家', dealer: '經銷商' },
    funnel: { L: 'License', H: 'OEM／H', DEALER: '經銷', BOTH: '兩線' },
    stage: {
      lead: '線索',
      contacted: '已聯繫',
      replied: '已回信',
      negotiating: '洽談中',
      won: '成交',
      lost: '丟失',
      hold: '擱置'
    },
    cat: {
      HOME_OEM: '家用整機',
      COMMERCIAL_OEM: '商用整機',
      LICENSE: '授權大腦',
      CONSUMABLE: '豆／耗材',
      AFTERSALES: '售後配件',
      OTHER: '其他'
    }
  },
  immersivePromo: {
    sampleTitle: '沉浸推廣樣板',
    sampleDesc: '上面＝本頁真實導航入口（與側欄同一棵樹）；廣告帶固定在頁底，中間卡片自己滑。',
    navEmpty: '目前沒有可展示的導航入口，請確認已登入且有菜單權限。',
    navChildren: '查看子選單',
    sampleHint: '廣告區不扮演功能入口。右側箭頭看更多廣告。',
    adRailKicker: '為你推薦',
    adMore: '更多',
    adMoreTitle: '更多廣告',
    navEnter: '點擊進入',
    helpFoot: '導航卡＝進功能；廣告帶＝推送。點箭頭看更全的廣告。',
    surface: '推廣面',
    surfaceHome: '客戶首頁',
    surfaceDataCenter: '數據中心',
    portrait: '畫像',
    portraitOem: '設備生產商',
    portraitDist: '業務分銷商',
    portraitChain: '實體連鎖運營者',
    ownedSkusHint: '模擬已購 SKU（逗號分隔）',
    leoInstalled: '已裝 Leo',
    leoActive: '近7日活躍',
    strategyLabel: '策略器',
    ownedTitle: '已開通功能',
    promoTitle: '可加購能力',
    promoLead: '卡片外觀像功能；文案像廣告（便利／好處）。滑鼠移上去看詳細說明，再決定試用。',
    zoneOwnedHint: '功能入口',
    zoneUnlockHint: '能力發現 · 廣告文案',
    tagOwned: '可用',
    tagPromo: '加購',
    tagCapability: '可開通',
    hoverHint: '移上查看詳情',
    adDetailKicker: '為什麼值得試',
    adDetailClose: '關閉',
    adVideoFullscreen: '全屏觀看',
    adVideoFullscreenClose: '關閉',
    leoQrHint: '掃碼安裝 Leo：蘋果 App Store；安卓海外 Google Play，大陸走本區節點。',
    leoQrAlt: 'Leo 掃碼下載',
    trialBadge: '免費試用',
    freeUpgradeBadge: '免費升級',
    adPromoPriceLabel: '當前優惠',
    adPriceLabel: '價格',
    adPriceFallback: '免費試用 · 優惠價另計',
    ctaOpen: '打開',
    ctaTrial: '先試用',
    ctaFreeUpgrade: '免費升級',
    ctaSign: '試用後再簽約',
    ctaSampleOnly: '樣板 CTA：正式試用／簽約另接 entitlement',
    ctaTrialHint: '先試用，用好了再決定要不要簽約，現在不會收費。',
    ctaPathMissing: '這則廣告還沒接到可進的頁面，請稍後再試。',
    ctaTrialFirst: '下一步是試用。試用滿意再簽約，不會現在拉你去簽約台。',
    ctaFreeUpgradeFirst: '下一步：升級機器 → 下載手機 App → 打開雲瞳開始用。不用懂 AI，跟著做即可。',
    freeUpgradeStarted: '已開始免費升級引導：先升級機器，再裝 App，就能用。',
    noPromo: '此畫像本域暫無可加購能力卡',
    reload: '重新載入',
    goPortraits: '客戶畫像',
    goOrchestrate: '廣告編排',
    loadFail: '載入推廣面失敗',
    orchDesc: '人只選模式與框；真正排出檔期／對象／內容順序的永遠是 AI。',
    orchMode: '編排模式',
    orchMode1: '1 · 人工框＋AI 編排',
    orchMode2: '2 · 全開接管',
    orchMode1Hint: '先設範圍／內容／時間（可只設幾項），保存後 AI 只在框內編排頁底廣告。',
    orchMode2Hint: '不設限制，由 AI 全面決定誰／什麼／何時。仍禁止一次全推；月主題釘住，其餘按畫像補。',
    orchAudience: '推廣範圍',
    orchContent: '推廣內容',
    orchTheme: '本月主題',
    orchThemeHint: '空白＝用當月默認（現為 Leo＋雲瞳）。主題會一直釘在廣告帶；其餘按客戶畫像補。',
    orchThemeSkus: '主題 SKU',
    orchSchedule: '推廣時間',
    orchSkus: 'SKU／域包',
    orchAny: '不限（空白＝該維度不卡）',
    orchDates: '起迄日期',
    orchHours: '每日時段',
    orchStart: '開始',
    orchEnd: '結束',
    orchDailyStart: '每日開始',
    orchDailyEnd: '每日結束',
    orchSave: '保存',
    orchSaveOk: '已保存，AI 會按此框編排',
    orchSaveFail: '保存失敗',
    orchLoadFail: '載入編排設置失敗',
    orchGoSample: '沉浸推廣樣板',
    orchHelpFoot: '結果落在頁底廣告帶，不是再造功能入口。時區 Asia/Shanghai。',
    contentDesc: '商城推薦固定四格：標題、正文、圖片、視頻。文案必出繁／簡／英／日；每格可 AI 生成，也可一鍵全部生成。不滿意就改或上載自己的圖／視頻。',
    contentList: '推薦內容',
    contentTitleCol: '標題',
    contentFmtTitle: '標題',
    contentLangTw: '繁中',
    contentLangZh: '簡中',
    contentLangEn: 'EN',
    contentLangJa: '日本語',
    contentFmtBody: '正文',
    contentFmtImage: '圖片',
    contentFmtVideo: '視頻',
    contentGenAll: '一鍵全部生成',
    contentHint: '人的建議',
    contentHintPh: '例如：強調省路費、先試用七天、少講規格多講好處（只當方向，不會原文上稿）',
    contentGenPrompts: '生成提示詞',
    contentGenPromptNote: 'Cursor／產品寫的生成提示詞；點 AI 生成會套這些去調 Gemini。可改後直接生成或先保存。',
    contentPreview: '廣告預覽',
    contentPreviewEmptyImg: '還沒有圖，請生成或上載',
    contentPreviewEmptyVideo: '還沒有短片。點「生成」會出可播畫面，也可上載成片。',
    contentPreviewStoryboard: '視頻分鏡預覽',
    contentGenerate: 'AI 生成',
    contentSave: '保存上線',
    contentHook: '卡片一句',
    contentBlurb: '短句',
    contentDetail: '詳文',
    contentBenefits: '好處（一行一條）',
    contentBenefitsPh: '每行一條',
    contentSocial: '社媒帖正文',
    contentSource: '來源',
    contentImagePromptPh: '畫面提示（AI 會寫；可改）',
    contentVideoPromptPh: '分鏡／腳本（成片請上載）',
    contentNote: '這是給客戶的推薦，不是硬廣。圖片／視頻可 AI 生成，也可上載替換。',
    contentSaveOk: '已保存並上推薦帶',
    contentSaveFail: '保存失敗',
    contentGenOk: 'AI 已出稿並上線',
    contentGenLlmSkip: '文案 AI 沒連上，已保留原商品稿，沒有把你的建議貼上去。',
    contentGenImageFail: '圖片 AI 沒連上，沒有用底圖加字冒充。',
    contentGenVideoSkip: '短片要先有真圖，這次沒生成。',
    contentGenFail: '生成失敗',
    contentLoadFail: '載入內容庫失敗',
    contentHelpFoot: '投放看「廣告編排」；這裡只管商城四格內容。頁內預覽可看圖／視頻。'
  },
  addonDeviceScope: {
    title: '選擇設備範圍',
    hint: '雲瞳等按台計費：請勾選要開通的機台或門店；費用＝單價×台數。',
    confirm: '確認選購',
    quoteLine: '{count} 台 × {unit} = {total} {currency}'
  },
  commerceMatrixAlert: {
    title: '商業全景有 {n} 個未歸類頁面，租戶側欄已隱藏',
    openMatrix: '去處理'
  },
  capabilityAdoptionBanner: {
    title: 'Leo 還有這些能力你還沒用過',
    start: '開始引導',
    dismiss: '暫不'
  },
  billingAddonGuide: {
    panelTitle: '我的加購',
    sidebarPathHint: '固定入口：側欄 → 服務簽約 → 加購簽約 → 加購總覽',
    trialSection: '試用中',
    paySection: '待付款',
    goPay: '去付款',
    goAddonHub: '打開加購總覽',
    trialEnds: '試用至 {date}',
    bannerTrial: '您有加購功能試用中；入口在首頁「我的加購」與側欄「加購簽約」。',
    bannerPay: '「{sku}」試用已結束，請完成付款以繼續使用。',
    bannerPayBtn: '去付款',
    bannerDismiss: '稍後提醒',
    sidebarBadgeTrial: '試用',
    sidebarBadgePay: '待付',
    sidebarBadgeTitle: '加購試用或待付款',
    promoTrialPathHint: '待付或待確認項目在右上角購物車。'
  },
  trialFeature: {
    badgeTrial: '試用',
    summaryPill: '試用中 {n} 項',
    tooltipActive: '{name}：試用中，剩餘 {days} 天',
    tooltipExpiring: '{name}：試用即將結束（剩 {days} 天），請簽約續用',
    tooltipExpired: '{name}：試用已結束，請簽約開通',
    tooltipPaidActive: '{name}：已付費開通',
    popoverKicker: '試用狀態',
    trialStartOk: '試用已開通',
    trialStartFail: '試用開通失敗',
    trialAlreadyActive: '已在試用中',
    endTrial: '結束試用',
    endTrialConfirm: '結束試用後，雲瞳入口會關閉，也不會再提醒付款；買機自帶的基礎功能不受影響。確定結束？',
    endTrialHint: '不想繼續可隨時結束試用，不影響買機基礎功能。',
    endTrialOk: '已結束試用',
    endTrialFail: '結束試用失敗',
    addToCart: '加入購物車',
    addToCartOk: '已加入購物車',
    addToCartFail: '加入購物車失敗'
  },
  trialReadiness: {
    title: '試用就绪',
    autoDetectIntro: '以下三項由系統自動檢測，無需手動查設定；點「重新檢測」可刷新。',
    refresh: '重新檢測',
    scopeTitle: '試用設備範圍',
    scopeHint: '預設全部型號與設備；可選型號、門店或指定機碼（SN/IMIE）。',
    modelPlaceholder: '型號（不選＝全部）',
    storePlaceholder: '門店（不選＝全部）',
    devicePlaceholder: '機碼（不選＝範圍內全部）',
    deviceEmptyHint: '目前篩選下沒有可選設備；請清空型號／門店篩選，或確認品牌下已綁定機碼。',
    applyScope: '套用範圍',
    scopeSaved: '試用範圍已更新',
    scopeSaveFail: '更新試用範圍失敗',
    guideTitle: '怎麼立刻試用雲瞳',
    guideStep1: '確認雲端試用已開（上方雲端項為 ✅）。',
    guideStep2: '選好要試的設備範圍，至少一台在線且機型支持雲瞳。',
    guideStep3: '打開設備列表 → 該行操作 → 雲瞳。',
    guideStep4: '手機端可裝 Leo App 遠端看機（選填）。',
    openEntry: '去設備列表',
    deviceOnline: '在線',
    deviceOffline: '離線',
    samplesTitle: '範圍內設備快照',
    sampleNoIris: '機型不支持雲瞳',
    leoAppLoggedIn: '近 {days} 天內偵測到 Leo App 登入（品牌 {brandLogins7d} 次）。',
    leoAppNotSeen: '近 {days} 天未偵測到 Leo App 登入；請到 SOC 應用商店下載安裝（不擋 SOC 試用）。',
    leoAppDetectHint: '自動查會員登入紀錄，不用自己找設定。',
    cloudReady: '雲端試用權限已開，可直接用 SOC 雲瞳。',
    cloudMissing: '雲端試用尚未生效，請刷新或重新開通。',
    cloudDetectHint: '自動查加購 entitlement 是否仍在試用期。',
    cloudTrialBypassNote: '試用期間即使角色未勾「雲瞳遥控」也可開雲瞳。',
    deviceReady: '範圍內 {ready}/{total} 台可試（支持雲瞳且在線）。',
    deviceNone: '範圍內尚無設備，請先綁定或調整篩選。',
    deviceNoIrisSupport: '範圍內 {total} 台設備，但尚無支持雲瞳的機型（泡茶機／咖啡機族）。',
    deviceNeedsOnline: '範圍內 {irisCapable} 台支持雲瞳，僅 {online} 台在線；請開機聯網。',
    deviceDetectHint: '自動查設備在線狀態與機型是否支持雲瞳。',
    actionLeoApp: '去 SOC 應用商店下載',
    actionDevices: '查看設備列表',
    check: {
      leoApp: 'Leo App（手機）',
      cloud: '雲端權限',
      device: '設備在線＋雲瞳支持'
    }
  },
  billingCart: {
    title: '待辦賬單',
    empty: '暫無待付或待確認項目',
    refresh: '刷新',
    trackAddon: '加購',
    trackContract: '簽約',
    statusConfirm: '待確認',
    statusPay: '待付款',
    statusTrial: '試用待購',
    statusRenew: '待續費'
  },
  billingOrder: {
    documentTitle: 'XRROSS 服務訂單',
    documentSubtitle: '請核對費用明細與彙總後確認或付款（商業 Order Form）',
    orderNo: '訂單編號',
    orderDate: '開單日期',
    partyTitle: '訂單雙方',
    seller: '賣方',
    buyer: '買方（品牌商）',
    currency: '幣別',
    billType: '訂單類型',
    lineItems: '訂單明細',
    salesOrderTitle: '銷售訂單明細',
    scheduleOfFeesTitle: '費用明細（Schedule of Fees）',
    stickyPayLabel: '本檔應付',
    stickyPayHint: '方案：{scheme} · 目前 {devices} 台',
    deviceSummaryHint: '依設備類別與單價分組；同價格同類別合併顯示台數。',
    feeSummaryTitle: '費用彙總',
    listExTaxUsd: '美金价目（未税）',
    fxRate: '匯率',
    subtotalExTax: '未稅小計',
    addonExtra: '加購（雲瞳等）',
    taxAmount: '稅額',
    colLineNo: '序號',
    colSku: 'SKU',
    colMachineCode: '機碼',
    colDeviceType: '設備類型',
    colModel: '型號',
    colSite: '歸屬',
    colService: '服務項',
    colServiceDefault: '設備數據年費',
    grandTotal: '合計',
    colDescription: '服務說明',
    colSegment: '場景',
    colQty: '數量',
    colUom: '單位',
    colUnitPrice: '單價',
    colBillingFreq: '計費週期',
    colAmount: '行金額',
    freqYearly: '年',
    freqMonthly: '月',
    termsTitle: '條款與聲明',
    termsHint: '付款前請展開閱讀；確認或付款即表示同意下列條款。',
    paymentTermsTitle: '付款條款',
    paymentTermsSummary: '本單付款條件：{term}。',
    paymentTermsSummaryDefault: '本單以訂單所列幣別與金額為準，須於指定期限內完成付款。',
    paymentTermsBody1: '逾期未付可能暫停服務；已付金額依合同／加購條款處理，不退還已開通期間之服務費（另有書面約定者除外）。',
    paymentTermsBody2: '微信／PayPal 等通道之手續費、匯率差異由付款方自行承擔；到賬以 XRROSS 公司收款帳戶入帳為準。',
    usageTermsTitle: '使用條款',
    usageTermsSummaryContract: '本服務合同涵蓋之 SOC 門戶、設備數據或按店訂閱功能，僅供授權品牌商及其門店／設備使用，不得轉售或超範圍調用 API。',
    usageTermsSummaryAddon: '加購「{sku}」僅在付款／試用授權範圍內啟用；到期未續費將自動降級或停用相關功能。',
    usageTermsBody1: '您應確保有權代表企業簽約並付款；帳號操作、Leo 指令與設備遠端操作之後果由企業自行負責。',
    usageTermsCancelAnytime: '本加購標示可隨時取消；取消後下一計費週期不再扣款，已付期間不退費。',
    serviceTermsTitle: '服務條款與免責',
    serviceTermsBody1: 'XRROSS SOC 平台服務依《隱私政策》《服務條款》與《免責聲明》提供；設備現場安全、食安與第三方金流由客戶自行管理。',
    serviceTermsBody2: '電子確認、付款時間戳與帳號紀錄得作為履約證據；爭議以合同／訂單所載條款及適用法律為準。',
    viewPlatformTerms: '查看平台完整條款',
    totalDue: '應付合計',
    promoTitle: '優惠券',
    promoSelectHint: '可選一張或多張優惠券，套用後更新應付金額（每單僅可套用一次）。',
    promoApplyBtn: '套用優惠券',
    promoAppliedTitle: '已套用優惠',
    promoDiscount: '優惠減免',
    promoSubtotalBefore: '優惠前小計',
    promoEmpty: '目前沒有可用的優惠券',
    trialEndsAt: '試用截止',
    paymentTermNet7: '開票後 7 日內付款',
    paymentTermNet15: '開票後 15 日內付款',
    paymentTermNet30: '開票後 30 日內付款',
    paymentTermNet45: '開票後 45 日內付款',
    paymentTermNet60: '開票後 60 日內付款',
    paymentTermPrepaid: '預付／先付後用',
    paymentTermDueOnReceipt: '收票即付'
  },
  brandServiceContract: {
    title: '服務簽約',
    pageDesc: '依品牌商制定計費條款，支援郵件確認／電子簽後啟用；條款寫入 terms_json 供自動帳單。',
    helpTitle: '本頁說明（點擊展開）',
    help1: '選擇品牌商與三種計費方法之一，填寫付款條件與價目。',
    help2: '選定確認通道：發郵件、電子簽、門戶確認或線下口頭。',
    help3: '須確認後才可啟用數據服務合同；Leo 基礎買機即含，加購在下方可試用、可取消。',
    create: '新建簽約',
    tabContracts: '合同列表',
    tabEntitlementTree: '權限樹已購',
    treeNeedBrand: '請先選品牌商，再按側欄同一棵樹查看已購／待購。',
    treePickContract: '選合同',
    treeInContract: '在合同',
    treeLockedPrice: '鎖價',
    treeQty: '數量',
    treePayable: '應付',
    treeLineStatus: '狀態',
    treeStatusInScope: '已購',
    treeStatusNotPurchased: '待購',
    treeFilterInContract: '已購篩選',
    treeFilterAll: '全部',
    treeFilterPurchased: '僅已購',
    treeFilterNotPurchased: '僅待購',
    treeFilterKeyword: '搜選單／SKU',
    createTitle: '新建品牌服務簽約',
    bundleTier: '四檔算價',
    bundleTierT1: '① 純 SOC $49/店/月',
    bundleTierT2: '② 全店打包 $199/店/月',
    bundleTierT3: '③ 純設備按台',
    bundleTierT4: '④ SOC $99 + 按台',
    bundleTierPaperLock: '紙質鎖定（不重算價目）',
    priceBookSku: '價目表模板',
    priceBookSkuPh: '從 HQ 價目表選合同計價模板',
    needPriceBookSku: '請先選價目表模板；無對應 SKU 無法計算合同金額',
    brand: '品牌商',
    brandId: '品牌商ID',
    status: '狀態',
    statusDraft: '草稿',
    statusPendingHqApproval: '待總部審',
    statusApproved: '已批准',
    statusPendingTenantConfirm: '待租戶確認',
    statusPendingPay: '待付款',
    statusActive: '已啟用',
    statusSuspended: '已暫停',
    statusExpired: '已到期',
    statusCancelled: '已取消',
    contractNo: '合同號',
    pricingMethod: '計費方法',
    pricingTiered: '年費＋台數階梯',
    pricingPerDevice: '每台週期費',
    pricingPerStoreMonth: '按店／月（含最少月數）',
    pricingPerDeviceMonth: '按台／月（含最少月數）',
    pricingPerStoreDay: '按店／天現結',
    pricingPerDeviceDay: '按台／天現結',
    minContractMonths: '最少簽約月數',
    periodMonths: '本合同月數',
    dayCount: '使用天數',
    pricingSocStore: 'SOC 按店訂閱（推薦）',
    addonPricingOneTime: '一次性加購',
    addonPricingPerDeviceYear: '每台／年',
    addonPricingPerStoreYear: '每店／年',
    addonPricingPerHouseholdYear: '每戶／年',
    addonPricingTrialThenPaid: '試用後付費',
    addonPricingAiPoints: 'AI 點數包',
    addonPricingModule: '模組加購',
    addonPricingCustomQuote: '專案報價',
    paymentTerm: '付款條件',
    currency: '幣種',
    confirmChannel: '確認通道',
    confirmStatus: '確認狀態',
    confirmNone: '未確認',
    confirmPendingEmail: '待郵件確認',
    confirmPendingEsign: '待電子簽',
    confirmEmailOk: '郵件已確認',
    confirmSigned: '已電子簽',
    confirmPortalOk: '門戶已確認',
    confirmRejected: '已拒絕',
    confirmExpired: '確認已過期',
    confirmPendingTenant: '待租戶確認',
    cycleYearly: '按年',
    cycleQuarterly: '按季',
    cycleMonthly: '按月',
    cycleDaily: '按天',
    paymentTermDepositBalance: '訂金＋尾款',
    paymentTermInstallment: '分期付款',
    period: '週期',
    actions: '操作',
    tierCode: '合同檔位',
    unitPrice: '單台單價',
    tiers: '價目階梯',
    addTier: '加一行階梯',
    legacyOral: '口頭舊約',
    confirmSection: '簽約確認',
    chEmail: '郵件確認',
    chEsign: '電子簽',
    chPortal: '門戶確認',
    chManual: '線下／口頭',
    confirmEmail: '收件郵箱',
    signerRole: '簽署人角色',
    signerName: '簽署人姓名',
    mailLocale: '郵件語言',
    requireConfirm: '須確認後才可啟用',
    addonTitle: 'SOC／Leo 加購（試用可取消）',
    addonHint: '買機含 Leo 基礎免費；此表僅加購。家用／商用分清單。',
    addonHome: '家用',
    addonCommercial: '商用',
    addonName: '名稱',
    addonTrialDays: '試用天',
    addonUsdPrice: 'USD 標價',
    addonBillingCycle: '付費週期',
    addonBillingYearly: '年付',
    addonBillingMonthly: '月付',
    addonCancel: '可取消',
    addonStartTrial: '開始試用',
    addonWxPay: '微信支付',
    addonPaypal: 'PayPal',
    addonPaypalOpen: '已打開 PayPal 付款頁（海外 USD）',
    addonPaypalStub: 'Stub 已記開通（不是真收款）',
    addonPaypalNoUrl: '沒有 PayPal 跳轉網址',
    addonWxTitle: 'XRROSS 公司微信收款',
    addonWxHonesty: '掃碼付款進公司戶（賣 SOC／硬體），不是店客單。未配商戶密鑰時為模擬碼。',
    addonWxSim: '模擬已付',
    addonWxPaid: '已記已付（模擬≠真到賬，除非已配公司商戶）',
    addonWxQrFail: '無法產生收款碼',
    addonWxNoEntitlement: '找不到加購試用單，請先試用',
    addonNeedBrand: '請先在上方篩選品牌商再試用',
    addonTrialOk: '已開始試用',
    quoteLine: '預覽：約 {amount} {currency}／{period}（台數 {devices}，店數 {stores}）',
    quoteTrackA: 'A 小計（設備數據）',
    quoteTrackB: 'B 小計（店務運營）',
    quoteBundle: '套餐價',
    quotePayable: '應付',
    quoteExTax: '未稅小計',
    quoteExTaxShort: '未稅',
    quoteTax: '稅額',
    quoteTaxInclusive: '含稅合計',
    taxRegion: '計稅稅區',
    quoteExportPdf: '匯出報價單',
    quotePrintTitle: '官方結構報價單',
    needBrandPricing: '請選擇品牌商與計費方法',
    needEmail: '郵件確認須填寫郵箱',
    sendEmail: '發確認郵件',
    portalAck: '門戶確認',
    markEsign: '標記已簽',
    activate: '啟用',
    suspend: '暫停',
    suspendReason: '暫停原因（可選）',
    esignUrlHint: '簽章憑證 URL（可選）',
    mailSent: '確認郵件已發送',
    mailStub: '郵件未發出（已生成令牌，可複製）',
    summaryTitle: '簽約總表',
    summaryPageDesc: '看各品牌商要確認、要付錢、已開通的費用單；點詳情看明細。',
    summarySimpleIntro: '三種費用會列在這裡：① 平台服務費（管設備／數據）② 額外買的功能 ③ 買機器的付款單。每一行就是一筆事，不是重複資料。',
    summaryGoDesk: '新建簽約',
    startPipeline: '開始標準流水線',
    pipelineTitle: '簽約標準流水線',
    pipelineDesc: '草稿 → 總部批 → 品牌簽回 → 付款 → 開通；點節點可跳到對應頁並開助手。',
    pipelineNow: '當前',
    flowNode_bsc_draft: '建草稿',
    flowNode_bsc_hq_approve: '總部批',
    flowNode_bsc_tenant_confirm: '品牌簽回',
    flowNode_bsc_pay: '付款',
    flowNode_bsc_active: '已開通',
    addonStartPipeline: '開始加購流水線',
    addonPipelineTitle: '加購標準流水線',
    addonPipelineDesc: '試用／直購 → 付款 → 開通（標準 SKU 免總部批）。',
    flowNode_sla_start: '試用／直購',
    flowNode_sla_pay: '付款',
    flowNode_sla_active: '已開通',
    quickAll: '全部',
    quickActionAdmin: '待我處理',
    quickActionTenant: '待我確認',
    quickPay: '待付款',
    quickOverdue: '已逾期',
    quickActive: '已開通',
    statPendingPay: '待付款',
    statOverdue: '已逾期',
    statActive: '已開通',
    filterBrandPh: '搜品牌商',
    filterTypePh: '費用類型',
    showAdvanced: '更多篩選',
    hideAdvanced: '收起篩選',
    colBrand: '品牌商',
    colItem: '什麼費用',
    colSituation: '現在怎樣',
    colAmount: '應付',
    colDueDate: '下次到期',
    trackShortContractA: '平台服務費',
    trackShortAddonB: '額外功能',
    trackShortHardware: '買機器',
    situationPendingHq: '等你批准',
    situationPendingConfirm: '等你確認簽約',
    situationPendingPay: '待付款',
    situationOverdue: '已逾期',
    situationActive: '已開通',
    situationSuspended: '已暫停',
    situationDraft: '草稿',
    situationHardware: '硬件付款',
    situationOther: '其他',
    actionApprove: '批准',
    actionConfirm: '去確認',
    actionReject: '駁回',
    goDesk: '簽約台',
    paymentStatus: '付款狀態',
    payUnpaid: '未付',
    payPaid: '已付',
    payPartial: '部分付',
    payOverdue: '逾期',
    amountDue: '應付',
    amountPaid: '已付金額',
    nextDueAt: '下次到期',
    expiredOnly: '僅到期／逾期',
    editPayment: '編輯付款',
    editPaymentTitle: '編輯付款狀態',
    totalContracts: '合同數',
    totalActive: '已啟用',
    totalUnpaid: '未付／部分',
    totalOverdue: '付款逾期',
    totalDue: '應付合計',
    totalOutstanding: '未結合計',
    viewDetail: '詳情',
    detailTitle: '簽約詳情',
    detailPageDesc: '正式銷售訂單（機型／數量／單價／彙總）與收費歷史；與確認頁同一套 Order Form。',
    backSummary: '返回總表',
    goConfirmOrder: '打開確認／簽回',
    detailPayWaitHq: '此單尚待總部核准，核准後才可確認／付款。',
    detailPayWaitConfirm: '請先完成門戶確認／簽回，狀態變為待付款後才會出現付款鈕。',
    detailPayNoAction: '目前狀態不可付款；請用右上角「打開確認／簽回」或「去付款」（待付款時）。',
    detailMerchant: '商戶',
    detailScope: '產品／服務範圍',
    detailPricing: '價格與計費',
    detailDates: '生效與到期',
    detailChargeHistory: '收費歷史',
    chargeTime: '時間',
    chargeEvent: '事件',
    chargeNote: '備註',
    amountDelta: '已付增減',
    effectiveFrom: '生效起',
    effectiveTo: '生效迄／到期',
    devicesStores: '計費台數／店數',
    detailLoadFail: '載入詳情失敗',
    track: '軌道',
    trackContractA: '服務合同',
    trackAddonB: '加購',
    trackHardware: '硬體採購',
    deskPhase: '待辦階段',
    phasePendingHq: '待總部審',
    phasePendingConfirm: '待確認',
    phasePendingPay: '待付款',
    phaseOverdue: '逾期',
    phaseSuspended: '已停服',
    hqApprove: '總部批准',
    hqReject: '總部駁回',
    hqApproveOk: '已批准並通知品牌商',
    hqRejectOk: '已駁回',
    submitApproval: '提交審批',
    batchSelected: '已選 {n} 筆',
    batchSubmit: '批量提交審批',
    batchHqApprove: '批量總部批准',
    batchHqReject: '批量總部駁回',
    batchSendEmail: '批量發確認信',
    batchActivate: '批量激活',
    batchSuspend: '批量暫停',
    batchClear: '取消選擇',
    batchAllOk: '{n} 筆全部成功',
    batchPartial: '成功 {ok} 筆，失敗 {fail} 筆（{err}）',
    batchConfirmSubmit: '確認將 {n} 筆合同提交總部審批？',
    batchConfirmActivate: '確認激活 {n} 筆合同？',
    contractLineItem: '服務項目',
    priceLockedHint: '以下單價已從價目表鎖定，確認後寫入合同',
    discountPct: '折扣％',
    discountPctPh: '0 表示無折扣',
    discountReasonPh: '優惠原因（可選）',
    hqRejectReasonPh: '駁回原因',
    billingConfirmTitle: '賬單／合同確認',
    schemePickTitle: '選擇計費方案',
    addonTrackBTitle: '加購一併出單（Track B）',
    addonTrackBHint: '雲瞳等加購與 Track A 服務合同同頁列出；計費 entitlement 獨立，總表可合併查看。',
    cloudIrisPickHint: '確認簽回前可勾選要開通雲瞳的機台；金額按台數重算。',
    cloudIrisPickBtn: '選機',
    cloudIrisPickOk: '雲瞳選機已更新',
    schemePickHint: '請按機台規模選擇套餐／按台年費／台數階梯等方案；點選後下方金額與明細會立刻更新；滑鼠移到方案上可看說明與單價組成，鎖定後再確認簽回。',
    schemePickHintSimple: '點一張卡片選方案；展開後在同一張卡裡選數量檔，下方「應付」會立刻更新。',
    schemePickHintPaperLock: '紙質合同已鎖年費與台數上限，不按價目表重算；請確認後簽回。',
    tierEmbedTitle: '選數量檔（越多越省）',
    tierEmbedHint: '點一檔即可；目前落檔已標示。選更高檔＝預購到該檔最少台數，單價更低。',
    storeTierEmbedTitle: '選店數檔（越多越省）',
    storeTierEmbedHint: '點一檔即可；目前落檔已標示。選更高檔＝預購到該檔最少店數。',
    brandRoleTitleReadonly: '您的類型',
    brandRoleLockedHint: '由平台定案，不可自改',
    schemeCardBlurbDefault: '點選後即可在下方查看應付與明細。',
    deviceTierLadderHint: '數量越多單台越便宜。下表用您目前台數對比各檔；升檔可省多少一眼可見。',
    storeTierLadderHint: '店數越多單店越便宜。下表用您目前店數對比各檔。',
    tierLadderTitle: '台數階梯（越多越省）',
    storeTierLadderTitle: '店數階梯（越多越省）',
    tierLadderBand: '檔位',
    tierLadderRange: '台數範圍',
    tierLadderDiscount: '折扣',
    tierLadderUnit: '有效單價',
    tierLadderQty: '計費台數',
    tierLadderQtyStore: '計費店數',
    tierLadderTotal: '合計',
    tierLadderSaveVsPrev: '比上一檔省',
    tierLadderSaveVsPrevAmt: '比上一檔同台數省 {amount}',
    tierLadderCurrent: '目前落檔',
    tierLadderNegotiated: '特批協商',
    tierLadderNeedPrepaid: '須預購≥{count}',
    tierLadderNeedPrepaidStore: '須預購≥{count}店',
    tierLadderFootnote: '以上以目前 {count} 台對比；若選「預購鎖檔」，須達到該檔最少台數才能用更低單價。',
    schemeHoverHint: '將滑鼠移到方案上查看詳細說明與單價組成',
    schemeUnitComposeTitle: '單價組成',
    schemeUnitComposeEmpty: '本方案暫無逐台／逐店單價拆解（以合計為準）。',
    schemeUnitComposeFlat: '單價 {unit} {currency} × {qty}',
    schemeUnitComposeTotalOnly: '本方案按合計報價 {total} {currency}（無更細單價拆解）。',
    schemeExplain_DEFAULT: '該方案按價目表估算；鎖定後寫入合同應付與明細。',
    schemeExplain_T1: '① 純 SOC：只收門店 SOC 訂閱（按店／月），帳單不含機台數據年費。已有機台請改選②全店打包或④ SOC＋按台；本檔適合先開通門戶、暫不算設備年費。',
    schemeT1DeviceGuideTitle: 'T1 純 SOC 不含機台費用',
    schemeT1DeviceGuideDesc: '目前品牌子樹約有 {count} 台設備。選 $49／月只收 SOC，不會自動加上設備年費。若機台也要計費，請改選「全店打包」或「SOC＋按台分項」。',
    schemeT1DeviceBlockTitle: '方案備註（T1 純 SOC）',
    schemeT1DeviceBlockDesc: '目前品牌子樹約有 {count} 台設備。已有機台時 T1（$49／純 SOC）通常不適用，建議改選「全店打包」或「SOC＋按台分項」後再鎖定。',
    brandRoleTitle: '品牌商類型（影響推薦）',
    brandRoleOperator: '品牌運營商',
    brandRoleEquipment: '做設備（廠／通路）',
    schemeRecommendTitle: '系統推薦 · 最划算',
    schemeRecommendBadge: '推薦',
    schemeRecommendApply: '採用推薦方案',
    schemeRecommendApplied: '已套用推薦方案與付款節奏',
    schemeRecommendReasonNone: '暫無可推薦方案，請人工選擇。',
    schemeRecommendReasonEquipment: '判定為做設備（約 {deviceCount} 台、{storeCount} 店）：不必買 SOC，推薦純設備檔 {code}，年化約 {amount} {currency}。',
    schemeRecommendReasonOperator: '判定為品牌運營商（約 {storeCount} 店、{deviceCount} 台）：在可選方案中 {code} 年化約 {amount} {currency} 最划算。',
    schemeRecommendReasonOperatorAnnual: '判定為品牌運營商：推薦 {code}，並以預繳年 85 折計，年化約 {amount} {currency}（含月費折扣口徑）。',
    schemeExplain_T2: '② 全店打包：按店／月打包 SOC 能力（比純 SOC 檔更高），仍以門店訂閱為主；適合全店數位化但暫不拆機台明細的場景。',
    schemeExplain_T3: '③ 純設備按台（年）：只收品牌子樹下各機台設備數據年費，按型號／機碼列明細；不含 SOC 店費。適合「已有機台、按台計費」的現況合同。',
    schemeExplain_T4: '④ SOC＋按台分項：門店 SOC 訂閱＋各機台設備年費一併報價；適合門戶與機台數據服務都要的完整檔。',
    schemeExplain_PER_DEVICE_YEARLY: '按台年費：品牌子樹每台設備一條明細，單價來自價目表對應 SKU（如配料機年費），合計＝各台行金額之和。',
    schemeExplain_TIERED_ANNUAL_POOL: '台數池階梯年費：按品牌子樹台數落入價目階梯（台越多單價可能更划算）；現況明細仍可按台列示便於對帳。',
    schemeLockBtn: '鎖定此方案',
    schemeLockOk: '計費方案已鎖定',
    schemeLockFail: '鎖定方案失敗（需後台已部署選方案接口）',
    deviceTierLockTitle: '台數檔位（設備資料）',
    deviceTierLockHint: '可按現況台數自動落檔，或選預購臺階：按該檔最少台數預繳，檔內單價鎖定。',
    deviceTierModeActual: '現況台數（{count} 台）',
    deviceTierModePrepaid: '預購臺階鎖檔',
    committedDeviceCountLabel: '承諾台數',
    committedDeviceCountHint: '須 ≥ 現況台數；鎖定後按承諾台數算檔與應付。',
    committedDeviceCountInvalid: '承諾台數須不少於現況 {min} 台',
    storeTierLockTitle: '店數檔位（按店計劃）',
    storeTierLockHint: '選店鋪計劃後可按現況店數落檔，或選預購臺階：按該檔最少店數預繳。',
    storeTierModeActual: '現況店數（{count} 店）',
    storeTierModePrepaid: '預購臺階鎖檔',
    tierBandPickHint: '請選擇臺階；預繳數量＝該檔下限與現況的較大者。',
    tierBandPrepaidMin: '預繳 {count} 台',
    storeTierBandPrepaidMin: '預繳 {count} 店',
    tierBandRequired: '請先選擇一個臺階',
    tierBandUnavailable: '該臺階對現況數量不可用，請改選更高檔',
    tierGrowthPolicyHint: '合同期內多出來的數量（仍在本檔）按同檔單價×剩餘期限補差；跨下一檔須改簽，不自動升檔。',
    paymentCadenceTitle: '付款節奏（付款條件優惠）',
    paymentCadenceHint: '月費固定部分可按月繳，或一次預繳全年享 85 折（按台年費等不打折）。選好後點鎖定，應付金額會更新。',
    paymentCadenceMonthly: '按月繳',
    paymentCadenceMonthlyNote: '當期月費固定部分（其它年費行另計）',
    paymentCadenceAnnual: '預繳年 · 85 折',
    paymentCadenceAnnualNote: '月費×12×0.85 一次付清（其它年費行原價）',
    paymentCadenceLockBtn: '鎖定此付款節奏',
    paymentCadenceLockOk: '付款節奏已鎖定，應付已更新',
    paymentCadenceLockFail: '鎖定付款節奏失敗',
    billingConfirmDesc: '總部已批准後，請在此電子確認條款；確認後進入待付款。',
    billingConfirmBtn: '我確認條款',
    billingConfirmOk: '已確認，請完成付款',
    billingConfirmDone: '本單已確認或不可再確認',
    billingConfirmMissing: '缺少 track／sourceId 或無權查看',
    billingPayActive: '服務已開通'
  },
  opsAnalytics: {
    subtitle: '本店／本區圖表 + AI 建議；對手情報另計加購',
    month: '月份',
    storeId: '店鋪 ID',
    query: '查詢',
    goPnl: 'P&L 工作台',
    skuHint: '圖表／本區：COM_ANALYTICS_AI；對手＋深度建議：COM_COMPETITOR_INTEL＋AI 點數',
    areaTitle: '本區店鋪對比',
    store: '店鋪',
    compTitle: '競爭對手分析',
    compSku: '競爭情報加購',
    compName: '對手',
    rating: '評分',
    reviews: '評論數',
    priceBand: '價帶',
    salesHonesty: '銷售誠實態',
    aiTitle: 'AI 建議（短）',
    catalogTitle: '報表目錄（最大集）',
    kpi: { revenue: '營收', gross: '毛利', net: '淨額', aov: '客單', tickets: '單量', labor: '人工佔比' },
    charts: { rev: '營收趨勢', hour: '時段熱力', item: '品項排行', channel: '渠道結構', area: '本區排名' }
  },
  tokenBilling: {
    pageTitle: 'AI 點數帳單平台',
    pageLead: '依目前登入企業彙總 Leo 用量與入帳扣款；對外顯示 AI 點數，內部仍為 token ledger。維護上游成本與參考售價供毛利估算（近 30 日）。'
  },
  leoE2: {
    webMarketSearch: '熱銷網搜',
    webMarketHintTitle: '熱銷網搜已接後端（草案）',
    webMarketHintDesc: '會搜公開資料並解析用料草案，僅 DRAFT；仍須物料 ID 預檢與人閘。不等於生產硬綠，不會自動下發。',
    webQuery: '網搜關鍵詞',
    webQueryPh: '例：新茶飲 熱銷 茉莉奶綠 用料（可空，用預設熱銷查詢）',
    webSearchBtn: '網搜並轉入開場',
    webSearchFail: '熱銷網搜失敗',
    e21Tab: 'E21 智能配方',
    e21AlertTitle: 'E21 對話試泡閉環（茶機一期 · 模擬機先）',
    e21Banner: '流程：開會話 → 首次應用人閘 → 試泡 → 口味回饋微調 → 正式保存 PRIVATE+VERIFIED。PRODUCTION 可聊禁下發。硬規：泡茶機試泡＝茶葉（散葉），不是茶粉。',
    e21Entry: '入口',
    e21HasMenu: '有菜單／品項文字',
    e21CompetitorPaste: '競品用料貼上',
    e21MenuText: '菜單文本',
    e21MenuPh: '貼上客戶菜單／競品用料，將編譯草案並作 E21 開場',
    e21ApplyOpener: '轉入開場話',
    e21TrialMaterial: '目前試泡物料：{label}',
    e21TeaLeaf: '茶葉',
    e21TargetUrn: '目標機 URN',
    e21DeviceOpsMode: 'deviceOpsMode',
    e21StartMessage: '開場話',
    e21Start: '開會話',
    e21ConfirmFirst: '確認首次應用',
    e21Trial: '試泡',
    e21FormalSave: '正式保存',
    e21TurnFeedback: '多輪／回饋',
    e21TurnPh: '例如：這泡偏苦再淡一點／滿意了正式保存',
    e21SendTurn: '發送 turn',
    e21SendFeedback: '發送 feedback',
    e21SessionState: '會話狀態',
    e21NeedUrnAndMessage: '請填目標機與開場話',
    e21SessionOpened: 'E21 會話已開',
    e21StartFail: '開會話失敗',
    e21FirstConfirmed: '首次應用已確認',
    e21FirstCancelled: '已取消首次應用',
    e21FirstFail: '首次應用失敗',
    e21TrialStarted: '試泡已發起',
    e21TrialFail: '試泡失敗',
    e21NeedUtterance: '請輸入話術',
    e21TurnFail: 'turn 失敗',
    e21NeedFeedback: '請輸入回饋',
    e21FeedbackOk: '已收回饋',
    e21FeedbackFail: 'feedback 失敗',
    e21Saved: '已正式保存 PRIVATE+VERIFIED',
    e21SaveCancelled: '已取消保存',
    e21SaveFail: '正式保存失敗',
    e21HotSellOpener: '搜一下市场上热销的茶'
  },
  x600hProductionOrder: {
    pageDesc: '雙軌產線：安卓先聯雲、9100 先 HF 配網；再綁碼／廠檢／出廠。頁上可開工廠標準流水線。',
    startStandardPipeline: '開始全自動流水線',
    socPipelineNodeTodo: '未開始',
    socPipelineNodeCurrent: '進行中',
    socPipelineNodeDone: '已完成',
    startOpenStorePipeline: '開始開店流水線',
    startBusinessHoursPipeline: '開始營業時間流水線',
    pipelineStarted: '已打開批量加設備全自動流水線（含建工廠），請按節點逐步做。',
    togoOpen: '工單待辦',
    togoTitle: '工單待辦',
    togoRemain: '還差 {n} 步',
    togoAllDone: '四步都過了',
    togoStuck: '卡住',
    togoHint: '打勾只認系統狀態。點卡住的步驟可跳真頁，或開口跟 Leo 說、填同一張單。',
    togoVoice: '跟 Leo 說',
    togoClose: '關閉',
    togoLoadFail: '待辦清單載入失敗',
    togoStep_demand_placed: '需求已落單',
    togoStep_hq_confirm: '總部確認',
    togoStep_factory_ready: '工廠可交貨',
    togoStep_customer_activate: '客戶現場激活',
    flowNow: '目前',
    flowHint: '格子連成一條線：綠的已過、黃的是卡住這一步、灰的還沒到。點格子跳到本單對應位置。',
    flowNode_hq: '總部確認',
    flowNode_open: '打開本單',
    flowNode_bind: '機讀綁碼',
    flowNode_handshake: '9100握手',
    flowNode_ship: '出廠確認',
    flowNode_activate: '客戶激活',
    simplePipelineTitle: '全自動流水線：批量加設備',
    simplePipelineDesc: '為配合全球設備統一管理：建工廠 → 登記供應夥伴 → 建產線單 → 等系統確認。不要用設備列表手建頂替。',
    pipelineNow: '目前',
    pipelineDone: '完成',
    pipelineTodo: '未開始',
    pipelineWaitHq: '等待系統確認',
    flowNode_bbds_create_factory: '建工廠',
    flowNode_bbds_register_s0: '登記供應廠',
    flowNode_bbds_create_order: '建產線單',
    flowNode_bbds_wait_hq: '等系統確認'
  },
  deviceOrderLifecycle: {
    title: '設備主鏈引導',
    desc: '建單到客戶：S1～S7 跳真頁；可按總部／品牌／工廠開智能引導。',
    roleHq: '總部',
    roleBrand: '品牌',
    roleFactory: '工廠',
    hintHq: '總部：審單、發號、看全鏈。',
    hintBrand: '品牌：建單、收貨／下放、客戶激活入口。',
    hintFactory: '工廠：聯雲／配網、綁碼、首檢、出廠（主 UI 仍在 Leo 工廠包）。',
    startSmartGuide: '開本角色智能引導',
    openPage: '打開本步真頁',
    prev: '上一步',
    next: '下一步',
    guideStarted: '智能引導已開始，可在 Leo 助手繼續檢查。',
    guideStartFail: '無法開始智能引導（權限或後台未重啟）',
    s1Title: '建產線訂單',
    s1Short: '品牌建單',
    s1Body: '在「產線訂單」新建訂單：數量、型號、雲區。提交後等總部確認。',
    s2Title: '總部確認',
    s2Short: '審單釘死',
    s2Body: '總部確認後數量／型號／雲區釘死，進入可發號與產線。',
    s3Title: '發號同步',
    s3Short: '跨區發號',
    s3Body: '在「發號同步」確認號段與跨區副本 ACK。',
    s4Title: '聯雲／配網與綁碼',
    s4Short: '工廠產線',
    s4Body: '安卓先「生產聯雲」、9100 先「HF 生產配網」；再機讀綁碼與廠檢／首檢。禁止手填主路徑。',
    s5Title: '出廠確認',
    s5Short: '可交貨',
    s5Body: '首檢通過後出廠確認。未出廠則客戶不可激活；出廠≠開始計費。',
    s6Title: '品牌收貨／下放',
    s6Short: '到店／客戶',
    s6Body: '品牌在設備列表完成收貨或下放給門店／終端客戶。',
    s7Title: '客戶首啟／現場配網',
    s7Short: '激活開收',
    s7Body: '用 Leo「現場配網」選雲區→WiFi；「更換 WiFi」只改 STA。首啟後寫客戶激活（出廠≠開收）。硬體認證頁可核對開收閘。'
  },
  globalDevice: {
    catalogTitle: '型號目錄',
    catalogDesc: '新型號須申請待審；僅東京寫中心可批准寫入總表。',
    catalogHint: '全球型號 Catalog：節點申請 → 東京審批',
    catalogApply: '申請新型號',
    applyManageTitle: '型號申請',
    applyManageDesc: '管理各節點型號申請：提交、待審列表、東京批准／拒絕。',
    submitApply: '提交申請',
    applyRequired: '請填寫型號代碼與名稱',
    applySubmitted: '已提交，狀態為待審',
    modelKey: '型號代碼',
    modelName: '型號名稱',
    deviceFamily: '設備族',
    applyStatus: '申請狀態',
    applicantRegion: '申請區',
    publishedModelId: '已發布型號ID',
    rejectReason: '拒絕原因',
    notes: '備註',
    approve: '批准',
    reject: '拒絕',
    confirmApprove: '確認批准並寫入東京總表？',
    approved: '已批准並寫入總表',
    rejected: '已拒絕',
    waitingTokyo: '待東京審核',
    centerRole: '寫中心角色',
    statusPending: '待審 PENDING',
    statusApproved: '已批 APPROVED',
    statusRejected: '已拒 REJECTED',
    openApplyManage: '打開型號申請管理',
    governanceGapJump: '整治缺口',
    simplePipelineTitle: '全自動流水線：申請新機型',
    simplePipelineDesc: '為配合全球設備統一管理：打開申請頁 → 提交一條 → 等東京批准。不要在本地私自建正式型號。',
    pipelineNow: '目前',
    pipelineDone: '完成',
    pipelineTodo: '未開始',
    pipelineWaitTokyo: '等待東京',
    startSimplePipeline: '開始全自動流水線',
    pipelineStarted: '已打開型號申請全自動流水線，請按節點逐步做。',
    flowNode_bcas_open_apply: '打開申請頁',
    flowNode_bcas_submit_apply: '提交申請',
    flowNode_bcas_wait_tokyo: '等東京審核'
  },
  dispenserDataCenter: {
    precisionDesc: '精準度 = 實際出料 ÷ 配方出料；用於配料機出料校準與出品品質監視。',
    lossDesc: '按物料對比配方出料與實際出料差額，定位損耗與超量。',
    multiMachineDesc: '配料機與泡茶機供料綁定工作台入口（複用多機互聯）。',
    refresh: '刷新',
    imiePlaceholder: '設備 IMIE（可空＝租戶匯總）',
    days7: '近 7 天',
    days30: '近 30 天',
    days90: '近 90 天',
    avgPrecision: '平均精準度',
    onTargetRate: '達標率',
    dispenseCount: '出料次數',
    precisionTrend: '精準度趨勢（日均）',
    recentDispenses: '最近出料',
    noTrend: '暫無趨勢資料；後端合入後自動展示',
    noRows: '暫無明細',
    colTime: '時間',
    colMaterial: '物料',
    colRecipe: '配方出料',
    colActual: '實際出料',
    colPrecision: '精準度',
    colDelta: '差額',
    totalRecipe: '配方合計',
    totalActual: '實際合計',
    totalDelta: '損耗差額',
    lossRate: '損耗率',
    lossByMaterial: '按物料損耗',
    loadFailedFriendly: '精準度／損耗介面暫不可用（後端未合入或網路異常），頁面已降級為空態。',
    multiMachineReuseTitle: '配料機多機互聯',
    multiMachineReuseBody: '本頁深鏈至既有「多機互聯工作」台，配置飲料機／配料機與泡茶機綁定。',
    openEarlyBrew: '打開多機互聯工作台',
    openInNewTab: '新分頁打開'
  },
  leoAiBill: {
    pageDesc: '美金硬閘只擋雲修單；桌面聊天請看 Cursor 官方 Spending。',
    startPipeline: '開始標準流水線',
    usdCapLine: '月美金上限（只擋雲修單）',
    usdExhausted: '美金已觸頂',
    gateScope: '只擋雲修單 Healer 新開跑；不擋桌面 Cursor 聊天',
    roundsCap: '月輪次上限',
    usdCap: '月美金上限',
    saveCaps: '保存雙帽',
    savedCaps: '已保存輪次上限與美金上限',
    tableTitle: '總賬單（美金＋Token）',
    colSubject: '科目',
    colUsd: '美金',
    colTokens: 'Token',
    colGated: '是否受閘',
    colHint: '說明',
    colAgent: 'Agent',
    gatedYes: '擋雲修單',
    gatedNo: '只展示',
    na: '—',
    tokenNotSecondMoney: 'Token 是同一筆雲 Agent 用量，不是第二筆錢。點行看細項。',
    detailTitle: '雲修單細項',
    desktopHint: '桌面寫碼請看 Cursor 官方 Spending',
    guideStarted: '已開標準流水線',
    guideStartFail: '開流水線失敗'
  },
  x600hAftersales: {
    title: 'X600H 家用售後',
    desc: '換機／退貨／政策 FAQ 進度可查；節點可點、狀態可見。公開條款在購買頁。',
    openTerms: '保固與退貨條款',
    startLine: '開一條線',
    startHint: '也可在 Leo 開口說——同一條 playbook。',
    startReplace: '開始先換新',
    startReturn: '開始 30 天退貨',
    startFaq: '問保固／退貨 FAQ',
    myProcess: '我的進程',
    refresh: '刷新',
    noActive: '暫無進行中的售後線——請上方開線或在 Leo 開口。',
    pleaseDo: '請完成：',
    followPipeline: '請依序完成流水線',
    coachDefault: '藍框＝當前步。點節點可看狀態。',
    openAssist: '打開助手',
    iDidCheck: '我做完了 · 再檢查',
    statusDone: '完成',
    statusCurrent: '進行中',
    statusTodo: '未開始'
  },
  storeHomeFeedTitle: '首頁推薦',
  storeHomeFeedDesc: '人定方向、AI 排版：釘位爆品 + 千人千面馬賽克',
  storeHomeFeedSave: '保存方向',
  storeHomeFeedReload: '刷新',
  storeHomeFeedAnalytics: '效果看板',
  storeHomeFeedTheme: '戰役主題',
  storeHomeFeedMode: '模式',
  storeHomeFeedModeDirection: '方向框內 AI 排',
  storeHomeFeedModeFull: '更開放（仍禁一次塞滿）',
  storeHomeFeedPins: '釘位商品 ID',
  storeHomeFeedBoostCats: '加權品類',
  storeHomeFeedBan: '禁推 ID',
  storeHomeFeedGuarantee: '保量 %',
  storeHomeFeedExplore: '探索 %',
  storeHomeFeedEnabled: '啟用',
  storeHomeFeedIdsHint: '逗號分隔數字 ID',
  storeHomeFeedCatsHint: '如 特調,茶飲',
  storeHomeFeedSaved: '已保存',
  storeHomeFeedImp: '曝光',
  storeHomeFeedClick: '點擊',
  storeHomeFeedAdd: '加購',
  storeHomeFeedPay: '成交',
  storeHomeFeedPipeline: '標準流水線',
  storeHomeFeedStartPipeline: '開始標準流水線',
  storeHomeFeedCheckGuide: '檢查引導',
}


// WEBPACK FOOTER //
// ./src/lang/zh-tw.js